/* eslint-disable */
// tslint:disable
/**
 * StackState API
 * This API documentation page describes the StackState server API. The StackState UI and CLI use the StackState server API to configure and query StackState. 
You can use the API for similar purposes.

Each request sent to the StackState server API must be authenticated using one of the available authentication methods. 

*Note that the StackState receiver API, used to send topology, telemetry and traces to StackState, is not described on this page and requires a different authentication method.*

For more information on StackState, refer to the [StackState documentation](https://docs.stackstate.com).

 *
 * OpenAPI spec version: 5.2.0
 * Contact: info@stackstate.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator+.
 * https://github.com/karlvr/openapi-generator-plus
 * Do not edit the class manually.
 */

export namespace Api {
	export interface AgentData {
		platform: string;
		/**
		 * @type {number}
		 * @memberof AgentData
		 */
		coreCount: number;
		/**
		 * @type {number}
		 * @memberof AgentData
		 */
		memoryBytes: number;
		kernelVersion: string;
	}

	export enum AgentLease {
		Active = 'Active',
		Limited = 'Limited',
		Stale = 'Stale'
	}

	export interface AgentRegistration {
		agentId: string;
		lease: Api.AgentLease;
		/**
		 * @type {number}
		 * @memberof AgentRegistration
		 */
		leaseUntilEpochMs: number;
		/**
		 * @type {number}
		 * @memberof AgentRegistration
		 */
		registeredEpochMs: number;
		agentData?: Api.AgentData;
		/**
		 * @description <p>The number of standard (4CPU, 16Gb) nodes this agent counts for</p>
		 * @type {number}
		 * @memberof AgentRegistration
		 */
		nodeBudgetCount: number;
	}

	export interface AgentRegistrations {
		agents: Api.AgentRegistration[];
	}

	export interface ApiToken {
		/**
		 * @type {number}
		 * @memberof ApiToken
		 */
		readonly id?: number;
		/**
		 * @type {number}
		 * @memberof ApiToken
		 */
		readonly lastUpdateTimestamp?: number;
		name: string;
		description?: string;
		token: string;
	}

	export enum ApplicationDomain {
		Observability = 'Observability',
		Security = 'Security'
	}

	export type Argument = Api.ArgumentBooleanVal | Api.ArgumentComponentTypeRef | Api.ArgumentRelationTypeRef | Api.ArgumentQueryViewRef | Api.ArgumentLongVal | Api.ArgumentStructTypeVal | Api.ArgumentDoubleVal | Api.ArgumentStateVal | Api.ArgumentNodeIdVal | Api.ArgumentDurationVal | Api.ArgumentStringVal | Api.ArgumentTimeWindowVal | Api.ArgumentComparatorWithoutEqualityVal | Api.ArgumentFailingHealthStateVal | Api.ArgumentPromQLMetricVal | Api.ArgumentTopologyQueryVal | Api.ArgumentTopologyPromQLMetricVal;

	export interface ArgumentBooleanVal {
		/**
		 * Value for discriminator in Api.Argument
		 */
		_type: 'ArgumentBooleanVal';
	
		/**
		 * @type {number}
		 * @memberof ArgumentBooleanVal
		 */
		id?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentBooleanVal
		 */
		lastUpdateTimestamp?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentBooleanVal
		 */
		parameter: number;
		value: boolean;
	}
	
	/**
	 * @export
	 * @namespace ArgumentBooleanVal
	 */
	export namespace ArgumentBooleanVal {
		export enum TypeEnum {
			ArgumentBooleanVal = 'ArgumentBooleanVal'
		}
	
	}

	export interface ArgumentComparatorWithoutEqualityVal {
		/**
		 * Value for discriminator in Api.Argument
		 */
		_type: 'ArgumentComparatorWithoutEqualityVal';
	
		/**
		 * @type {number}
		 * @memberof ArgumentComparatorWithoutEqualityVal
		 */
		id?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentComparatorWithoutEqualityVal
		 */
		lastUpdateTimestamp?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentComparatorWithoutEqualityVal
		 */
		parameter: number;
		value: Api.ComparatorWithoutEquality;
	}
	
	/**
	 * @export
	 * @namespace ArgumentComparatorWithoutEqualityVal
	 */
	export namespace ArgumentComparatorWithoutEqualityVal {
		export enum TypeEnum {
			ArgumentComparatorWithoutEqualityVal = 'ArgumentComparatorWithoutEqualityVal'
		}
	
	}

	export interface ArgumentComponentTypeRef {
		/**
		 * Value for discriminator in Api.Argument
		 */
		_type: 'ArgumentComponentTypeRef';
	
		/**
		 * @type {number}
		 * @memberof ArgumentComponentTypeRef
		 */
		id?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentComponentTypeRef
		 */
		lastUpdateTimestamp?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentComponentTypeRef
		 */
		parameter: number;
		/**
		 * @type {number}
		 * @memberof ArgumentComponentTypeRef
		 */
		componentType: number;
	}
	
	/**
	 * @export
	 * @namespace ArgumentComponentTypeRef
	 */
	export namespace ArgumentComponentTypeRef {
		export enum TypeEnum {
			ArgumentComponentTypeRef = 'ArgumentComponentTypeRef'
		}
	
	}

	export interface ArgumentDoubleVal {
		/**
		 * Value for discriminator in Api.Argument
		 */
		_type: 'ArgumentDoubleVal';
	
		/**
		 * @type {number}
		 * @memberof ArgumentDoubleVal
		 */
		id?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentDoubleVal
		 */
		lastUpdateTimestamp?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentDoubleVal
		 */
		parameter: number;
		/**
		 * @type {number}
		 * @memberof ArgumentDoubleVal
		 */
		value: number;
	}
	
	/**
	 * @export
	 * @namespace ArgumentDoubleVal
	 */
	export namespace ArgumentDoubleVal {
		export enum TypeEnum {
			ArgumentDoubleVal = 'ArgumentDoubleVal'
		}
	
	}

	export interface ArgumentDurationVal {
		/**
		 * Value for discriminator in Api.Argument
		 */
		_type: 'ArgumentDurationVal';
	
		/**
		 * @type {number}
		 * @memberof ArgumentDurationVal
		 */
		id?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentDurationVal
		 */
		lastUpdateTimestamp?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentDurationVal
		 */
		parameter: number;
		/**
		 * @type {number}
		 * @memberof ArgumentDurationVal
		 */
		value: number;
	}
	
	/**
	 * @export
	 * @namespace ArgumentDurationVal
	 */
	export namespace ArgumentDurationVal {
		export enum TypeEnum {
			ArgumentDurationVal = 'ArgumentDurationVal'
		}
	
	}

	export interface ArgumentFailingHealthStateVal {
		/**
		 * Value for discriminator in Api.Argument
		 */
		_type: 'ArgumentFailingHealthStateVal';
	
		/**
		 * @type {number}
		 * @memberof ArgumentFailingHealthStateVal
		 */
		id?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentFailingHealthStateVal
		 */
		lastUpdateTimestamp?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentFailingHealthStateVal
		 */
		parameter: number;
		value: Api.FailingHealthStateValue;
	}
	
	/**
	 * @export
	 * @namespace ArgumentFailingHealthStateVal
	 */
	export namespace ArgumentFailingHealthStateVal {
		export enum TypeEnum {
			ArgumentFailingHealthStateVal = 'ArgumentFailingHealthStateVal'
		}
	
	}

	export interface ArgumentLongVal {
		/**
		 * Value for discriminator in Api.Argument
		 */
		_type: 'ArgumentLongVal';
	
		/**
		 * @type {number}
		 * @memberof ArgumentLongVal
		 */
		id?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentLongVal
		 */
		lastUpdateTimestamp?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentLongVal
		 */
		parameter: number;
		/**
		 * @type {number}
		 * @memberof ArgumentLongVal
		 */
		value: number;
	}
	
	/**
	 * @export
	 * @namespace ArgumentLongVal
	 */
	export namespace ArgumentLongVal {
		export enum TypeEnum {
			ArgumentLongVal = 'ArgumentLongVal'
		}
	
	}

	export interface ArgumentNodeIdVal {
		/**
		 * Value for discriminator in Api.Argument
		 */
		_type: 'ArgumentNodeIdVal';
	
		/**
		 * @type {number}
		 * @memberof ArgumentNodeIdVal
		 */
		id?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentNodeIdVal
		 */
		lastUpdateTimestamp?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentNodeIdVal
		 */
		parameter: number;
		/**
		 * @type {number}
		 * @memberof ArgumentNodeIdVal
		 */
		value: number;
	}
	
	/**
	 * @export
	 * @namespace ArgumentNodeIdVal
	 */
	export namespace ArgumentNodeIdVal {
		export enum TypeEnum {
			ArgumentNodeIdVal = 'ArgumentNodeIdVal'
		}
	
	}

	export interface ArgumentPromQLMetricVal {
		/**
		 * Value for discriminator in Api.Argument
		 */
		_type: 'ArgumentPromQLMetricVal';
	
		/**
		 * @type {number}
		 * @memberof ArgumentPromQLMetricVal
		 */
		id?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentPromQLMetricVal
		 */
		lastUpdateTimestamp?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentPromQLMetricVal
		 */
		parameter: number;
		value: Api.PromQLMetric;
	}
	
	/**
	 * @export
	 * @namespace ArgumentPromQLMetricVal
	 */
	export namespace ArgumentPromQLMetricVal {
		export enum TypeEnum {
			ArgumentPromQLMetricVal = 'ArgumentPromQLMetricVal'
		}
	
	}

	export interface ArgumentQueryViewRef {
		/**
		 * Value for discriminator in Api.Argument
		 */
		_type: 'ArgumentQueryViewRef';
	
		/**
		 * @type {number}
		 * @memberof ArgumentQueryViewRef
		 */
		id?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentQueryViewRef
		 */
		lastUpdateTimestamp?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentQueryViewRef
		 */
		parameter: number;
		/**
		 * @type {number}
		 * @memberof ArgumentQueryViewRef
		 */
		queryView: number;
	}
	
	/**
	 * @export
	 * @namespace ArgumentQueryViewRef
	 */
	export namespace ArgumentQueryViewRef {
		export enum TypeEnum {
			ArgumentQueryViewRef = 'ArgumentQueryViewRef'
		}
	
	}

	export interface ArgumentRelationTypeRef {
		/**
		 * Value for discriminator in Api.Argument
		 */
		_type: 'ArgumentRelationTypeRef';
	
		/**
		 * @type {number}
		 * @memberof ArgumentRelationTypeRef
		 */
		id?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentRelationTypeRef
		 */
		lastUpdateTimestamp?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentRelationTypeRef
		 */
		parameter: number;
		/**
		 * @type {number}
		 * @memberof ArgumentRelationTypeRef
		 */
		relationType: number;
	}
	
	/**
	 * @export
	 * @namespace ArgumentRelationTypeRef
	 */
	export namespace ArgumentRelationTypeRef {
		export enum TypeEnum {
			ArgumentRelationTypeRef = 'ArgumentRelationTypeRef'
		}
	
	}

	export interface ArgumentStateVal {
		/**
		 * Value for discriminator in Api.Argument
		 */
		_type: 'ArgumentStateVal';
	
		/**
		 * @type {number}
		 * @memberof ArgumentStateVal
		 */
		id?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentStateVal
		 */
		lastUpdateTimestamp?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentStateVal
		 */
		parameter: number;
		value: Api.HealthStateValue;
	}
	
	/**
	 * @export
	 * @namespace ArgumentStateVal
	 */
	export namespace ArgumentStateVal {
		export enum TypeEnum {
			ArgumentStateVal = 'ArgumentStateVal'
		}
	
	}

	export interface ArgumentStringVal {
		/**
		 * Value for discriminator in Api.Argument
		 */
		_type: 'ArgumentStringVal';
	
		/**
		 * @type {number}
		 * @memberof ArgumentStringVal
		 */
		id?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentStringVal
		 */
		lastUpdateTimestamp?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentStringVal
		 */
		parameter: number;
		value: string;
	}
	
	/**
	 * @export
	 * @namespace ArgumentStringVal
	 */
	export namespace ArgumentStringVal {
		export enum TypeEnum {
			ArgumentStringVal = 'ArgumentStringVal'
		}
	
	}

	export interface ArgumentStructTypeVal {
		/**
		 * Value for discriminator in Api.Argument
		 */
		_type: 'ArgumentStructTypeVal';
	
		/**
		 * @type {number}
		 * @memberof ArgumentStructTypeVal
		 */
		id?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentStructTypeVal
		 */
		lastUpdateTimestamp?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentStructTypeVal
		 */
		parameter: number;
		value: string;
	}
	
	/**
	 * @export
	 * @namespace ArgumentStructTypeVal
	 */
	export namespace ArgumentStructTypeVal {
		export enum TypeEnum {
			ArgumentStructTypeVal = 'ArgumentStructTypeVal'
		}
	
	}

	export interface ArgumentTimeWindowVal {
		/**
		 * Value for discriminator in Api.Argument
		 */
		_type: 'ArgumentTimeWindowVal';
	
		/**
		 * @type {number}
		 * @memberof ArgumentTimeWindowVal
		 */
		id?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentTimeWindowVal
		 */
		lastUpdateTimestamp?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentTimeWindowVal
		 */
		parameter: number;
		/**
		 * @type {number}
		 * @memberof ArgumentTimeWindowVal
		 * minimum: 0
		 */
		valueMs: number;
	}
	
	/**
	 * @export
	 * @namespace ArgumentTimeWindowVal
	 */
	export namespace ArgumentTimeWindowVal {
		export enum TypeEnum {
			ArgumentTimeWindowVal = 'ArgumentTimeWindowVal'
		}
	
	}

	export interface ArgumentTopologyPromQLMetricVal {
		/**
		 * Value for discriminator in Api.Argument
		 */
		_type: 'ArgumentTopologyPromQLMetricVal';
	
		/**
		 * @type {number}
		 * @memberof ArgumentTopologyPromQLMetricVal
		 */
		id?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentTopologyPromQLMetricVal
		 */
		lastUpdateTimestamp?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentTopologyPromQLMetricVal
		 */
		parameter: number;
		value: Api.TopologyPromQLMetric;
	}
	
	/**
	 * @export
	 * @namespace ArgumentTopologyPromQLMetricVal
	 */
	export namespace ArgumentTopologyPromQLMetricVal {
		export enum TypeEnum {
			ArgumentTopologyPromQLMetricVal = 'ArgumentTopologyPromQLMetricVal'
		}
	
	}

	export interface ArgumentTopologyQueryVal {
		/**
		 * Value for discriminator in Api.Argument
		 */
		_type: 'ArgumentTopologyQueryVal';
	
		/**
		 * @type {number}
		 * @memberof ArgumentTopologyQueryVal
		 */
		id?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentTopologyQueryVal
		 */
		lastUpdateTimestamp?: number;
		/**
		 * @type {number}
		 * @memberof ArgumentTopologyQueryVal
		 */
		parameter: number;
		query: string;
	}
	
	/**
	 * @export
	 * @namespace ArgumentTopologyQueryVal
	 */
	export namespace ArgumentTopologyQueryVal {
		export enum TypeEnum {
			ArgumentTopologyQueryVal = 'ArgumentTopologyQueryVal'
		}
	
	}

	export interface BarChart {
		/**
		 * Value for discriminator in Api.Chart
		 */
		_type: 'BarChart';
	
		unit?: string;
		/**
		 * @type {number}
		 * @memberof BarChart
		 */
		decimals?: number;
		/**
		 * @type {number}
		 * @memberof BarChart
		 */
		min?: number;
		/**
		 * @type {number}
		 * @memberof BarChart
		 */
		max?: number;
		thresholds?: Api.ChartThresholds;
	}
	
	/**
	 * @export
	 * @namespace BarChart
	 */
	export namespace BarChart {
		export enum TypeEnum {
			BarChart = 'BarChart'
		}
	
	}

	export interface BaseComponentField {
		fieldId: string;
		title: string;
		description?: string;
	}

	export interface BaseMonitorError {
		monitorId?: string;
		monitorIdType?: Api.BaseMonitorError.MonitorIdTypeEnum;
	}
	
	/**
	 * @export
	 * @namespace BaseMonitorError
	 */
	export namespace BaseMonitorError {
		export enum MonitorIdTypeEnum {
			Id = 'id',
			Urn = 'urn'
		}
	
	}

	export interface BaseNotificationChannel {
		/**
		 * @type {number}
		 * @memberof BaseNotificationChannel
		 */
		id: number;
		/**
		 * @type {number}
		 * @memberof BaseNotificationChannel
		 */
		notificationConfigurationId?: number;
		status: Api.NotificationChannelStatus;
	}

	export interface BoundMetric {
		boundMetricId?: Api.BoundMetricId;
		name: string;
		boundQueries: Api.BoundMetricQuery[];
		description?: string;
		chart?: Api.Chart;
		dummy?: boolean;
	}

	export interface BoundMetricBindingId {
		/**
		 * Value for discriminator in Api.BoundMetricId
		 */
		_type: 'BoundMetricBindingId';
	
		identifier: string;
	}
	
	/**
	 * @export
	 * @namespace BoundMetricBindingId
	 */
	export namespace BoundMetricBindingId {
		export enum TypeEnum {
			BoundMetricBindingId = 'BoundMetricBindingId'
		}
	
	}

	export type BoundMetricId = Api.BoundMetricBindingId | Api.BoundPresentationMetricId;

	export interface BoundMetricQuery {
		expression: string;
		alias: string;
		componentIdentifierTemplate?: string;
		primary?: boolean;
	}

	export interface BoundPresentationMetricId {
		/**
		 * Value for discriminator in Api.BoundMetricId
		 */
		_type: 'BoundPresentationMetricId';
	
		presentationIdentifier?: string;
		metricId: string;
	}
	
	/**
	 * @export
	 * @namespace BoundPresentationMetricId
	 */
	export namespace BoundPresentationMetricId {
		export enum TypeEnum {
			BoundPresentationMetricId = 'BoundPresentationMetricId'
		}
	
	}

	export interface BoundSummaryMetric {
		boundMetricId?: Api.BoundMetricId;
		name: string;
		query: string;
		unit?: string;
		/**
		 * @type {number}
		 * @memberof BoundSummaryMetric
		 */
		decimalPlaces?: number;
		dummy?: boolean;
	}

	export interface BoundTraces {
		filter: Api.SpanFilter;
	}

	export interface CausingEventsAreNotAvailableForTheTime {
		/**
		 * Value for discriminator in Api.GetCausingEventsResult
		 */
		_type: 'CausingEventsAreNotAvailableForTheTime';
	
	  // OpenAPI `type: object` without properties
	  [name: string]: unknown
	}
	
	/**
	 * @export
	 * @namespace CausingEventsAreNotAvailableForTheTime
	 */
	export namespace CausingEventsAreNotAvailableForTheTime {
		export enum TypeEnum {
			CausingEventsAreNotAvailableForTheTime = 'CausingEventsAreNotAvailableForTheTime'
		}
	
	}

	export interface CausingEventsResult {
		/**
		 * Value for discriminator in Api.GetCausingEventsResult
		 */
		_type: 'CausingEventsResult';
	
		items: Api.TopologyEvent[];
	}
	
	/**
	 * @export
	 * @namespace CausingEventsResult
	 */
	export namespace CausingEventsResult {
		export enum TypeEnum {
			CausingEventsResult = 'CausingEventsResult'
		}
	
	}

	export type CellValue = Api.MetricCell | Api.LinkCell | Api.ComponentLinkCell | Api.HealthCell | Api.TextCell | Api.NumericCell | Api.DurationCell | Api.ReadyStatusCell;

	export type ChannelReferenceId = Api.SlackChannelRefId | Api.WebhookChannelRefId | Api.OpsgenieChannelRefId | Api.TeamsChannelRefId | Api.EmailChannelRefId;

	export type Chart = Api.TimeSeriesChart | Api.GaugeChart | Api.BarChart | Api.StatChart;

	export enum ChartCalculation {
		Mean = 'mean',
		Sum = 'sum',
		Min = 'min',
		Max = 'max',
		First = 'first',
		FirstNumber = 'first-number',
		Last = 'last',
		LastNumber = 'last-number'
	}

	export interface ChartStatThresholds {
		defaultColor?: string;
		steps: Api.ChartThresholdStep[];
	}

	export interface ChartThresholds {
		mode?: Api.ChartThresholds.ModeEnum;
		defaultColor?: string;
		steps: Api.ChartThresholdStep[];
	}
	
	/**
	 * @export
	 * @namespace ChartThresholds
	 */
	export namespace ChartThresholds {
		export enum ModeEnum {
			Absolute = 'absolute',
			Percent = 'percent'
		}
	
	}

	export interface ChartThresholdStep {
		/**
		 * @type {number}
		 * @memberof ChartThresholdStep
		 */
		value: number;
		color?: string;
	}

	export interface CheckLeaseRequest {
		apiKey: string;
		agentData?: Api.AgentData;
	}

	export enum ComparatorWithoutEquality {
		GTE = 'GTE',
		GT = 'GT',
		LT = 'LT',
		LTE = 'LTE'
	}

	export interface ComponentAction {
		/**
		 * @type {number}
		 * @memberof ComponentAction
		 */
		id: number;
		name: string;
		description?: string;
	}

	export interface ComponentCheckState {
		identifier: string;
		idOrIdentifier: string;
		/**
		 * @type {number}
		 * @memberof ComponentCheckState
		 */
		startTime: number;
		/**
		 * @type {number}
		 * @memberof ComponentCheckState
		 */
		endTime: number;
	}

	export interface ComponentCheckStates {
		checkStates: Api.ComponentCheckState[];
	}

	export interface ComponentData {
		/**
		 * @type {number}
		 * @memberof ComponentData
		 */
		id?: number;
		identifiers?: string[];
		name: string;
		description?: string;
		version?: string;
		tags: string[];
		properties: { [name: string]: string };
		layerName?: string;
		domainName?: string;
		health?: Api.HealthStateValue;
		/**
		 * @type {number}
		 * @memberof ComponentData
		 */
		lastUpdateTimestamp?: number;
	}

	export interface ComponentEvents {
		showEvents: boolean;
		/**
		 * @description <p>Topology query for resources related to the highlighted component</p>
		 * @type {string}
		 * @memberof ComponentEvents
		 */
		relatedResourcesQuery?: string;
	}

	export type ComponentField = Api.ErrorField | Api.MetricField | Api.LinkField | Api.ComponentLinkField | Api.HealthField | Api.TextField | Api.NumericField | Api.DurationField | Api.RatioField | Api.MapField | Api.TagField;

	export interface ComponentHealthChange {
		/**
		 * @type {number}
		 * @memberof ComponentHealthChange
		 */
		timestamp: number;
		newHealth: Api.HealthStateValue;
	}

	export interface ComponentHealthHistory {
		/**
		 * @type {number}
		 * @memberof ComponentHealthHistory
		 */
		startTime: number;
		/**
		 * @type {number}
		 * @memberof ComponentHealthHistory
		 */
		endTime: number;
		/**
		 * @description <p>List of health state changes ordered from most recent to oldest.</p>
		 * @type {Api.ComponentHealthChange[]}
		 * @memberof ComponentHealthHistory
		 */
		healthStateChanges: Api.ComponentHealthChange[];
	}

	export type ComponentHighlightProjection = Api.HealthProjection | Api.MetricProjection | Api.ComponentLinkProjection | Api.TextProjection | Api.NumericProjection | Api.DurationProjection | Api.RatioProjection | Api.ContainerImageProjection | Api.MapProjection | Api.TagProjection;

	export interface ComponentLink {
		name: string;
		componentId: string;
	}

	export interface ComponentLinkCell {
		/**
		 * Value for discriminator in Api.CellValue
		 */
		_type: 'ComponentLinkCell';
	
		component?: Api.ComponentLink;
	}
	
	/**
	 * @export
	 * @namespace ComponentLinkCell
	 */
	export namespace ComponentLinkCell {
		export enum TypeEnum {
			ComponentLinkCell = 'ComponentLinkCell'
		}
	
	}

	export interface ComponentLinkField extends Api.BaseComponentField {
		/**
		 * Value for discriminator in Api.ComponentField
		 */
		_type: 'ComponentLinkField';
	
		name: string;
		identifier: string;
	}
	
	/**
	 * @export
	 * @namespace ComponentLinkField
	 */
	export namespace ComponentLinkField {
		export enum TypeEnum {
			ComponentLinkField = 'ComponentLinkField'
		}
	
	}

	export interface ComponentLinkMetaDisplay {
		/**
		 * Value for discriminator in Api.OverviewColumnMetaDisplay
		 */
		_type: 'ComponentLinkMetaDisplay';
	
	  // OpenAPI `type: object` without properties
	  [name: string]: unknown
	}
	
	/**
	 * @export
	 * @namespace ComponentLinkMetaDisplay
	 */
	export namespace ComponentLinkMetaDisplay {
		export enum TypeEnum {
			ComponentLinkMetaDisplay = 'ComponentLinkMetaDisplay'
		}
	
	}

	export interface ComponentLinkProjection {
		/**
		 * Value for discriminator in Api.ComponentOverviewProjection
		 */
		_type: 'ComponentLinkProjection';
	
		/**
		 * @description <p>Cel expression that returns a string that represents the name of the component to link to</p>
		 * @type {string}
		 * @memberof ComponentLinkProjection
		 */
		name: string;
		/**
		 * @description <p>Cel expression that returns a string that represents the identifier in order to build the link</p>
		 * @type {string}
		 * @memberof ComponentLinkProjection
		 */
		identifier: string;
	}
	
	/**
	 * @export
	 * @namespace ComponentLinkProjection
	 */
	export namespace ComponentLinkProjection {
		export enum TypeEnum {
			ComponentLinkProjection = 'ComponentLinkProjection'
		}
	
	}

	export interface ComponentMetricSection {
		sectionId: string;
		title: string;
		description?: string;
		metrics: Api.BoundMetric[];
		defaultExpanded: boolean;
	}

	export interface ComponentMetricTab {
		tabId: string;
		title: string;
		sections: Api.ComponentMetricSection[];
	}

	export type ComponentOverviewProjection = Api.HealthProjection | Api.MetricProjection | Api.ComponentLinkProjection | Api.TextProjection | Api.NumericProjection | Api.DurationProjection | Api.RatioProjection | Api.ContainerImageProjection;

	export interface ComponentPresentation {
		identifier: string;
		name: string;
		description?: string;
		binding: Api.ComponentPresentationQueryBinding;
		rank?: Api.ComponentPresentationRank;
		/**
		 * @description <p>Component presentation definition.
		 *  If multiple ComponentPresentations match, <code>filters</code> are merged by filter identity with the most specific presentation winning.
		 *  Scalar fields like <code>icon</code> and <code>topology</code> follow most-specific-wins semantics across matching presentations.
		 *  Absence of <code>topology</code> means the Topology perspective is not available for this presentation.
		 *  Absence of the field keeps legacy behavior (for example, ViewType-based filters) unchanged.</p>
		 * @type {Api.PresentationDefinition}
		 * @memberof ComponentPresentation
		 */
		presentation: Api.PresentationDefinition;
	}

	export interface ComponentPresentationApiError {
		message: string;
	}

	/**
	 * <p>Filter definition for ComponentPresentation.
	 * When only <code>filterId</code> is provided, the filter references a definition from a less specific presentation.
	 * Merge semantics for matching ComponentPresentations:</p>
	 * <ol>
	 * <li>The most specific matching ComponentPresentation&#39;s filter list determines which <code>filterId</code>s are active.
	 * Only filters whose <code>filterId</code> appears in that list are rendered.</li>
	 * <li>For each active <code>filterId</code>, scalar fields (<code>displayName</code>, <code>menuSection</code>, <code>filter</code>, etc.) are resolved by
	 * falling back through less specific presentations that define the same <code>filterId</code>, most specific value wins.</li>
	 * <li>Array position determines display order: earlier items are primary (filter bar),
	 * later items are secondary (&quot;More&quot; section).</li>
	 * </ol>
	 */
	export interface ComponentPresentationFilter {
		/**
		 * @description <p>Stable identity used for deduplication and cross-stackpack compatibility.</p>
		 * @type {string}
		 * @memberof ComponentPresentationFilter
		 */
		filterId: string;
		displayName?: Api.FilterName;
		/**
		 * @description <p>Label to group filters in the UI.</p>
		 * @type {string}
		 * @memberof ComponentPresentationFilter
		 */
		menuSection?: string;
		filter?: Api.ComponentPresentationFilterDefinition;
	}

	export type ComponentPresentationFilterDefinition = Api.TagFilter;

	export type ComponentPresentationLink = Api.ResolvedComponentPresentationLink | Api.ErrorComponentPresentationLink;

	export interface ComponentPresentationMetric {
		metricId: string;
		name?: string;
		description?: string;
		metricQueries?: Api.PresentationMetricQuery[];
		chart?: Api.Chart;
	}

	export interface ComponentPresentationQueryBinding {
		/**
		 * @description <p>Stq query that defines to which components does the presentation applies to.</p>
		 * @type {string}
		 * @memberof ComponentPresentationQueryBinding
		 */
		query: string;
	}

	export interface ComponentPresentationRank {
		/**
		 * @description <p>Determines how much of a &quot;specialization&quot; this presentation is. Higher number means more specific. This is used to determine which presentation to use when multiple presentations match.</p>
		 * @type {number}
		 * @memberof ComponentPresentationRank
		 */
		specificity: number;
	}

	export interface ComponentProvisioning {
		showConfiguration: boolean;
		showStatus: boolean;
		externalId: string;
	}

	export interface ComponentQuery {
		/**
		 * @description <p>Attributes (key/value pairs) describing the resource for the span.</p>
		 * @type {{ [name: string]: string }}
		 * @memberof ComponentQuery
		 */
		resourceAttributes: { [name: string]: string };
		/**
		 * @description <p>Attributes (key/value pairs) from the span itself.</p>
		 * @type {{ [name: string]: string }}
		 * @memberof ComponentQuery
		 */
		spanAttributes?: { [name: string]: string };
		/**
		 * @description <p>A description of the span&#39;s operation. For example, the name can be a qualified method name or a file name and a line number where the operation is called</p>
		 * @type {string}
		 * @memberof ComponentQuery
		 */
		spanName?: string;
		/**
		 * @description <p>The type of span. Distinguishes between spans generated in a particular context.</p>
		 * @type {Api.SpanKind}
		 * @memberof ComponentQuery
		 */
		spanKind?: Api.SpanKind;
		/**
		 * @description <p>The status of the operation for the span</p>
		 * @type {Api.SpanStatusCode}
		 * @memberof ComponentQuery
		 */
		statusCode?: Api.SpanStatusCode;
		/**
		 * @description <p>Human readable message for the status</p>
		 * @type {string}
		 * @memberof ComponentQuery
		 */
		statusMessage?: string;
		/**
		 * @description <p>The name of the instrumentation scope for the span <a href="https://opentelemetry.io/docs/specs/otel/glossary/#instrumentation-scope">https://opentelemetry.io/docs/specs/otel/glossary/#instrumentation-scope</a></p>
		 * @type {string}
		 * @memberof ComponentQuery
		 */
		scopeName?: string;
		/**
		 * @description <p>The version for the instrumentation scope for the span <a href="https://opentelemetry.io/docs/specs/otel/glossary/#instrumentation-scope">https://opentelemetry.io/docs/specs/otel/glossary/#instrumentation-scope</a></p>
		 * @type {string}
		 * @memberof ComponentQuery
		 */
		scopeVersion?: string;
		/**
		 * @description <p>Date/time representation in milliseconds since epoch (1970-01-01 00:00:00)</p>
		 * @type {number}
		 * @memberof ComponentQuery
		 */
		instant?: number;
	}

	export interface ComponentSummary {
		metrics: Api.BoundSummaryMetric[];
	}

	export interface ComponentViewArguments {
		/**
		 * Value for discriminator in Api.TimelineSummaryRequest.Arguments
		 */
		_type: 'ComponentViewArguments';
	
		componentIdentifier: string;
		/**
		 * @description <p>Date/time representation in milliseconds since epoch (1970-01-01 00:00:00)</p>
		 * @type {number}
		 * @memberof ComponentViewArguments
		 */
		queryTime?: number;
	}
	
	/**
	 * @export
	 * @namespace ComponentViewArguments
	 */
	export namespace ComponentViewArguments {
		export enum TypeEnum {
			ComponentViewArguments = 'ComponentViewArguments'
		}
	
	}

	/**
	 * <p>Helps rendering links for docker images</p>
	 */
	export interface ContainerImageProjection {
		/**
		 * Value for discriminator in Api.ComponentOverviewProjection
		 */
		_type: 'ContainerImageProjection';
	
		/**
		 * @description <p>Cel expression that returns a string</p>
		 * @type {string}
		 * @memberof ContainerImageProjection
		 */
		imageId: string;
		/**
		 * @description <p>Cel expression that returns a string</p>
		 * @type {string}
		 * @memberof ContainerImageProjection
		 */
		imageName: string;
	}
	
	/**
	 * @export
	 * @namespace ContainerImageProjection
	 */
	export namespace ContainerImageProjection {
		export enum TypeEnum {
			ContainerImageProjection = 'ContainerImageProjection'
		}
	
	}

	/**
	 * <p>Request body for creating a silencing rule</p>
	 */
	export interface CreateSilencingRule {
		/**
		 * @description <p>Human-readable reason for the silencing rule.</p>
		 * @type {string}
		 * @memberof CreateSilencingRule
		 */
		note: string;
		/**
		 * @description <p>Unix epoch (seconds) at which this silencing rule expires. Maximum is 6 hours from now.</p>
		 * @type {number}
		 * @memberof CreateSilencingRule
		 */
		expiryEpochSeconds?: number;
		/**
		 * @description <p>Selects what to silence. Discriminated by <code>type</code> to allow future selector variants.</p>
		 * @type {Api.SilencingRuleSelector}
		 * @memberof CreateSilencingRule
		 */
		selector: Api.SilencingRuleSelector;
	}

	export interface CreateSubject {
		query?: string;
		version?: string;
	}

	export interface DashboardAuthorizationError {
		/**
		 * @description <p>A detailed error message describing why the operation failed.</p>
		 * @type {string}
		 * @memberof DashboardAuthorizationError
		 */
		message: string;
		dashboardIdOrUrn: string;
		userName: string;
	}

	export type DashboardClientErrors = Api.DashboardInvalidIdentifierError | Api.DashboardValidationError;

	/**
	 * <p>The provided fields are used to override the corresponding fields of the new (cloned) dashboard.</p>
	 */
	export interface DashboardCloneSchema {
		/**
		 * @description <p>Name of the dashboard. Required to make it easier so see which dashboard is the new (cloned) dashboard.</p>
		 * @type {string}
		 * @memberof DashboardCloneSchema
		 */
		name: string;
		/**
		 * @description <p>Description of the dashboard</p>
		 * @type {string}
		 * @memberof DashboardCloneSchema
		 */
		description?: string;
		/**
		 * @description <p>Scope of the dashboard. &#39;publicDashboard&#39; for accessible by everyone, &#39;privateDashboard&#39; for owned and accessible by the current user.</p>
		 * @type {Api.DashboardScope}
		 * @memberof DashboardCloneSchema
		 */
		scope?: Api.DashboardScope;
		dashboard?: Api.PersesDashboard;
	}

	export interface DashboardInvalidIdentifierError {
		/**
		 * Value for discriminator in Api.DashboardClientErrors
		 */
		_type: 'DashboardInvalidIdentifierError';
	
		/**
		 * @description <p>A detailed error message describing why the operation failed.</p>
		 * @type {string}
		 * @memberof DashboardInvalidIdentifierError
		 */
		message: string;
		dashboardIdOrUrn: string;
	}
	
	/**
	 * @export
	 * @namespace DashboardInvalidIdentifierError
	 */
	export namespace DashboardInvalidIdentifierError {
		export enum TypeEnum {
			DashboardInvalidIdentifierError = 'DashboardInvalidIdentifierError'
		}
	
	}

	export interface DashboardList {
		/**
		 * @description <p>List of dashboards, which can be either metadata or full representations.</p>
		 * @type {Api.DashboardReadSchema[]}
		 * @memberof DashboardList
		 */
		dashboards: Api.DashboardReadSchema[];
	}

	export interface DashboardNotFoundError {
		/**
		 * @description <p>A detailed error message describing why the operation failed.</p>
		 * @type {string}
		 * @memberof DashboardNotFoundError
		 */
		message: string;
		dashboardIdOrUrn: string;
	}

	/**
	 * <p>The provided fields are used to patch the corresponding fields of a dashboard.</p>
	 */
	export interface DashboardPatchSchema {
		/**
		 * @description <p>Name of the dashboard</p>
		 * @type {string}
		 * @memberof DashboardPatchSchema
		 */
		name?: string;
		/**
		 * @description <p>Description of the dashboard</p>
		 * @type {string}
		 * @memberof DashboardPatchSchema
		 */
		description?: string;
		/**
		 * @description <p>Scope of the dashboard. &#39;publicDashboard&#39; for accessible by everyone, &#39;privateDashboard&#39; for owned and accessible by the current user.</p>
		 * @type {Api.DashboardScope}
		 * @memberof DashboardPatchSchema
		 */
		scope?: Api.DashboardScope;
		dashboard?: Api.PersesDashboard;
	}

	export interface DashboardReadBaseSchema {
		_type: string;
		/**
		 * @description <p>The identifier of a dashboard. Either the system/graph ID or URN of the resource.</p>
		 * @type {string}
		 * @memberof DashboardReadBaseSchema
		 */
		identifier: string;
		/**
		 * @type {number}
		 * @memberof DashboardReadBaseSchema
		 */
		id: number;
		/**
		 * @description <p>Name of the dashboard</p>
		 * @type {string}
		 * @memberof DashboardReadBaseSchema
		 */
		name: string;
		/**
		 * @description <p>Description of the dashboard</p>
		 * @type {string}
		 * @memberof DashboardReadBaseSchema
		 */
		description: string;
		/**
		 * @description <p>Scope of the dashboard. &#39;publicDashboard&#39; for accessible by everyone, &#39;privateDashboard&#39; for owned and accessible by the current user.</p>
		 * @type {Api.DashboardScope}
		 * @memberof DashboardReadBaseSchema
		 */
		scope: Api.DashboardScope;
		/**
		 * @description <p>The user id of the dashboard owner. A dashboard was either created by a user or from a StackPack. For a user, the identifier will be the system/graph ID, and for a StackPack, the field will be empty/omitted.</p>
		 * @type {number}
		 * @memberof DashboardReadBaseSchema
		 */
		ownerId?: number;
		/**
		 * @type {number}
		 * @memberof DashboardReadBaseSchema
		 */
		lastUpdateTimestamp: number;
	}

	export interface DashboardReadFullSchema {
		/**
		 * Value for discriminator in Api.DashboardReadSchema
		 */
		_type: 'DashboardReadFullSchema';
	
		/**
		 * @description <p>The identifier of a dashboard. Either the system/graph ID or URN of the resource.</p>
		 * @type {string}
		 * @memberof DashboardReadFullSchema
		 */
		identifier: string;
		/**
		 * @type {number}
		 * @memberof DashboardReadFullSchema
		 */
		id: number;
		/**
		 * @description <p>Name of the dashboard</p>
		 * @type {string}
		 * @memberof DashboardReadFullSchema
		 */
		name: string;
		/**
		 * @description <p>Description of the dashboard</p>
		 * @type {string}
		 * @memberof DashboardReadFullSchema
		 */
		description: string;
		/**
		 * @description <p>Scope of the dashboard. &#39;publicDashboard&#39; for accessible by everyone, &#39;privateDashboard&#39; for owned and accessible by the current user.</p>
		 * @type {Api.DashboardScope}
		 * @memberof DashboardReadFullSchema
		 */
		scope: Api.DashboardScope;
		/**
		 * @description <p>The user id of the dashboard owner. A dashboard was either created by a user or from a StackPack. For a user, the identifier will be the system/graph ID, and for a StackPack, the field will be empty/omitted.</p>
		 * @type {number}
		 * @memberof DashboardReadFullSchema
		 */
		ownerId?: number;
		/**
		 * @type {number}
		 * @memberof DashboardReadFullSchema
		 */
		lastUpdateTimestamp: number;
		dashboard: Api.PersesDashboard;
	}
	
	/**
	 * @export
	 * @namespace DashboardReadFullSchema
	 */
	export namespace DashboardReadFullSchema {
		export enum TypeEnum {
			DashboardReadFullSchema = 'DashboardReadFullSchema'
		}
	
	}

	export interface DashboardReadMetadataSchema {
		/**
		 * Value for discriminator in Api.DashboardReadSchema
		 */
		_type: 'DashboardReadMetadataSchema';
	
		/**
		 * @description <p>The identifier of a dashboard. Either the system/graph ID or URN of the resource.</p>
		 * @type {string}
		 * @memberof DashboardReadMetadataSchema
		 */
		identifier: string;
		/**
		 * @type {number}
		 * @memberof DashboardReadMetadataSchema
		 */
		id: number;
		/**
		 * @description <p>Name of the dashboard</p>
		 * @type {string}
		 * @memberof DashboardReadMetadataSchema
		 */
		name: string;
		/**
		 * @description <p>Description of the dashboard</p>
		 * @type {string}
		 * @memberof DashboardReadMetadataSchema
		 */
		description: string;
		/**
		 * @description <p>Scope of the dashboard. &#39;publicDashboard&#39; for accessible by everyone, &#39;privateDashboard&#39; for owned and accessible by the current user.</p>
		 * @type {Api.DashboardScope}
		 * @memberof DashboardReadMetadataSchema
		 */
		scope: Api.DashboardScope;
		/**
		 * @description <p>The user id of the dashboard owner. A dashboard was either created by a user or from a StackPack. For a user, the identifier will be the system/graph ID, and for a StackPack, the field will be empty/omitted.</p>
		 * @type {number}
		 * @memberof DashboardReadMetadataSchema
		 */
		ownerId?: number;
		/**
		 * @type {number}
		 * @memberof DashboardReadMetadataSchema
		 */
		lastUpdateTimestamp: number;
	}
	
	/**
	 * @export
	 * @namespace DashboardReadMetadataSchema
	 */
	export namespace DashboardReadMetadataSchema {
		export enum TypeEnum {
			DashboardReadMetadataSchema = 'DashboardReadMetadataSchema'
		}
	
	}

	export type DashboardReadSchema = Api.DashboardReadMetadataSchema | Api.DashboardReadFullSchema;

	/**
	 * <p>Scope of the dashboard. &#39;publicDashboard&#39; for accessible by everyone, &#39;privateDashboard&#39; for owned and accessible by the current user.</p>
	 */
	export enum DashboardScope {
		PublicDashboard = 'publicDashboard',
		PrivateDashboard = 'privateDashboard'
	}

	export interface DashboardValidationError {
		/**
		 * Value for discriminator in Api.DashboardClientErrors
		 */
		_type: 'DashboardValidationError';
	
		/**
		 * @description <p>A detailed error message describing why the operation failed.</p>
		 * @type {string}
		 * @memberof DashboardValidationError
		 */
		message: string;
	}
	
	/**
	 * @export
	 * @namespace DashboardValidationError
	 */
	export namespace DashboardValidationError {
		export enum TypeEnum {
			DashboardValidationError = 'DashboardValidationError'
		}
	
	}

	export interface DashboardWriteSchema {
		/**
		 * @description <p>Name of the dashboard</p>
		 * @type {string}
		 * @memberof DashboardWriteSchema
		 */
		name: string;
		/**
		 * @description <p>Description of the dashboard</p>
		 * @type {string}
		 * @memberof DashboardWriteSchema
		 */
		description: string;
		/**
		 * @description <p>Scope of the dashboard. &#39;publicDashboard&#39; for accessible by everyone, &#39;privateDashboard&#39; for owned and accessible by the current user.</p>
		 * @type {Api.DashboardScope}
		 * @memberof DashboardWriteSchema
		 */
		scope: Api.DashboardScope;
		dashboard: Api.PersesDashboard;
	}

	export interface DataUnavailable {
		/**
		 * Value for discriminator in Api.GetCausingEventsNotFound
		 */
		_type: 'DataUnavailable';
	
		message: string;
		/**
		 * @type {number}
		 * @memberof DataUnavailable
		 */
		requestTimeMs: number;
		/**
		 * @type {number}
		 * @memberof DataUnavailable
		 */
		availableSinceMs: number;
	}
	
	/**
	 * @export
	 * @namespace DataUnavailable
	 */
	export namespace DataUnavailable {
		export enum TypeEnum {
			DataUnavailable = 'DataUnavailable'
		}
	
	}

	export interface DeleteVersionsResult {
		deleted: string[];
		skippedInUse: string[];
	}

	export enum DependencyDirection {
		OneWay = 'one-way',
		None = 'none',
		Both = 'both'
	}

	export interface DurationCell {
		/**
		 * Value for discriminator in Api.CellValue
		 */
		_type: 'DurationCell';
	
		/**
		 * @type {number}
		 * @memberof DurationCell
		 */
		startDate: number;
		/**
		 * @type {number | null}
		 * @memberof DurationCell
		 */
		endDate?: number | null;
	}
	
	/**
	 * @export
	 * @namespace DurationCell
	 */
	export namespace DurationCell {
		export enum TypeEnum {
			DurationCell = 'DurationCell'
		}
	
	}

	export interface DurationField extends Api.BaseComponentField {
		/**
		 * Value for discriminator in Api.ComponentField
		 */
		_type: 'DurationField';
	
		/**
		 * @type {number}
		 * @memberof DurationField
		 */
		startTime: number;
		/**
		 * @type {number | null}
		 * @memberof DurationField
		 */
		endTime?: number | null;
	}
	
	/**
	 * @export
	 * @namespace DurationField
	 */
	export namespace DurationField {
		export enum TypeEnum {
			DurationField = 'DurationField'
		}
	
	}

	export interface DurationHistogram {
		/**
		 * @description <p>List of duration buckets</p>
		 * @type {Api.DurationHistogramBucket[]}
		 * @memberof DurationHistogram
		 */
		buckets: Api.DurationHistogramBucket[];
		/**
		 * @description <p>Quantiles for duration</p>
		 * @type {Api.DurationQuantiles}
		 * @memberof DurationHistogram
		 */
		quantiles: Api.DurationQuantiles;
	}

	export interface DurationHistogramBucket {
		/**
		 * @description <p>Number of successful traces with a duration between (lowerNanos, upperNanos].</p>
		 * @type {number}
		 * @memberof DurationHistogramBucket
		 */
		okCount: number;
		/**
		 * @description <p>Number of erroneous traces with a duration between (lowerNanos, upperNanos].</p>
		 * @type {number}
		 * @memberof DurationHistogramBucket
		 */
		errorCount: number;
		/**
		 * @description <p>Number of traces with unset status and a duration between (lowerNanos, upperNanos].</p>
		 * @type {number}
		 * @memberof DurationHistogramBucket
		 */
		unsetCount: number;
		/**
		 * @description <p>Lower limit on trace duration</p>
		 * @type {number}
		 * @memberof DurationHistogramBucket
		 */
		lowerNanos?: number;
		/**
		 * @description <p>Upper limit on trace duration</p>
		 * @type {number}
		 * @memberof DurationHistogramBucket
		 */
		upperNanos?: number;
	}

	export interface DurationMetaDisplay {
		/**
		 * Value for discriminator in Api.OverviewColumnMetaDisplay
		 */
		_type: 'DurationMetaDisplay';
	
	  // OpenAPI `type: object` without properties
	  [name: string]: unknown
	}
	
	/**
	 * @export
	 * @namespace DurationMetaDisplay
	 */
	export namespace DurationMetaDisplay {
		export enum TypeEnum {
			DurationMetaDisplay = 'DurationMetaDisplay'
		}
	
	}

	export interface DurationProjection {
		/**
		 * Value for discriminator in Api.ComponentOverviewProjection
		 */
		_type: 'DurationProjection';
	
		/**
		 * @description <p>Cel expression that returns an ISO8601 formatted timestamp</p>
		 * @type {string}
		 * @memberof DurationProjection
		 */
		startTime: string;
		/**
		 * @description <p>Cel expression that returns an ISO8601 formatted timestamp</p>
		 * @type {string}
		 * @memberof DurationProjection
		 */
		endTime?: string;
	}
	
	/**
	 * @export
	 * @namespace DurationProjection
	 */
	export namespace DurationProjection {
		export enum TypeEnum {
			DurationProjection = 'DurationProjection'
		}
	
	}

	export interface DurationQuantiles {
		/**
		 * @type {number}
		 * @memberof DurationQuantiles
		 */
		q50: number;
		/**
		 * @type {number}
		 * @memberof DurationQuantiles
		 */
		q90: number;
		/**
		 * @type {number}
		 * @memberof DurationQuantiles
		 */
		q95: number;
		/**
		 * @type {number}
		 * @memberof DurationQuantiles
		 */
		q99: number;
	}

	export interface EmailChannelRefId {
		/**
		 * Value for discriminator in Api.ChannelReferenceId
		 */
		_type: 'EmailChannelRefId';
	
		/**
		 * @type {number}
		 * @memberof EmailChannelRefId
		 */
		id: number;
	}
	
	/**
	 * @export
	 * @namespace EmailChannelRefId
	 */
	export namespace EmailChannelRefId {
		export enum TypeEnum {
			EmailChannelRefId = 'EmailChannelRefId'
		}
	
	}

	export interface EmailChannelWriteSchema {
		to: string[];
		cc: string[];
		subjectPrefix?: string;
	}

	export interface EmailNotificationChannel extends Api.BaseNotificationChannel, Api.EmailChannelWriteSchema {
		/**
		 * Value for discriminator in Api.NotificationChannel
		 */
		_type: 'EmailNotificationChannel';
	
	  // OpenAPI `type: object` without properties
	  [name: string]: unknown
	}
	
	/**
	 * @export
	 * @namespace EmailNotificationChannel
	 */
	export namespace EmailNotificationChannel {
		export enum TypeEnum {
			EmailNotificationChannel = 'EmailNotificationChannel'
		}
	
	}

	export interface EmailNotificationStatus {
		validConfiguration: boolean;
	}

	export interface ErrorComponentPresentationLink {
		/**
		 * Value for discriminator in Api.ComponentPresentationLink
		 */
		_type: 'ErrorComponentPresentationLink';
	
		/**
		 * @description <p>Identity key for this link.</p>
		 * @type {string}
		 * @memberof ErrorComponentPresentationLink
		 */
		linkId: string;
		/**
		 * @description <p>Displayed link title, or the link identity when the title could not be resolved.</p>
		 * @type {string}
		 * @memberof ErrorComponentPresentationLink
		 */
		title: string;
		/**
		 * @description <p>Reason why the link could not be resolved.</p>
		 * @type {string}
		 * @memberof ErrorComponentPresentationLink
		 */
		message: string;
	}
	
	/**
	 * @export
	 * @namespace ErrorComponentPresentationLink
	 */
	export namespace ErrorComponentPresentationLink {
		export enum TypeEnum {
			ErrorComponentPresentationLink = 'ErrorComponentPresentationLink'
		}
	
	}

	export interface ErrorField extends Api.BaseComponentField {
		/**
		 * Value for discriminator in Api.ComponentField
		 */
		_type: 'ErrorField';
	
		message: string;
	}
	
	/**
	 * @export
	 * @namespace ErrorField
	 */
	export namespace ErrorField {
		export enum TypeEnum {
			ErrorField = 'ErrorField'
		}
	
	}

	export interface EventBucket {
		/**
		 * @description <p>Total logs record count in the bucket.</p>
		 * @type {number}
		 * @memberof EventBucket
		 */
		count: number;
		/**
		 * @description <p>The bucket initial timestamp.</p>
		 * @type {number}
		 * @memberof EventBucket
		 */
		startTime: number;
		/**
		 * @description <p>The bucket final timestamp.</p>
		 * @type {number}
		 * @memberof EventBucket
		 */
		endTime: number;
		categoryBuckets: Api.EventCategoryBucket[];
	}

	export enum EventCategory {
		Changes = 'Changes',
		Deployments = 'Deployments',
		Alerts = 'Alerts',
		Anomalies = 'Anomalies',
		Activities = 'Activities',
		Others = 'Others'
	}

	export interface EventCategoryBucket {
		/**
		 * @description <p>Total events count for a particular category in the bucket.</p>
		 * @type {number}
		 * @memberof EventCategoryBucket
		 */
		count: number;
		category: Api.EventCategory;
	}

	export interface EventComponent {
		/**
		 * Value for discriminator in Api.EventElement
		 */
		_type: 'EventComponent';
	
		/**
		 * @type {number}
		 * @memberof EventComponent
		 */
		id: number;
		typeName: string;
		name: string;
		identifiers: string[];
		icon?: string;
	}
	
	/**
	 * @export
	 * @namespace EventComponent
	 */
	export namespace EventComponent {
		export enum TypeEnum {
			EventComponent = 'EventComponent'
		}
	
	}

	export interface EventCursor {
		/**
		 * @type {number}
		 * @memberof EventCursor
		 */
		lastEventTimestampMs: number;
		lastEventId: string;
	}

	export type EventElement = Api.EventComponent | Api.EventRelation;

	export interface EventFilters {
		types?: string[];
		tags?: string[];
		categories?: string[];
		sources?: string[];
	}

	export interface EventItemsWithTotal {
		items: Api.TopologyEvent[];
		/**
		 * @type {number}
		 * @memberof EventItemsWithTotal
		 */
		total: number;
	}

	export interface EventListRequest {
		/**
		 * @type {number}
		 * @memberof EventListRequest
		 */
		startTimestampMs: number;
		/**
		 * @type {number}
		 * @memberof EventListRequest
		 */
		endTimestampMs: number;
		topologyQuery: string;
		includeConnectedComponents?: boolean;
		/**
		 * @type {number}
		 * @memberof EventListRequest
		 */
		limit: number;
		/**
		 * @type {number}
		 * @memberof EventListRequest
		 */
		playHeadTimestampMs?: number;
		eventTypes?: string[];
		eventTags?: string[];
		eventCategories?: Api.EventCategory[];
		eventSources?: string[];
		cursor?: Api.EventCursor;
	}

	export interface EventNotFoundError {
		/**
		 * Discriminator property
		 */
		_type: Api.EventNotFoundError.TypeEnum;
		
		eventId: string;
	}
	
	/**
	 * @export
	 * @namespace EventNotFoundError
	 */
	export namespace EventNotFoundError {
		export enum TypeEnum {
			EventNotFoundError = 'EventNotFoundError'
		}
	
	}

	export interface EventRelation {
		/**
		 * Value for discriminator in Api.EventElement
		 */
		_type: 'EventRelation';
	
		/**
		 * @type {number}
		 * @memberof EventRelation
		 */
		id: number;
		typeName: string;
		name?: string;
		identifiers: string[];
		source: Api.EventComponent;
		target: Api.EventComponent;
		dependencyDirection: Api.DependencyDirection;
	}
	
	/**
	 * @export
	 * @namespace EventRelation
	 */
	export namespace EventRelation {
		export enum TypeEnum {
			EventRelation = 'EventRelation'
		}
	
	}

	export interface EventsHistogram {
		buckets: Api.EventBucket[];
	}

	export interface EventsHistogramRequest {
		/**
		 * @type {number}
		 * @memberof EventsHistogramRequest
		 */
		topologyTimestamp?: number;
		/**
		 * @type {number}
		 * @memberof EventsHistogramRequest
		 */
		startTimestampMs: number;
		/**
		 * @type {number}
		 * @memberof EventsHistogramRequest
		 */
		endTimestampMs: number;
		topologyQuery: string;
		includeConnectedComponents?: boolean;
		eventTypes?: string[];
		eventCategories?: Api.EventCategory[];
		/**
		 * @type {number}
		 * @memberof EventsHistogramRequest
		 */
		histogramBucketCount: number;
	}

	export interface EventsPerspective {
	  // OpenAPI `type: object` without properties
	  [name: string]: unknown
	}

	export interface EventTag {
		key: string;
		value: string;
	}

	export interface ExecuteScriptArgumentsScriptError {
		/**
		 * Value for discriminator in Api.ExecuteScriptError
		 */
		_type: 'ExecuteScriptArgumentsScriptError';
	
		message: string;
		error: Api.ExecuteScriptError;
	}
	
	/**
	 * @export
	 * @namespace ExecuteScriptArgumentsScriptError
	 */
	export namespace ExecuteScriptArgumentsScriptError {
		export enum TypeEnum {
			ExecuteScriptArgumentsScriptError = 'ExecuteScriptArgumentsScriptError'
		}
	
	}

	export type ExecuteScriptError = Api.ExecuteScriptSyntaxErrors | Api.ExecuteScriptGroovyRuntimeError | Api.ExecuteScriptExecutionError | Api.ExecuteScriptSecurityError | Api.ExecuteScriptExceptionError | Api.ExecuteScriptWrongReturnTypeError | Api.ExecuteScriptTimeoutError | Api.ExecuteScriptArgumentsScriptError;

	export interface ExecuteScriptExceptionError {
		/**
		 * Value for discriminator in Api.ExecuteScriptError
		 */
		_type: 'ExecuteScriptExceptionError';
	
		message: string;
	}
	
	/**
	 * @export
	 * @namespace ExecuteScriptExceptionError
	 */
	export namespace ExecuteScriptExceptionError {
		export enum TypeEnum {
			ExecuteScriptExceptionError = 'ExecuteScriptExceptionError'
		}
	
	}

	export interface ExecuteScriptExecutionError {
		/**
		 * Value for discriminator in Api.ExecuteScriptError
		 */
		_type: 'ExecuteScriptExecutionError';
	
		reason: string;
		message: string;
	}
	
	/**
	 * @export
	 * @namespace ExecuteScriptExecutionError
	 */
	export namespace ExecuteScriptExecutionError {
		export enum TypeEnum {
			ExecuteScriptExecutionError = 'ExecuteScriptExecutionError'
		}
	
	}

	export interface ExecuteScriptGroovyRuntimeError {
		/**
		 * Value for discriminator in Api.ExecuteScriptError
		 */
		_type: 'ExecuteScriptGroovyRuntimeError';
	
		message: string;
		location?: Api.ScriptLocation;
	}
	
	/**
	 * @export
	 * @namespace ExecuteScriptGroovyRuntimeError
	 */
	export namespace ExecuteScriptGroovyRuntimeError {
		export enum TypeEnum {
			ExecuteScriptGroovyRuntimeError = 'ExecuteScriptGroovyRuntimeError'
		}
	
	}

	export interface ExecuteScriptRequest {
		/**
		 * @type {number}
		 * @memberof ExecuteScriptRequest
		 */
		timeoutMs?: number;
		script: string;
		argumentsScript?: string;
	}

	export interface ExecuteScriptResponse {
		/**
		 * @description <p>Contains a <code>value</code> and <code>_type</code> property. This is described this way, because <code>value</code> can hold any
		 *  JSON type and most open api generators (but not all) have problems with such types or are inconsistent with the OpenAPI spec.
		 *  The <code>_type</code> property describes the original type of the result value during script execution.
		 *  The <code>value</code> property holds the resulting value serialized to JSON.
		 *  The <code>value</code> property can be of any JSON type, i.e. null, undefined, boolean, number, string, array or object.</p>
		 * @type {Api.ExecuteScriptResponse.Result | null}
		 * @memberof ExecuteScriptResponse
		 */
		result: Api.ExecuteScriptResponse.Result | null;
	}
	
	/**
	 * @export
	 * @namespace ExecuteScriptResponse
	 */
	export namespace ExecuteScriptResponse {
		/**
		 * <p>Contains a <code>value</code> and <code>_type</code> property. This is described this way, because <code>value</code> can hold any
		 * JSON type and most open api generators (but not all) have problems with such types or are inconsistent with the OpenAPI spec.
		 * The <code>_type</code> property describes the original type of the result value during script execution.
		 * The <code>value</code> property holds the resulting value serialized to JSON.
		 * The <code>value</code> property can be of any JSON type, i.e. null, undefined, boolean, number, string, array or object.</p>
		 */
		export interface Result {
		  // OpenAPI `type: object` without properties
		  [name: string]: unknown
		}
	
	}

	export interface ExecuteScriptSecurityError {
		/**
		 * Value for discriminator in Api.ExecuteScriptError
		 */
		_type: 'ExecuteScriptSecurityError';
	
		message: string;
	}
	
	/**
	 * @export
	 * @namespace ExecuteScriptSecurityError
	 */
	export namespace ExecuteScriptSecurityError {
		export enum TypeEnum {
			ExecuteScriptSecurityError = 'ExecuteScriptSecurityError'
		}
	
	}

	export interface ExecuteScriptSyntaxErrors {
		/**
		 * Value for discriminator in Api.ExecuteScriptError
		 */
		_type: 'ExecuteScriptSyntaxErrors';
	
		message: string;
		errors: Api.ExecuteScriptSyntaxErrors.Error[];
	}
	
	/**
	 * @export
	 * @namespace ExecuteScriptSyntaxErrors
	 */
	export namespace ExecuteScriptSyntaxErrors {
		export enum TypeEnum {
			ExecuteScriptSyntaxErrors = 'ExecuteScriptSyntaxErrors'
		}
	
		export interface Error {
			message: string;
			location: Api.ScriptLocation;
		}
	
	}

	export interface ExecuteScriptTimeoutError {
		/**
		 * Value for discriminator in Api.ExecuteScriptError
		 */
		_type: 'ExecuteScriptTimeoutError';
	
		message: string;
		/**
		 * @type {number}
		 * @memberof ExecuteScriptTimeoutError
		 */
		timeoutMs: number;
	}
	
	/**
	 * @export
	 * @namespace ExecuteScriptTimeoutError
	 */
	export namespace ExecuteScriptTimeoutError {
		export enum TypeEnum {
			ExecuteScriptTimeoutError = 'ExecuteScriptTimeoutError'
		}
	
	}

	export interface ExecuteScriptWrongReturnTypeError {
		/**
		 * Value for discriminator in Api.ExecuteScriptError
		 */
		_type: 'ExecuteScriptWrongReturnTypeError';
	
		message: string;
		actualReturnType: string;
		expectedReturnType: string;
	}
	
	/**
	 * @export
	 * @namespace ExecuteScriptWrongReturnTypeError
	 */
	export namespace ExecuteScriptWrongReturnTypeError {
		export enum TypeEnum {
			ExecuteScriptWrongReturnTypeError = 'ExecuteScriptWrongReturnTypeError'
		}
	
	}

	export interface ExpiredSubscription {
		/**
		 * Value for discriminator in Api.SubscriptionState
		 */
		_type: 'ExpiredSubscription';
	
		subscription: Api.Subscription;
	}
	
	/**
	 * @export
	 * @namespace ExpiredSubscription
	 */
	export namespace ExpiredSubscription {
		export enum TypeEnum {
			ExpiredSubscription = 'ExpiredSubscription'
		}
	
	}

	export interface Export {
		nodesWithIds?: number[];
		allNodesOfTypes?: string[];
		namespace?: string;
		allowReferences?: string[];
	}

	export interface ExternalComponent {
		externalId?: string;
		identifiers: string[];
		data: Api.ExternalComponent.Data;
		/**
		 * @type {number}
		 * @memberof ExternalComponent
		 */
		id?: number;
		/**
		 * @type {number}
		 * @memberof ExternalComponent
		 */
		lastUpdateTimestamp?: number;
		elementTypeTag?: string;
		syncName: string;
		sourceProperties: Api.ExternalComponent.SourceProperties;
		status?: Api.ExternalComponent.Status;
		tags: string[];
	}
	
	/**
	 * @export
	 * @namespace ExternalComponent
	 */
	export namespace ExternalComponent {
		export interface Data {
		  // OpenAPI `type: object` without properties
		  [name: string]: unknown
		}
	
		export interface SourceProperties {
		  // OpenAPI `type: object` without properties
		  [name: string]: unknown
		}
	
		export interface Status {
		  // OpenAPI `type: object` without properties
		  [name: string]: unknown
		}
	
	}

	export interface ExternalMonitorDefId {
		/**
		 * Value for discriminator in Api.MonitorReferenceId
		 */
		_type: 'ExternalMonitorDefId';
	
		/**
		 * @type {number}
		 * @memberof ExternalMonitorDefId
		 */
		id: number;
	}
	
	/**
	 * @export
	 * @namespace ExternalMonitorDefId
	 */
	export namespace ExternalMonitorDefId {
		export enum TypeEnum {
			ExternalMonitorDefId = 'ExternalMonitorDefId'
		}
	
	}

	export interface ExternalRelation {
		externalId?: string;
		identifiers: string[];
		data: Api.ExternalRelation.Data;
		/**
		 * @type {number}
		 * @memberof ExternalRelation
		 */
		id?: number;
		/**
		 * @type {number}
		 * @memberof ExternalRelation
		 */
		lastUpdateTimestamp?: number;
		elementTypeTag?: string;
		syncName: string;
		tags: string[];
	}
	
	/**
	 * @export
	 * @namespace ExternalRelation
	 */
	export namespace ExternalRelation {
		export interface Data {
		  // OpenAPI `type: object` without properties
		  [name: string]: unknown
		}
	
	}

	export enum FailingHealthStateValue {
		DEVIATING = 'DEVIATING',
		CRITICAL = 'CRITICAL',
		UNKNOWN = 'UNKNOWN'
	}

	export interface FAQ {
		question: string;
		answer: string;
	}

	export interface FilterName {
		singular: string;
		plural: string;
	}

	export interface FullComponent {
		typeName: string;
		icon?: string;
		fields: Api.ComponentField[];
		synced: Api.ExternalComponent[];
		provisioning?: Api.ComponentProvisioning;
		/**
		 * @description <p>Resolved related resource definitions in display order. Backend populates from both legacy and new presentation definitions.</p>
		 * @type {Api.RelatedResource[]}
		 * @memberof FullComponent
		 */
		relatedResources: Api.RelatedResource[];
		/**
		 * @description <p>Resolved presentation links in display order. Backend populates from matching presentation definitions.</p>
		 * @type {Api.ComponentPresentationLink[]}
		 * @memberof FullComponent
		 */
		links: Api.ComponentPresentationLink[];
		events?: Api.ComponentEvents;
		data: Api.ComponentData;
		highlights?: Api.LegacyComponentHighlights;
		summary: Api.ComponentSummary;
		highlightMetrics: Api.ComponentMetricSection[];
		actions: Api.ComponentAction[];
		boundTraces?: Api.BoundTraces;
	}

	export interface FullRelation {
		data: Api.RelationData;
		source: Api.FullComponent;
		target: Api.FullComponent;
		typeName: string;
		synced: Api.ExternalRelation[];
	}

	export interface FullStackPack {
		name: string;
		displayName: string;
		version: string;
		logo?: string;
		categories: string[];
		isNew: boolean;
		isMultiConfig: boolean;
		overviewUrl?: string;
		detailedOverviewUrl?: string;
		resourcesUrl?: string;
		faqs: Api.FAQ[];
		configurationUrls: (string[])[];
		releaseStatus: Api.ReleaseStatus;
		steps: Api.StackPackStep[];
		integrations: Api.StackPackIntegration[];
		releaseNotes?: string;
		upgradeInstructions?: string;
		configurations: Api.StackPackConfiguration[];
		nextVersion?: Api.FullStackPack;
		latestVersion?: Api.FullStackPack;
		canUninstall: boolean;
		isCompatible: boolean;
	}

	export interface GaugeChart {
		/**
		 * Value for discriminator in Api.Chart
		 */
		_type: 'GaugeChart';
	
		unit?: string;
		/**
		 * @type {number}
		 * @memberof GaugeChart
		 */
		decimals?: number;
		/**
		 * @type {number}
		 * @memberof GaugeChart
		 */
		max?: number;
		calculation?: Api.ChartCalculation;
		thresholds?: Api.ChartThresholds;
	}
	
	/**
	 * @export
	 * @namespace GaugeChart
	 */
	export namespace GaugeChart {
		export enum TypeEnum {
			GaugeChart = 'GaugeChart'
		}
	
	}

	export interface GenericApiError {
		_type: Api.GenericApiError.TypeEnum;
		message: string;
		/**
		 * @type {number}
		 * @memberof GenericApiError
		 */
		errorCode?: number;
	}
	
	/**
	 * @export
	 * @namespace GenericApiError
	 */
	export namespace GenericApiError {
		export enum TypeEnum {
			InternalError = 'InternalError'
		}
	
	}

	export interface GenericErrorsResponse {
		_type?: Api.GenericErrorsResponse.TypeEnum;
		trackingKey: string;
		/**
		 * @type {number}
		 * @memberof GenericErrorsResponse
		 */
		serverTimestamp: number;
		errors: Api.GenericApiError[];
	}
	
	/**
	 * @export
	 * @namespace GenericErrorsResponse
	 */
	export namespace GenericErrorsResponse {
		export enum TypeEnum {
			ErrorsResponse = 'ErrorsResponse'
		}
	
	}

	export type GetCausingEventsBadRequest = Api.LimitOutOfRange | Api.TopologyTimeOutOfRange;

	export type GetCausingEventsNotFound = Api.ProblemNotFound | Api.DataUnavailable;

	export type GetCausingEventsResult = Api.CausingEventsResult | Api.TooManyTopologyResults | Api.CausingEventsAreNotAvailableForTheTime;

	export type GetCausingEventsServiceUnaivailable = Api.TooManyActiveQueries | Api.GetTopologyTimeout;

	export type GetKubernetesLogsAutocompleteBadRequest = Api.GetKubernetesLogsAutocompleteInvalidTimeRange;

	export interface GetKubernetesLogsAutocompleteInvalidTimeRange {
		/**
		 * Value for discriminator in Api.GetKubernetesLogsAutocompleteBadRequest
		 */
		_type: 'GetKubernetesLogsAutocompleteInvalidTimeRange';
	
		message: string;
		/**
		 * @description <p>Date/time representation in milliseconds since epoch (1970-01-01 00:00:00)</p>
		 * @type {number}
		 * @memberof GetKubernetesLogsAutocompleteInvalidTimeRange
		 */
		from: number;
		/**
		 * @description <p>Date/time representation in milliseconds since epoch (1970-01-01 00:00:00)</p>
		 * @type {number}
		 * @memberof GetKubernetesLogsAutocompleteInvalidTimeRange
		 */
		to: number;
	}
	
	/**
	 * @export
	 * @namespace GetKubernetesLogsAutocompleteInvalidTimeRange
	 */
	export namespace GetKubernetesLogsAutocompleteInvalidTimeRange {
		export enum TypeEnum {
			InvalidTimeRange = 'InvalidTimeRange'
		}
	
	}

	export interface GetKubernetesLogsAutocompleteResult {
		containerNames: string[];
		levels: Api.LogSeverity[];
	}

	export type GetKubernetesLogsBadRequest = Api.GetKubernetesLogsInvalidTimeRange | Api.GetKubernetesLogsInvalidPagination | Api.GetKubernetesLogsInvalidQuery;

	export type GetKubernetesLogsHistogramBadRequest = Api.GetKubernetesLogsHistogramInvalidTimeRange | Api.GetKubernetesLogsHistogramInvalidQuery;

	export interface GetKubernetesLogsHistogramInvalidQuery {
		/**
		 * Value for discriminator in Api.GetKubernetesLogsHistogramBadRequest
		 */
		_type: 'GetKubernetesLogsHistogramInvalidQuery';
	
		message: string;
		query: string;
	}
	
	/**
	 * @export
	 * @namespace GetKubernetesLogsHistogramInvalidQuery
	 */
	export namespace GetKubernetesLogsHistogramInvalidQuery {
		export enum TypeEnum {
			InvalidQuery = 'InvalidQuery'
		}
	
	}

	export interface GetKubernetesLogsHistogramInvalidTimeRange {
		/**
		 * Value for discriminator in Api.GetKubernetesLogsHistogramBadRequest
		 */
		_type: 'GetKubernetesLogsHistogramInvalidTimeRange';
	
		message: string;
		/**
		 * @description <p>Date/time representation in milliseconds since epoch (1970-01-01 00:00:00)</p>
		 * @type {number}
		 * @memberof GetKubernetesLogsHistogramInvalidTimeRange
		 */
		from: number;
		/**
		 * @description <p>Date/time representation in milliseconds since epoch (1970-01-01 00:00:00)</p>
		 * @type {number}
		 * @memberof GetKubernetesLogsHistogramInvalidTimeRange
		 */
		to: number;
	}
	
	/**
	 * @export
	 * @namespace GetKubernetesLogsHistogramInvalidTimeRange
	 */
	export namespace GetKubernetesLogsHistogramInvalidTimeRange {
		export enum TypeEnum {
			InvalidTimeRange = 'InvalidTimeRange'
		}
	
	}

	export interface GetKubernetesLogsHistogramResult {
		buckets: Api.KubernetesLogHistogramBucket[];
	}

	export interface GetKubernetesLogsInvalidPagination {
		/**
		 * Value for discriminator in Api.GetKubernetesLogsBadRequest
		 */
		_type: 'GetKubernetesLogsInvalidPagination';
	
		message: string;
		/**
		 * @type {number}
		 * @memberof GetKubernetesLogsInvalidPagination
		 */
		pageSize: number;
		/**
		 * @type {number}
		 * @memberof GetKubernetesLogsInvalidPagination
		 */
		page: number;
	}
	
	/**
	 * @export
	 * @namespace GetKubernetesLogsInvalidPagination
	 */
	export namespace GetKubernetesLogsInvalidPagination {
		export enum TypeEnum {
			InvalidPagination = 'InvalidPagination'
		}
	
	}

	export interface GetKubernetesLogsInvalidQuery {
		/**
		 * Value for discriminator in Api.GetKubernetesLogsBadRequest
		 */
		_type: 'GetKubernetesLogsInvalidQuery';
	
		message: string;
		query: string;
	}
	
	/**
	 * @export
	 * @namespace GetKubernetesLogsInvalidQuery
	 */
	export namespace GetKubernetesLogsInvalidQuery {
		export enum TypeEnum {
			InvalidQuery = 'InvalidQuery'
		}
	
	}

	export interface GetKubernetesLogsInvalidTimeRange {
		/**
		 * Value for discriminator in Api.GetKubernetesLogsBadRequest
		 */
		_type: 'GetKubernetesLogsInvalidTimeRange';
	
		message: string;
		/**
		 * @description <p>Date/time representation in milliseconds since epoch (1970-01-01 00:00:00)</p>
		 * @type {number}
		 * @memberof GetKubernetesLogsInvalidTimeRange
		 */
		from: number;
		/**
		 * @description <p>Date/time representation in milliseconds since epoch (1970-01-01 00:00:00)</p>
		 * @type {number}
		 * @memberof GetKubernetesLogsInvalidTimeRange
		 */
		to: number;
	}
	
	/**
	 * @export
	 * @namespace GetKubernetesLogsInvalidTimeRange
	 */
	export namespace GetKubernetesLogsInvalidTimeRange {
		export enum TypeEnum {
			InvalidTimeRange = 'InvalidTimeRange'
		}
	
	}

	export interface GetKubernetesLogsResult {
		/**
		 * @description <p>List of log records ordered by timestamps in ascending order.</p>
		 * @type {Api.KubernetesLogRecord[]}
		 * @memberof GetKubernetesLogsResult
		 */
		logs: Api.KubernetesLogRecord[];
		/**
		 * @description <p>Maximum number of the log lines in the result.</p>
		 * @type {number}
		 * @memberof GetKubernetesLogsResult
		 */
		pageSize: number;
		/**
		 * @description <p>The requested logs page.</p>
		 * @type {number}
		 * @memberof GetKubernetesLogsResult
		 */
		page: number;
		/**
		 * @description <p>The total amount of matching logs for the requested search criteria.</p>
		 * @type {number}
		 * @memberof GetKubernetesLogsResult
		 */
		matchesTotal: number;
	}

	export interface GetTopologyTimeout {
		/**
		 * Value for discriminator in Api.GetCausingEventsServiceUnaivailable
		 */
		_type: 'GetTopologyTimeout';
	
		message: string;
		/**
		 * @type {number}
		 * @memberof GetTopologyTimeout
		 */
		timeoutSeconds: number;
	}
	
	/**
	 * @export
	 * @namespace GetTopologyTimeout
	 */
	export namespace GetTopologyTimeout {
		export enum TypeEnum {
			GetTopologyTimeout = 'GetTopologyTimeout'
		}
	
	}

	export interface GrantPermission {
		permission: string;
		resourceName: string;
	}

	export interface HealthCell {
		/**
		 * Value for discriminator in Api.CellValue
		 */
		_type: 'HealthCell';
	
		state: Api.HealthStateValue;
	}
	
	/**
	 * @export
	 * @namespace HealthCell
	 */
	export namespace HealthCell {
		export enum TypeEnum {
			HealthCell = 'HealthCell'
		}
	
	}

	export interface HealthField extends Api.BaseComponentField {
		/**
		 * Value for discriminator in Api.ComponentField
		 */
		_type: 'HealthField';
	
		state: Api.HealthStateValue;
	}
	
	/**
	 * @export
	 * @namespace HealthField
	 */
	export namespace HealthField {
		export enum TypeEnum {
			HealthField = 'HealthField'
		}
	
	}

	export interface HealthMetaDisplay {
		/**
		 * Value for discriminator in Api.OverviewColumnMetaDisplay
		 */
		_type: 'HealthMetaDisplay';
	
	  // OpenAPI `type: object` without properties
	  [name: string]: unknown
	}
	
	/**
	 * @export
	 * @namespace HealthMetaDisplay
	 */
	export namespace HealthMetaDisplay {
		export enum TypeEnum {
			HealthMetaDisplay = 'HealthMetaDisplay'
		}
	
	}

	export interface HealthProjection {
		/**
		 * Value for discriminator in Api.ComponentOverviewProjection
		 */
		_type: 'HealthProjection';
	
		/**
		 * @description <p>Cel expression that returns a string that represents a valid HealthState</p>
		 * @type {string}
		 * @memberof HealthProjection
		 */
		value: string;
	}
	
	/**
	 * @export
	 * @namespace HealthProjection
	 */
	export namespace HealthProjection {
		export enum TypeEnum {
			HealthProjection = 'HealthProjection'
		}
	
	}

	export enum HealthStateValue {
		UNINITIALIZED = 'UNINITIALIZED',
		UNKNOWN = 'UNKNOWN',
		CLEAR = 'CLEAR',
		DISABLED = 'DISABLED',
		DEVIATING = 'DEVIATING',
		FLAPPING = 'FLAPPING',
		CRITICAL = 'CRITICAL'
	}

	export interface HealthStreamError {
		errorCode: string;
		level: string;
		error: string;
		/**
		 * @type {number}
		 * @memberof HealthStreamError
		 */
		count: number;
	}

	export interface HealthStreamMetrics {
		/**
		 * @type {number}
		 * @memberof HealthStreamMetrics
		 */
		bucketSizeSeconds: number;
		latencySeconds?: Api.MetricBucketValue[];
		messagePerSecond?: Api.MetricBucketValue[];
		createsPerSecond?: Api.MetricBucketValue[];
		updatesPerSecond?: Api.MetricBucketValue[];
		deletesPerSecond?: Api.MetricBucketValue[];
	}

	export interface HealthStreamNotFound {
		/**
		 * Value for discriminator in Api.HealthSubStreamError
		 */
		_type: 'HealthStreamNotFound';
	
		urn: string;
	}
	
	/**
	 * @export
	 * @namespace HealthStreamNotFound
	 */
	export namespace HealthStreamNotFound {
		export enum TypeEnum {
			HealthStreamNotFound = 'HealthStreamNotFound'
		}
	
	}

	export interface HealthStreamStatus {
		/**
		 * @type {number}
		 * @memberof HealthStreamStatus
		 */
		partition: number;
		consistencyModel: string;
		recoverMessage?: string;
		globalErrors?: Api.HealthStreamError[];
		aggregateMetrics: Api.HealthStreamMetrics;
		mainStreamStatus?: Api.HealthSubStreamStatus;
	}

	export type HealthSubStreamConsistencyState = Api.HealthSubStreamSnapshot | Api.HealthSubStreamExpiry | Api.HealthSubStreamTransactionalIncrements;

	export type HealthSubStreamError = Api.HealthStreamNotFound | Api.HealthSubStreamNotFound;

	export interface HealthSubStreamExpiry {
		/**
		 * Value for discriminator in Api.HealthSubStreamConsistencyState
		 */
		_type: 'HealthSubStreamExpiry';
	
		/**
		 * @type {number}
		 * @memberof HealthSubStreamExpiry
		 */
		expiryIntervalMs: number;
		/**
		 * @type {number}
		 * @memberof HealthSubStreamExpiry
		 */
		repeatIntervalMs: number;
	}
	
	/**
	 * @export
	 * @namespace HealthSubStreamExpiry
	 */
	export namespace HealthSubStreamExpiry {
		export enum TypeEnum {
			HealthSubStreamExpiry = 'HealthSubStreamExpiry'
		}
	
	}

	export interface HealthSubStreamNotFound {
		/**
		 * Value for discriminator in Api.HealthSubStreamError
		 */
		_type: 'HealthSubStreamNotFound';
	
		urn: string;
		subStreamId?: string;
	}
	
	/**
	 * @export
	 * @namespace HealthSubStreamNotFound
	 */
	export namespace HealthSubStreamNotFound {
		export enum TypeEnum {
			HealthSubStreamNotFound = 'HealthSubStreamNotFound'
		}
	
	}

	export interface HealthSubStreamSnapshot {
		/**
		 * Value for discriminator in Api.HealthSubStreamConsistencyState
		 */
		_type: 'HealthSubStreamSnapshot';
	
		/**
		 * @type {number}
		 * @memberof HealthSubStreamSnapshot
		 */
		expiryIntervalMs?: number;
		/**
		 * @type {number}
		 * @memberof HealthSubStreamSnapshot
		 */
		repeatIntervalMs: number;
	}
	
	/**
	 * @export
	 * @namespace HealthSubStreamSnapshot
	 */
	export namespace HealthSubStreamSnapshot {
		export enum TypeEnum {
			HealthSubStreamSnapshot = 'HealthSubStreamSnapshot'
		}
	
	}

	export interface HealthSubStreamStatus {
		errors?: Api.HealthStreamError[];
		metrics: Api.HealthStreamMetrics;
		subStreamState: Api.HealthSubStreamConsistencyState;
		/**
		 * @type {number}
		 * @memberof HealthSubStreamStatus
		 */
		checkStateCount: number;
	}

	export interface HealthSubStreamTransactionalIncrements {
		/**
		 * Value for discriminator in Api.HealthSubStreamConsistencyState
		 */
		_type: 'HealthSubStreamTransactionalIncrements';
	
		/**
		 * @type {number}
		 * @memberof HealthSubStreamTransactionalIncrements
		 */
		offset: number;
		/**
		 * @type {number}
		 * @memberof HealthSubStreamTransactionalIncrements
		 */
		batchIndex?: number;
	}
	
	/**
	 * @export
	 * @namespace HealthSubStreamTransactionalIncrements
	 */
	export namespace HealthSubStreamTransactionalIncrements {
		export enum TypeEnum {
			HealthSubStreamTransactionalIncrements = 'HealthSubStreamTransactionalIncrements'
		}
	
	}

	export enum IdentifierType {
		NodeId = 'NodeId',
		Identifier = 'Identifier'
	}

	export interface ImportSettings200Response {
	  // OpenAPI `type: object` without properties
	  [name: string]: unknown
	}

	export enum ImportSettingsLockedEnum {
		Fail = 'fail',
		Skip = 'skip',
		Overwrite = 'overwrite'
	}

	export enum ImportSettingsUnlockedEnum {
		Fail = 'fail',
		Skip = 'skip',
		Overwrite = 'overwrite'
	}

	/**
	 * <p>A custom representation for a date/time that needs better than milliseconds precision. Simply using nanoseconds since epoch results in integers that are too big to be represented correctly in Javascript (which is limited to 2^53-1). Instead this uses the standard representation of milliseconds since epoch with a nanosecond offset. Calculate nanoseconds since epoch like this <code>nanosSinceEpoch = timestamp * 1000000 + offsetNanos</code>.</p>
	 */
	export interface InstantNanoPrecision {
		/**
		 * @description <p>Default timestamp representation in milliseconds since epoch</p>
		 * @type {number}
		 * @memberof InstantNanoPrecision
		 */
		timestamp: number;
		/**
		 * @description <p>Offset in nanoseconds (relative to the timestamp). Especially useful when comparing start and/or end times of spans, for example when rendering a trace chart.</p>
		 * @type {number}
		 * @memberof InstantNanoPrecision
		 * minimum: 0
		 * maximum: 999999
		 */
		offsetNanos: number;
	}

	export interface InvalidMonitorIdentifierError {
		/**
		 * Value for discriminator in Api.MonitorValidationError
		 */
		_type: 'InvalidMonitorIdentifierError';
	
		monitorIdOrUrn: string;
	}
	
	/**
	 * @export
	 * @namespace InvalidMonitorIdentifierError
	 */
	export namespace InvalidMonitorIdentifierError {
		export enum TypeEnum {
			InvalidMonitorIdentifierError = 'InvalidMonitorIdentifierError'
		}
	
	}

	export interface InvalidNotificationConfigurationIdentifier {
		/**
		 * Value for discriminator in Api.NotificationConfigurationByIdErrors
		 */
		_type: 'InvalidNotificationConfigurationIdentifier';
	
		notificationConfigurationIdOrUrn: string;
	}
	
	/**
	 * @export
	 * @namespace InvalidNotificationConfigurationIdentifier
	 */
	export namespace InvalidNotificationConfigurationIdentifier {
		export enum TypeEnum {
			InvalidNotificationConfigurationIdentifier = 'InvalidNotificationConfigurationIdentifier'
		}
	
	}

	export interface InvalidSyncIdentifier {
		message: string;
	}

	export interface InvalidUrn {
		urn: string;
		message: string;
	}

	export interface KubernetesLogHighlight {
		/**
		 * @description <p>Index of character in the message to start the highlight (0-based)</p>
		 * @type {number}
		 * @memberof KubernetesLogHighlight
		 */
		startIndex: number;
		/**
		 * @description <p>Index of character in the message to end the highlight (0-based)</p>
		 * @type {number}
		 * @memberof KubernetesLogHighlight
		 */
		endIndex: number;
	}

	export interface KubernetesLogHistogramBucket {
		/**
		 * @description <p>Total logs record count in the bucket.</p>
		 * @type {number}
		 * @memberof KubernetesLogHistogramBucket
		 */
		count: number;
		/**
		 * @description <p>The bucket initial timestamp.</p>
		 * @type {number}
		 * @memberof KubernetesLogHistogramBucket
		 */
		startTime: number;
		/**
		 * @description <p>The bucket final timestamp.</p>
		 * @type {number}
		 * @memberof KubernetesLogHistogramBucket
		 */
		endTime: number;
		logSeverityBuckets: Api.KubernetesLogSeverityHistogramBucket[];
	}

	export interface KubernetesLogRecord {
		timestamp: string;
		message: string;
		highlights: Api.KubernetesLogHighlight[];
		podName: string;
		podUID: string;
		containerName: string;
		severity: Api.LogSeverity;
		level: Api.LogLevel;
	}

	export interface KubernetesLogSeverityHistogramBucket {
		/**
		 * @description <p>Total logs record count for a particular log severity in the bucket.</p>
		 * @type {number}
		 * @memberof KubernetesLogSeverityHistogramBucket
		 */
		count: number;
		severity: Api.LogSeverity;
	}

	export interface LegacyComponentHighlights {
		showLogs: boolean;
	}

	export interface LicensedSubscription {
		/**
		 * Value for discriminator in Api.SubscriptionState
		 */
		_type: 'LicensedSubscription';
	
		subscription: Api.Subscription;
	}
	
	/**
	 * @export
	 * @namespace LicensedSubscription
	 */
	export namespace LicensedSubscription {
		export enum TypeEnum {
			LicensedSubscription = 'LicensedSubscription'
		}
	
	}

	export interface LimitOutOfRange {
		/**
		 * Value for discriminator in Api.GetCausingEventsBadRequest
		 */
		_type: 'LimitOutOfRange';
	
		message: string;
		/**
		 * @type {number}
		 * @memberof LimitOutOfRange
		 */
		limit: number;
		/**
		 * @type {number}
		 * @memberof LimitOutOfRange
		 */
		lowerBound: number;
		/**
		 * @type {number}
		 * @memberof LimitOutOfRange
		 */
		upperBound: number;
	}
	
	/**
	 * @export
	 * @namespace LimitOutOfRange
	 */
	export namespace LimitOutOfRange {
		export enum TypeEnum {
			LimitOutOfRange = 'LimitOutOfRange'
		}
	
	}

	export interface LinkCell {
		/**
		 * Value for discriminator in Api.CellValue
		 */
		_type: 'LinkCell';
	
		name: string;
		url: string;
	}
	
	/**
	 * @export
	 * @namespace LinkCell
	 */
	export namespace LinkCell {
		export enum TypeEnum {
			LinkCell = 'LinkCell'
		}
	
	}

	export interface LinkField extends Api.BaseComponentField {
		/**
		 * Value for discriminator in Api.ComponentField
		 */
		_type: 'LinkField';
	
		name: string;
		url: string;
	}
	
	/**
	 * @export
	 * @namespace LinkField
	 */
	export namespace LinkField {
		export enum TypeEnum {
			LinkField = 'LinkField'
		}
	
	}

	export interface LinkMetaDisplay {
		/**
		 * Value for discriminator in Api.OverviewColumnMetaDisplay
		 */
		_type: 'LinkMetaDisplay';
	
		external: boolean;
	}
	
	/**
	 * @export
	 * @namespace LinkMetaDisplay
	 */
	export namespace LinkMetaDisplay {
		export enum TypeEnum {
			LinkMetaDisplay = 'LinkMetaDisplay'
		}
	
	}

	export type LockedResponse = Api.NodeLocked | Api.NodeUnlocked;

	export enum LogLevel {
		ALERT = 'ALERT',
		TRACE = 'TRACE',
		DEBUG = 'DEBUG',
		NOTICE = 'NOTICE',
		INFO = 'INFO',
		WARN = 'WARN',
		WARNING = 'WARNING',
		ERR = 'ERR',
		ERROR = 'ERROR',
		CRIT = 'CRIT',
		CRITICAL = 'CRITICAL',
		FATAL = 'FATAL',
		SEVERE = 'SEVERE',
		EMERG = 'EMERG',
		EMERGENCY = 'EMERGENCY',
		UNKNOWN = 'UNKNOWN'
	}

	export enum LogsDirection {
		NEWEST = 'NEWEST',
		OLDEST = 'OLDEST'
	}

	export enum LogSeverity {
		WARNING = 'WARNING',
		ERROR = 'ERROR',
		OTHER = 'OTHER'
	}

	export interface MainMenuGroup {
		name: string;
		identifier?: string;
		description?: string;
		defaultOpen: boolean;
		icon?: string;
		items: Api.MainMenuViewItem[];
	}

	export interface MainMenuViewItem {
		/**
		 * @description <p>Either a viewIdentifier or a componentPresentationIdentifier</p>
		 * @type {string}
		 * @memberof MainMenuViewItem
		 */
		identifier: string;
		title: string;
		icon?: string;
	}

	export interface MapField extends Api.BaseComponentField {
		/**
		 * Value for discriminator in Api.ComponentField
		 */
		_type: 'MapField';
	
		values: { [name: string]: string };
	}
	
	/**
	 * @export
	 * @namespace MapField
	 */
	export namespace MapField {
		export enum TypeEnum {
			MapField = 'MapField'
		}
	
	}

	export interface MapProjection {
		/**
		 * Value for discriminator in Api.ComponentHighlightProjection
		 */
		_type: 'MapProjection';
	
		/**
		 * @description <p>Cel expression that returns a map&lt;string,dyn&gt;</p>
		 * @type {string}
		 * @memberof MapProjection
		 */
		value: string;
	}
	
	/**
	 * @export
	 * @namespace MapProjection
	 */
	export namespace MapProjection {
		export enum TypeEnum {
			MapProjection = 'MapProjection'
		}
	
	}

	export interface Message {
		key: string;
		/**
		 * @type {number}
		 * @memberof Message
		 */
		partition: number;
		/**
		 * @type {number}
		 * @memberof Message
		 */
		offset: number;
		message: Api.Message.Message2;
	}
	
	/**
	 * @export
	 * @namespace Message
	 */
	export namespace Message {
		export interface Message2 {
		  // OpenAPI `type: object` without properties
		  [name: string]: unknown
		}
	
	}

	export enum MessageLevel {
		WARN = 'WARN',
		ERROR = 'ERROR',
		INFO = 'INFO'
	}

	export interface Messages {
		messages: Api.Message[];
	}

	export interface MetricBucketValue {
		/**
		 * @type {number}
		 * @memberof MetricBucketValue
		 */
		value?: number;
	}

	export interface MetricBucketValue2 {
		/**
		 * @type {number}
		 * @memberof MetricBucketValue2
		 */
		value?: number;
	}

	export interface MetricBucketValue3 {
		/**
		 * @type {number}
		 * @memberof MetricBucketValue3
		 */
		value?: number;
	}

	export interface MetricCell {
		/**
		 * Value for discriminator in Api.CellValue
		 */
		_type: 'MetricCell';
	
		/**
		 * @description <p>The frontend can use the individual query to refresh the metrics (at interval). Allows to keep the current behaviour of making individual calls for each row.</p>
		 * @type {string}
		 * @memberof MetricCell
		 */
		individualQuery: string;
	}
	
	/**
	 * @export
	 * @namespace MetricCell
	 */
	export namespace MetricCell {
		export enum TypeEnum {
			MetricCell = 'MetricCell'
		}
	
	}

	export interface MetricField extends Api.BaseComponentField {
		/**
		 * Value for discriminator in Api.ComponentField
		 */
		_type: 'MetricField';
	
		/**
		 * @description <p>The frontend can use the query to refresh the metrics (at interval). Allows to keep the current behaviour of making individual calls for each row.</p>
		 * @type {string}
		 * @memberof MetricField
		 */
		query: string;
		unit?: string;
		/**
		 * @type {number}
		 * @memberof MetricField
		 */
		decimalPlaces?: number;
	}
	
	/**
	 * @export
	 * @namespace MetricField
	 */
	export namespace MetricField {
		export enum TypeEnum {
			MetricField = 'MetricField'
		}
	
	}

	export interface MetricMetaDisplay {
		/**
		 * Value for discriminator in Api.OverviewColumnMetaDisplay
		 */
		_type: 'MetricMetaDisplay';
	
		unit?: string | null;
		/**
		 * @type {number | null}
		 * @memberof MetricMetaDisplay
		 */
		decimalPlaces?: number | null;
		sparkline?: boolean | null;
		locked: boolean;
		boundMetricId?: Api.BoundMetricId;
	}
	
	/**
	 * @export
	 * @namespace MetricMetaDisplay
	 */
	export namespace MetricMetaDisplay {
		export enum TypeEnum {
			MetricMetaDisplay = 'MetricMetaDisplay'
		}
	
	}

	export interface MetricPerspectiveData {
		tabs: Api.ComponentMetricTab[];
	}

	export interface MetricProjection {
		/**
		 * Value for discriminator in Api.ComponentOverviewProjection
		 */
		_type: 'MetricProjection';
	
		/**
		 * @description <p>Individual metric query that returns a timeseries for a specific cell.</p>
		 * @type {string}
		 * @memberof MetricProjection
		 */
		query: string;
		unit?: string;
		/**
		 * @type {number}
		 * @memberof MetricProjection
		 */
		decimalPlaces?: number;
		sparkline?: boolean;
		metricId?: string;
	}
	
	/**
	 * @export
	 * @namespace MetricProjection
	 */
	export namespace MetricProjection {
		export enum TypeEnum {
			MetricProjection = 'MetricProjection'
		}
	
	}

	export interface Monitor {
		/**
		 * @type {number}
		 * @memberof Monitor
		 */
		id: number;
		name: string;
		identifier?: string;
		description?: string;
		/**
		 * @type {number}
		 * @memberof Monitor
		 */
		functionId: number;
		arguments: Api.Monitor.Argument[];
		remediationHint?: string;
		/**
		 * @type {number}
		 * @memberof Monitor
		 */
		intervalSeconds: number;
		tags: string[];
		source: string;
		sourceDetails?: string;
		canEdit: boolean;
		canClone: boolean;
		/**
		 * @description <p>If a monitor status is set to DISABLED it won&#39;t produce any health states but it can still be run manually to inspect it&#39;s output</p>
		 * @type {Api.MonitorStatusValue}
		 * @memberof Monitor
		 */
		status: Api.MonitorStatusValue;
		runtimeStatus: Api.MonitorRuntimeStatusValue;
		dummy?: boolean;
		/**
		 * @type {number}
		 * @memberof Monitor
		 */
		lastUpdateTimestamp: number;
	}
	
	/**
	 * @export
	 * @namespace Monitor
	 */
	export namespace Monitor {
		export interface Argument {
		  // OpenAPI `type: object` without properties
		  [name: string]: unknown
		}
	
	}

	export interface MonitorApiError extends Api.BaseMonitorError {
		statusCode: string;
		message: string;
	}

	export interface MonitorCheckStates {
		states: Api.ViewCheckState[];
	}

	/**
	 * <p>Selects a single monitor check state identified by monitor + checkStateId.</p>
	 */
	export interface MonitorCheckStateSelector {
		/**
		 * Value for discriminator in Api.SilencingRuleSelector
		 */
		type: 'MonitorCheckStateSelector';
	
		monitorId: Api.MonitorReferenceId;
		/**
		 * @description <p>The check state id within the monitor&#39;s output.</p>
		 * @type {string}
		 * @memberof MonitorCheckStateSelector
		 */
		checkStateId: string;
		/**
		 * @description <p>The sub-stream identifier (always absent for Monitors, present for ExternalMonitors).</p>
		 * @type {string}
		 * @memberof MonitorCheckStateSelector
		 */
		subStream?: string;
	}
	
	/**
	 * @export
	 * @namespace MonitorCheckStateSelector
	 */
	export namespace MonitorCheckStateSelector {
		export enum TypeEnum {
			MonitorCheckStateSelector = 'MonitorCheckStateSelector'
		}
	
	}

	export interface MonitorCheckStatus {
		/**
		 * @type {number}
		 * @memberof MonitorCheckStatus
		 */
		id: number;
		identifier: string;
		message: string;
		reason?: string;
		health: Api.HealthStateValue;
		/**
		 * @type {number}
		 * @memberof MonitorCheckStatus
		 */
		triggeredTimestamp: number;
		metrics: Api.MonitorCheckStatusMetric[];
		component: Api.MonitorCheckStatusComponent;
		monitorId: Api.MonitorReferenceId;
		/**
		 * @description <p>The check state id within the monitor&#39;s output.</p>
		 * @type {string}
		 * @memberof MonitorCheckStatus
		 */
		checkStateId: string;
		/**
		 * @description <p>The sub-stream identifier (present for ExternalMonitors only).</p>
		 * @type {string}
		 * @memberof MonitorCheckStatus
		 */
		subStream?: string;
		monitorName: string;
		monitorDescription?: string;
		troubleshootingSteps?: string;
		/**
		 * @type {number}
		 * @memberof MonitorCheckStatus
		 */
		topologyTime: number;
		dummy: boolean;
		/**
		 * @description <p>Configured silencing rule on this check state id.</p>
		 * @type {Api.MonitorCheckStatusSilencingRule}
		 * @memberof MonitorCheckStatus
		 */
		silencingRule?: Api.MonitorCheckStatusSilencingRule;
	}

	export interface MonitorCheckStatusApiError {
		message: string;
	}

	export interface MonitorCheckStatusComponent {
		/**
		 * @type {number}
		 * @memberof MonitorCheckStatusComponent
		 */
		id: number;
		identifier: string;
		name: string;
		type: string;
		icon?: string;
	}

	export interface MonitorCheckStatusHealthChange {
		/**
		 * @type {number}
		 * @memberof MonitorCheckStatusHealthChange
		 */
		timestamp: number;
		newHealth: Api.HealthStateValue;
	}

	export interface MonitorCheckStatusHealthHistory {
		identifier: string;
		/**
		 * @type {number}
		 * @memberof MonitorCheckStatusHealthHistory
		 */
		startTime: number;
		/**
		 * @type {number}
		 * @memberof MonitorCheckStatusHealthHistory
		 */
		endTime: number;
		/**
		 * @description <p>List of health state changes ordered from most recent to oldest.</p>
		 * @type {Api.MonitorCheckStatusHealthChange[]}
		 * @memberof MonitorCheckStatusHealthHistory
		 */
		healthStateChanges: Api.MonitorCheckStatusHealthChange[];
	}

	export interface MonitorCheckStatusMetric {
		_type: string;
		name: string;
		description?: string;
		unit?: string;
		step?: string;
		queries: Api.MonitorCheckStatusQuery[];
	}

	export interface MonitorCheckStatusNotFoundError {
		identifier: string;
		_type: Api.MonitorCheckStatusNotFoundError.TypeEnum;
	}
	
	/**
	 * @export
	 * @namespace MonitorCheckStatusNotFoundError
	 */
	export namespace MonitorCheckStatusNotFoundError {
		export enum TypeEnum {
			MonitorNotFoundError = 'MonitorNotFoundError'
		}
	
	}

	export interface MonitorCheckStatusQuery {
		query: string;
		alias?: string;
		componentIdentifierTemplate?: string;
	}

	export interface MonitorCheckStatusRelatedFailures {
		identifier: string;
		/**
		 * @type {number}
		 * @memberof MonitorCheckStatusRelatedFailures
		 */
		topologyTime: number;
		checkStatuses: Api.MonitorCheckStatusRelatedFailuresCheckStatus[];
	}

	export interface MonitorCheckStatusRelatedFailuresCheckStatus {
		identifier: string;
		health: Api.HealthStateValue;
		name: string;
		component: Api.MonitorCheckStatusComponent;
		topology: Api.MonitorCheckStatusRelatedFailuresTopology;
		/**
		 * @type {number}
		 * @memberof MonitorCheckStatusRelatedFailuresCheckStatus
		 */
		triggeredTimestamp: number;
	}

	export interface MonitorCheckStatusRelatedFailuresTopology {
		/**
		 * @type {number}
		 * @memberof MonitorCheckStatusRelatedFailuresTopology
		 */
		distance: number;
		relation: Api.MonitorCheckStatusRelatedFailuresTopology.RelationEnum;
	}
	
	/**
	 * @export
	 * @namespace MonitorCheckStatusRelatedFailuresTopology
	 */
	export namespace MonitorCheckStatusRelatedFailuresTopology {
		export enum RelationEnum {
			SELF = 'SELF',
			DEPENDENCY = 'DEPENDENCY',
			IMPACTED = 'IMPACTED',
			RELATED = 'RELATED'
		}
	
	}

	/**
	 * <p>Configured silencing rule on this check state id.</p>
	 */
	export interface MonitorCheckStatusSilencingRule {
		/**
		 * @description <p>The unique identifier (URN) of the silencing rule.</p>
		 * @type {string}
		 * @memberof MonitorCheckStatusSilencingRule
		 */
		identifier: string;
		/**
		 * @description <p>Human-readable reason for the silencing rule.</p>
		 * @type {string}
		 * @memberof MonitorCheckStatusSilencingRule
		 */
		note: string;
		/**
		 * @description <p>Unix epoch (seconds) at which the silencing rule expires.</p>
		 * @type {number}
		 * @memberof MonitorCheckStatusSilencingRule
		 */
		expiryEpochSeconds?: number;
	}

	export interface MonitorDefId {
		/**
		 * Value for discriminator in Api.MonitorReferenceId
		 */
		_type: 'MonitorDefId';
	
		/**
		 * @type {number}
		 * @memberof MonitorDefId
		 */
		id: number;
	}
	
	/**
	 * @export
	 * @namespace MonitorDefId
	 */
	export namespace MonitorDefId {
		export enum TypeEnum {
			MonitorDefId = 'MonitorDefId'
		}
	
	}

	export interface MonitorDisplayQuery {
		query: string;
		alias?: string;
		componentIdentifierTemplate?: string;
	}

	export interface MonitorDisplayTimeSeries {
		name: string;
		queries: Api.MonitorDisplayQuery[];
		description?: string;
		unit?: string;
	}

	export interface MonitorError {
		error: string;
		/**
		 * @type {number}
		 * @memberof MonitorError
		 */
		count: number;
		level: Api.MessageLevel;
	}

	export interface MonitorFunction {
		/**
		 * @type {number}
		 * @memberof MonitorFunction
		 */
		id: number;
		name: string;
		identifier?: string;
		description?: string;
		/**
		 * @type {number}
		 * @memberof MonitorFunction
		 */
		lastUpdateTimestamp: number;
	}

	export interface MonitorFunctionNotFoundError {
		monitorFunctionId: string;
		monitorFunctionIdType: Api.MonitorFunctionNotFoundError.MonitorFunctionIdTypeEnum;
		_type: Api.MonitorFunctionNotFoundError.TypeEnum;
	}
	
	/**
	 * @export
	 * @namespace MonitorFunctionNotFoundError
	 */
	export namespace MonitorFunctionNotFoundError {
		export enum MonitorFunctionIdTypeEnum {
			Id = 'id',
			Urn = 'urn'
		}
	
		export enum TypeEnum {
			MonitorFunctionNotFoundError = 'MonitorFunctionNotFoundError'
		}
	
	}

	export interface MonitorFunctionTest {
		arguments: Api.Argument[];
		/**
		 * @type {number}
		 * @memberof MonitorFunctionTest
		 */
		intervalSeconds: number;
	}

	export interface MonitorHealthState {
		id: string;
		state: Api.HealthStateValue;
		topologyIdentifier: string;
		displayTimeSeries?: Api.MonitorDisplayTimeSeries[];
		remediationHintTemplateData?: Api.MonitorHealthState.RemediationHintTemplateData;
		message?: string;
		reason?: string;
	}
	
	/**
	 * @export
	 * @namespace MonitorHealthState
	 */
	export namespace MonitorHealthState {
		export interface RemediationHintTemplateData {
		  // OpenAPI `type: object` without properties
		  [name: string]: unknown
		}
	
	}

	export interface MonitorIdentifierLookup {
		metricQuery: string;
		componentTypeName: string;
		/**
		 * @type {number}
		 * @memberof MonitorIdentifierLookup
		 */
		topN?: number;
		overrides?: Api.MonitorIdentifierLookup.Overrides;
	}
	
	/**
	 * @export
	 * @namespace MonitorIdentifierLookup
	 */
	export namespace MonitorIdentifierLookup {
		export interface Overrides {
			/**
			 * @type {number}
			 * @memberof Overrides
			 */
			components: number;
			/**
			 * @type {number}
			 * @memberof Overrides
			 */
			timeSeries: number;
		}
	
	}

	export interface MonitorIdentifierSuggestion {
		identifierTemplate: string;
		/**
		 * @type {number}
		 * @memberof MonitorIdentifierSuggestion
		 */
		score: number;
		/**
		 * @type {number}
		 * @memberof MonitorIdentifierSuggestion
		 */
		totalMatches: number;
	}

	export interface MonitorIdentifierSuggestions {
		suggestions: Api.MonitorIdentifierSuggestion[];
		/**
		 * @type {number}
		 * @memberof MonitorIdentifierSuggestions
		 */
		componentsInspected: number;
		/**
		 * @type {number}
		 * @memberof MonitorIdentifierSuggestions
		 */
		timeseriesInspected: number;
	}

	export interface MonitorInvalidIntervalError {
		/**
		 * Value for discriminator in Api.MonitorValidationError
		 */
		_type: 'MonitorInvalidIntervalError';
	
		/**
		 * @type {number}
		 * @memberof MonitorInvalidIntervalError
		 */
		intervalSeconds: number;
	}
	
	/**
	 * @export
	 * @namespace MonitorInvalidIntervalError
	 */
	export namespace MonitorInvalidIntervalError {
		export enum TypeEnum {
			MonitorInvalidIntervalError = 'MonitorInvalidIntervalError'
		}
	
	}

	export interface MonitorList {
		monitors: Api.Monitor[];
	}

	export interface MonitorMetrics {
		healthSyncServiceMetrics?: Api.HealthStreamMetrics;
		runtimeMetrics: Api.MonitorRuntimeMetrics;
	}

	export interface MonitorNotFoundError extends Api.BaseMonitorError {
		_type?: Api.MonitorNotFoundError.TypeEnum;
	}
	
	/**
	 * @export
	 * @namespace MonitorNotFoundError
	 */
	export namespace MonitorNotFoundError {
		export enum TypeEnum {
			MonitorNotFoundError = 'MonitorNotFoundError'
		}
	
	}

	export interface MonitorOverview {
		monitor: Api.Monitor;
		function: Api.MonitorFunction;
		errors?: Api.MonitorError[];
		runtimeMetrics: Api.MonitorRuntimeMetrics;
	}

	export interface MonitorOverviewList {
		monitors: Api.MonitorOverview[];
	}

	export interface MonitorPatch {
		name?: string;
		identifier?: string;
		description?: string;
		remediationHint?: string;
		/**
		 * @type {number}
		 * @memberof MonitorPatch
		 */
		intervalSeconds?: number;
		tags?: string[];
		/**
		 * @description <p>If a monitor status is set to DISABLED it won&#39;t produce any health states but it can still be run manually to inspect it&#39;s output</p>
		 * @type {Api.MonitorStatusValue}
		 * @memberof MonitorPatch
		 */
		status?: Api.MonitorStatusValue;
	}

	export interface MonitorPreview {
		arguments?: Api.Argument[];
		/**
		 * @type {number}
		 * @memberof MonitorPreview
		 */
		intervalSeconds?: number;
	}

	export interface MonitorPreviewComponentCount {
		/**
		 * @description <p>The number of unique identifiers for the total health state count. Only available when there non-empty identifiers.</p>
		 * @type {number}
		 * @memberof MonitorPreviewComponentCount
		 */
		uniqueIdentifiers: number;
		/**
		 * @description <p>The number of components for the identifiers: matchingComponents &lt;= uniqueIdentifiers. Only available when there non-empty identifiers.</p>
		 * @type {number}
		 * @memberof MonitorPreviewComponentCount
		 */
		matchingComponents: number;
	}

	export interface MonitorPreviewResult {
		/**
		 * @description <p>Representing the total count of the monitor results.</p>
		 * @type {number}
		 * @memberof MonitorPreviewResult
		 */
		healthStatesCount: number;
		/**
		 * @description <p>Representing the count of the monitor results that are UNKNOWN in the result.</p>
		 * @type {number}
		 * @memberof MonitorPreviewResult
		 */
		unknownCount: number;
		/**
		 * @description <p>Representing the count of the monitor results that are CLEAR in the result.</p>
		 * @type {number}
		 * @memberof MonitorPreviewResult
		 */
		clearCount: number;
		/**
		 * @description <p>Representing the count of the monitor results that are DEVIATING in the result.</p>
		 * @type {number}
		 * @memberof MonitorPreviewResult
		 */
		deviatingCount: number;
		/**
		 * @description <p>Representing the count of the monitor results that are CRITICAL in the result.</p>
		 * @type {number}
		 * @memberof MonitorPreviewResult
		 */
		criticalCount: number;
		componentCounts?: Api.MonitorPreviewComponentCount;
		errors: string[];
	}

	export type MonitorReferenceId = Api.MonitorDefId | Api.ExternalMonitorDefId;

	export interface MonitorRunResult {
		result: Api.MonitorRunResult.Result;
	}
	
	/**
	 * @export
	 * @namespace MonitorRunResult
	 */
	export namespace MonitorRunResult {
		export interface Result {
		  // OpenAPI `type: object` without properties
		  [name: string]: unknown
		}
	
	}

	export interface MonitorRuntimeMetrics {
		/**
		 * @description <p>Representing the total count of the monitor results.</p>
		 * @type {number}
		 * @memberof MonitorRuntimeMetrics
		 */
		healthStatesCount?: number;
		/**
		 * @description <p>Representing the total count of the monitor results that are not mapped to topology.</p>
		 * @type {number}
		 * @memberof MonitorRuntimeMetrics
		 */
		unmappedHealthStatesCount?: number;
		/**
		 * @description <p>Representing the count of the monitor results that are UNKNOWN and are mapped to topology.</p>
		 * @type {number}
		 * @memberof MonitorRuntimeMetrics
		 */
		unknownCount?: number;
		/**
		 * @description <p>Representing the count of the monitor results that are CLEAR and are mapped to topology.</p>
		 * @type {number}
		 * @memberof MonitorRuntimeMetrics
		 */
		clearCount?: number;
		/**
		 * @description <p>Representing the count of the monitor results that are DEVIATING and are mapped to topology.</p>
		 * @type {number}
		 * @memberof MonitorRuntimeMetrics
		 */
		deviatingCount?: number;
		/**
		 * @description <p>Representing the count of the monitor results that are CRITICAL and are mapped to topology.</p>
		 * @type {number}
		 * @memberof MonitorRuntimeMetrics
		 */
		criticalCount?: number;
		/**
		 * @description <p>Representing the epoch millis of the last monitor run.</p>
		 * @type {number}
		 * @memberof MonitorRuntimeMetrics
		 */
		lastRunTimestamp?: number;
		/**
		 * @description <p>Representing the epoch millis of the last monitor successful run.</p>
		 * @type {number}
		 * @memberof MonitorRuntimeMetrics
		 */
		lastSuccessfulRunTimestamp?: number;
		/**
		 * @description <p>Representing the epoch millis of the last monitor failed run.</p>
		 * @type {number}
		 * @memberof MonitorRuntimeMetrics
		 */
		lastFailedRunTimestamp?: number;
	}

	export enum MonitorRuntimeStatusValue {
		ENABLED = 'ENABLED',
		DISABLED = 'DISABLED',
		ERROR = 'ERROR',
		WARNING = 'WARNING'
	}

	export interface MonitorSnapshot {
		firstBatch?: boolean;
		lastBatch?: boolean;
		healthStates: Api.MonitorHealthState[];
	}

	export interface MonitorStatus {
		monitor: Api.Monitor;
		function: Api.MonitorFunction;
		errors?: Api.MonitorError[];
		metrics: Api.MonitorMetrics;
		topologyMatchResult?: Api.TopologyMatchResult;
	}

	/**
	 * <p>If a monitor status is set to DISABLED it won&#39;t produce any health states but it can still be run manually to inspect it&#39;s output</p>
	 */
	export enum MonitorStatusValue {
		ENABLED = 'ENABLED',
		DISABLED = 'DISABLED'
	}

	export type MonitorValidationError = Api.MonitorInvalidIntervalError | Api.InvalidMonitorIdentifierError;

	export interface MultipleMatchesCheckState {
		checkStateId: string;
		topologyElementIdentifier: string;
		/**
		 * @type {number}
		 * @memberof MultipleMatchesCheckState
		 */
		matchCount: number;
	}

	export interface NewLicense {
		key: string;
	}

	export interface NewServiceTokenRequest {
		name: string;
		/**
		 * @type {number}
		 * @memberof NewServiceTokenRequest
		 */
		expiryDate?: number;
		roles: string[];
		dedicatedSubject?: string;
	}

	export interface Node {
		typeName: string;
		/**
		 * @type {number}
		 * @memberof Node
		 */
		id: number;
		/**
		 * @type {number}
		 * @memberof Node
		 */
		lastUpdateTimestamp: number;
		identifier?: string;
		name?: string;
		description?: string;
		ownedBy?: string;
		manual?: boolean;
		isSettingsNode?: boolean;
	}

	export interface NodeLocked {
		/**
		 * Value for discriminator in Api.LockedResponse
		 */
		_type: 'NodeLocked';
	
		owner: string;
	}
	
	/**
	 * @export
	 * @namespace NodeLocked
	 */
	export namespace NodeLocked {
		export enum TypeEnum {
			NodeLocked = 'NodeLocked'
		}
	
	}

	export interface NodeName {
		name: string;
	}

	export interface NodeTypes {
		nodeTypes: Api.NodeTypes.NodeType[];
	}
	
	/**
	 * @export
	 * @namespace NodeTypes
	 */
	export namespace NodeTypes {
		export interface NodeType {
			typeName: string;
			description: string;
		}
	
	}

	export interface NodeUnlocked {
		/**
		 * Value for discriminator in Api.LockedResponse
		 */
		_type: 'NodeUnlocked';
	
	  // OpenAPI `type: object` without properties
	  [name: string]: unknown
	}
	
	/**
	 * @export
	 * @namespace NodeUnlocked
	 */
	export namespace NodeUnlocked {
		export enum TypeEnum {
			NodeUnlocked = 'NodeUnlocked'
		}
	
	}

	export type NotificationChannel = Api.SlackNotificationChannel | Api.WebhookNotificationChannel | Api.OpsgenieNotificationChannel | Api.TeamsNotificationChannel | Api.EmailNotificationChannel;

	export interface NotificationChannelError {
		message: string;
		channelId: string;
		_type: Api.NotificationChannelError.TypeEnum;
	}
	
	/**
	 * @export
	 * @namespace NotificationChannelError
	 */
	export namespace NotificationChannelError {
		export enum TypeEnum {
			NotificationChannelError = 'NotificationChannelError'
		}
	
	}

	export interface NotificationChannelNotFound {
		message: string;
		channelId: string;
		_type: Api.NotificationChannelNotFound.TypeEnum;
	}
	
	/**
	 * @export
	 * @namespace NotificationChannelNotFound
	 */
	export namespace NotificationChannelNotFound {
		export enum TypeEnum {
			NotificationChannelNotFound = 'NotificationChannelNotFound'
		}
	
	}

	export interface NotificationChannelStatus {
		errors: Api.NotificationChannelStatusError[];
	}

	export interface NotificationChannelStatusError {
		category: string;
		/**
		 * @type {number}
		 * @memberof NotificationChannelStatusError
		 */
		count: number;
		message: string;
		/**
		 * @type {number}
		 * @memberof NotificationChannelStatusError
		 */
		firstSeenMs: number;
	}

	export type NotificationConfigurationByIdErrors = Api.NotificationConfigurationError | Api.InvalidNotificationConfigurationIdentifier;

	export interface NotificationConfigurationError {
		/**
		 * Value for discriminator in Api.NotificationConfigurationByIdErrors
		 */
		_type: 'NotificationConfigurationError';
	
		message: string;
	}
	
	/**
	 * @export
	 * @namespace NotificationConfigurationError
	 */
	export namespace NotificationConfigurationError {
		export enum TypeEnum {
			NotificationConfigurationError = 'NotificationConfigurationError'
		}
	
	}

	export interface NotificationConfigurationNotFound {
		message: string;
		notificationConfigurationIdOrUrn: string;
		_type: Api.NotificationConfigurationNotFound.TypeEnum;
	}
	
	/**
	 * @export
	 * @namespace NotificationConfigurationNotFound
	 */
	export namespace NotificationConfigurationNotFound {
		export enum TypeEnum {
			NotificationConfigurationNotFound = 'NotificationConfigurationNotFound'
		}
	
	}

	export interface NotificationConfigurationReadSchema extends Api.NotificationConfigurationWriteSchema {
		/**
		 * @type {number}
		 * @memberof NotificationConfigurationReadSchema
		 */
		id: number;
		/**
		 * @type {number}
		 * @memberof NotificationConfigurationReadSchema
		 */
		lastUpdateTimestamp: number;
		runtimeStatus: Api.NotificationConfigurationRuntimeStatusValue;
	}

	export enum NotificationConfigurationRuntimeStatusValue {
		ERROR = 'ERROR',
		WARNING = 'WARNING',
		OK = 'OK'
	}

	export enum NotificationConfigurationStatusValue {
		ENABLED = 'ENABLED',
		DISABLED = 'DISABLED'
	}

	export interface NotificationConfigurationWriteSchema {
		name: string;
		identifier?: string;
		description?: string;
		notifyHealthStates: Api.NotifyOnOptions;
		monitors: Api.MonitorReferenceId[];
		monitorTags: string[];
		componentTypeNames: string[];
		componentTags: string[];
		status: Api.NotificationConfigurationStatusValue;
		notificationChannels: Api.ChannelReferenceId[];
	}

	export enum NotifyOnOptions {
		CRITICAL = 'CRITICAL',
		DEVIATINGANDCRITICAL = 'DEVIATING_AND_CRITICAL'
	}

	export interface NumericCell {
		/**
		 * Value for discriminator in Api.CellValue
		 */
		_type: 'NumericCell';
	
		/**
		 * @type {number}
		 * @memberof NumericCell
		 */
		value?: number;
	}
	
	/**
	 * @export
	 * @namespace NumericCell
	 */
	export namespace NumericCell {
		export enum TypeEnum {
			NumericCell = 'NumericCell'
		}
	
	}

	export interface NumericField extends Api.BaseComponentField {
		/**
		 * Value for discriminator in Api.ComponentField
		 */
		_type: 'NumericField';
	
		/**
		 * @type {number}
		 * @memberof NumericField
		 */
		value: number;
		unit?: string;
		/**
		 * @type {number}
		 * @memberof NumericField
		 */
		decimalPlaces?: number;
	}
	
	/**
	 * @export
	 * @namespace NumericField
	 */
	export namespace NumericField {
		export enum TypeEnum {
			NumericField = 'NumericField'
		}
	
	}

	export interface NumericMetaDisplay {
		/**
		 * Value for discriminator in Api.OverviewColumnMetaDisplay
		 */
		_type: 'NumericMetaDisplay';
	
		unit?: string | null;
	}
	
	/**
	 * @export
	 * @namespace NumericMetaDisplay
	 */
	export namespace NumericMetaDisplay {
		export enum TypeEnum {
			NumericMetaDisplay = 'NumericMetaDisplay'
		}
	
	}

	export interface NumericProjection {
		/**
		 * Value for discriminator in Api.ComponentOverviewProjection
		 */
		_type: 'NumericProjection';
	
		/**
		 * @description <p>Cel expression that returns a number</p>
		 * @type {string}
		 * @memberof NumericProjection
		 */
		value: string;
		unit?: string | null;
		/**
		 * @type {number}
		 * @memberof NumericProjection
		 */
		decimalPlaces?: number;
	}
	
	/**
	 * @export
	 * @namespace NumericProjection
	 */
	export namespace NumericProjection {
		export enum TypeEnum {
			NumericProjection = 'NumericProjection'
		}
	
	}

	export interface OpsgenieChannelRefId {
		/**
		 * Value for discriminator in Api.ChannelReferenceId
		 */
		_type: 'OpsgenieChannelRefId';
	
		/**
		 * @type {number}
		 * @memberof OpsgenieChannelRefId
		 */
		id: number;
	}
	
	/**
	 * @export
	 * @namespace OpsgenieChannelRefId
	 */
	export namespace OpsgenieChannelRefId {
		export enum TypeEnum {
			OpsgenieChannelRefId = 'OpsgenieChannelRefId'
		}
	
	}

	export interface OpsgenieChannelWriteSchema {
		region: Api.OpsgenieRegion;
		genieKey: string;
		responders: Api.OpsgenieResponder[];
		priority: Api.OpsgeniePriority;
	}

	export interface OpsgenieNotificationChannel extends Api.BaseNotificationChannel, Api.OpsgenieChannelWriteSchema {
		/**
		 * Value for discriminator in Api.NotificationChannel
		 */
		_type: 'OpsgenieNotificationChannel';
	
	  // OpenAPI `type: object` without properties
	  [name: string]: unknown
	}
	
	/**
	 * @export
	 * @namespace OpsgenieNotificationChannel
	 */
	export namespace OpsgenieNotificationChannel {
		export enum TypeEnum {
			OpsgenieNotificationChannel = 'OpsgenieNotificationChannel'
		}
	
	}

	export enum OpsgeniePriority {
		P1 = 'P1',
		P2 = 'P2',
		P3 = 'P3',
		P4 = 'P4',
		P5 = 'P5'
	}

	export enum OpsgenieRegion {
		EU = 'EU',
		US = 'US'
	}

	export interface OpsgenieResponder {
		responderType: Api.OpsgenieResponderType;
		responder: string;
	}

	export enum OpsgenieResponderType {
		TEAM = 'TEAM',
		USER = 'USER',
		SCHEDULE = 'SCHEDULE',
		ESCALATION = 'ESCALATION'
	}

	export interface OrderedComponentPresentationMetric extends Api.ComponentPresentationMetric {
		/**
		 * @type {number}
		 * @memberof OrderedComponentPresentationMetric
		 */
		order?: number;
	}

	export interface OtelComponentMapping {
		_type: Api.OtelComponentMapping.TypeEnum;
		identifier: string;
		name: string;
		description?: string;
		/**
		 * @description <p>Combines input signals and conditional resource/scope/metric/span mappings.</p>
		 * @type {Api.OtelInput}
		 * @memberof OtelComponentMapping
		 */
		input: Api.OtelInput;
		output: Api.OtelComponentMappingOutput;
		vars?: Api.OtelVariableMapping[];
		/**
		 * @type {number}
		 * @memberof OtelComponentMapping
		 */
		expireAfter: number;
		rank: Api.OtelComponentMappingRank;
	}
	
	/**
	 * @export
	 * @namespace OtelComponentMapping
	 */
	export namespace OtelComponentMapping {
		export enum TypeEnum {
			OtelComponentMapping = 'OtelComponentMapping'
		}
	
	}

	export interface OtelComponentMappingFieldMapping {
		additionalIdentifiers?: string[];
		/**
		 * @description <p>An expression that must produce a string. It must be one of these formats:</p>
		 *  <ul>
		 *  <li>A plain string, for example <code>&quot;this is a plain string&quot;</code></li>
		 *  <li>A cel expression that must return a string, for example: <code>resource.attributes[&#39;service.namespace&#39;]</code></li>
		 *  </ul>
		 * @type {string}
		 * @memberof OtelComponentMappingFieldMapping
		 */
		version?: string;
		tags?: Api.OtelTagMapping[];
		/**
		 * @description <p>A CEL expression that resolves to a map representing the full configuration of the component. The result is stored and displayed as-is. Typically maps to the entire input object (e.g. <code>log.body</code>) or a sub-object such as <code>log.body[&#39;spec&#39;]</code>. Use the <code>omit()</code> helper to exclude keys that should not be part of the configuration (e.g. <code>omit(log.body, [&#39;status&#39;, &#39;managedFields&#39;])</code>). Or, inversely, use the <code>pick()</code> helper to only include specific keys (e.g. <code>pick(log.body, [&#39;spec&#39;])</code>).</p>
		 * @type {string}
		 * @memberof OtelComponentMappingFieldMapping
		 */
		configuration?: string;
		/**
		 * @description <p>A CEL expression that resolves to a map representing the current status of the component. The result is stored and displayed as-is, separate from the configuration.  Typically maps to a status sub-object of the input (e.g. <code>log.body[&#39;status&#39;]</code>).  Note: component health state (CLEAR / DEVIATING / CRITICAL) is not derived from this field — it is determined downstream by monitors configured on the component.</p>
		 * @type {string}
		 * @memberof OtelComponentMappingFieldMapping
		 */
		status?: string;
	}

	export interface OtelComponentMappingOutput {
		/**
		 * @description <p>An expression that must produce a string. It must be one of these formats:</p>
		 *  <ul>
		 *  <li>A plain string, for example <code>&quot;this is a plain string&quot;</code></li>
		 *  <li>A cel expression that must return a string, for example: <code>resource.attributes[&#39;service.namespace&#39;]</code></li>
		 *  </ul>
		 * @type {string}
		 * @memberof OtelComponentMappingOutput
		 */
		identifier: string;
		/**
		 * @description <p>An expression that must produce a string. It must be one of these formats:</p>
		 *  <ul>
		 *  <li>A plain string, for example <code>&quot;this is a plain string&quot;</code></li>
		 *  <li>A cel expression that must return a string, for example: <code>resource.attributes[&#39;service.namespace&#39;]</code></li>
		 *  </ul>
		 * @type {string}
		 * @memberof OtelComponentMappingOutput
		 */
		name: string;
		/**
		 * @description <p>An expression that must produce a string. It must be one of these formats:</p>
		 *  <ul>
		 *  <li>A plain string, for example <code>&quot;this is a plain string&quot;</code></li>
		 *  <li>A cel expression that must return a string, for example: <code>resource.attributes[&#39;service.namespace&#39;]</code></li>
		 *  </ul>
		 * @type {string}
		 * @memberof OtelComponentMappingOutput
		 */
		typeName: string;
		required?: Api.OtelComponentMappingFieldMapping;
		optional?: Api.OtelComponentMappingFieldMapping;
	}

	export interface OtelComponentMappingRank {
		/**
		 * @description <p>Determines how much of a &quot;specialization&quot; this mapping is. Higher number means more specific. Used during component merge to pick the winning typeName / name when multiple mappings contribute to the same component identifier. Recommended ranges: 1–99 environment &amp; infrastructure; 100–199 platform &amp; orchestration (k8s, otel base); 200–299 application / service; 300–399 runtime / SDK / language; 400+ user overrides.</p>
		 * @type {number}
		 * @memberof OtelComponentMappingRank
		 */
		specificity: number;
	}

	export interface OtelComponentMappingUpsertRequest {
		identifier: string;
		name: string;
		description?: string;
		/**
		 * @description <p>Combines input signals and conditional resource/scope/metric/span mappings.</p>
		 * @type {Api.OtelInput}
		 * @memberof OtelComponentMappingUpsertRequest
		 */
		input: Api.OtelInput;
		output: Api.OtelComponentMappingOutput;
		vars?: Api.OtelVariableMapping[];
		/**
		 * @type {number}
		 * @memberof OtelComponentMappingUpsertRequest
		 */
		expireAfter: number;
		rank: Api.OtelComponentMappingRank;
	}

	/**
	 * <p>Combines input signals and conditional resource/scope/metric/span mappings.</p>
	 */
	export interface OtelInput {
		signal: Api.OtelInputSignal[];
		/**
		 * @description <p>Defines the conditional mapping at the resource level.
		 *  If omitted, <code>condition</code> defaults to <code>true</code> and <code>action</code> defaults to <code>CONTINUE</code>.</p>
		 * @type {Api.OtelInputResource}
		 * @memberof OtelInput
		 */
		resource: Api.OtelInputResource;
	}

	/**
	 * <p>Defines conditional mapping at the resource -&gt; scope -&gt; metric -&gt; datapoint level.
	 * If omitted, <code>condition</code> defaults to <code>true</code> and <code>action</code> defaults to <code>CONTINUE</code>.</p>
	 */
	export interface OtelInputDatapoint {
		/**
		 * @description <p>A Cel expression that must return a boolean</p>
		 * @type {string}
		 * @memberof OtelInputDatapoint
		 */
		condition?: string;
		/**
		 * @description <p>A CEL expression that must evaluate to one of the valid OtelInputConditionAction values: <code>CREATE</code> or <code>CONTINUE</code>.
		 *  Can be a simple literal (e.g. <code>&#39;CREATE&#39;</code>) or a CEL expression (e.g. <code>condition ? &#39;CREATE&#39; : &#39;CONTINUE&#39;</code>).
		 *  If omitted, defaults to <code>CONTINUE</code>.</p>
		 * @type {string}
		 * @memberof OtelInputDatapoint
		 */
		action?: string;
	}

	/**
	 * <p>Defines conditional mapping at the resource -&gt; scope -&gt; log level.
	 * If omitted, <code>condition</code> defaults to <code>true</code> and <code>action</code> defaults to <code>CONTINUE</code>.</p>
	 */
	export interface OtelInputLog {
		/**
		 * @description <p>A Cel expression that must return a boolean</p>
		 * @type {string}
		 * @memberof OtelInputLog
		 */
		condition?: string;
		/**
		 * @description <p>A CEL expression that must evaluate to one of the valid OtelInputConditionAction values: <code>CREATE</code>, <code>CONTINUE</code>, or <code>DELETE</code>.
		 *  The <code>DELETE</code> action is only valid at the log level.
		 *  Can be a simple literal (e.g. <code>&#39;CREATE&#39;</code>) or a CEL expression
		 *  (e.g. <code>(log.body[&#39;type&#39;] == &#39;ADDED&#39;) ? &#39;CREATE&#39; : (log.body[&#39;type&#39;] == &#39;DELETED&#39; ? &#39;DELETE&#39; : &#39;CONTINUE&#39;)</code>).
		 *  If omitted, defaults to <code>CONTINUE</code>.</p>
		 * @type {string}
		 * @memberof OtelInputLog
		 */
		action?: string;
	}

	/**
	 * <p>Defines conditional mapping at the resource -&gt; scope -&gt; metric level.
	 * If omitted, <code>condition</code> defaults to <code>true</code> and <code>action</code> defaults to <code>CONTINUE</code>.</p>
	 */
	export interface OtelInputMetric {
		/**
		 * @description <p>A Cel expression that must return a boolean</p>
		 * @type {string}
		 * @memberof OtelInputMetric
		 */
		condition?: string;
		/**
		 * @description <p>A CEL expression that must evaluate to one of the valid OtelInputConditionAction values: <code>CREATE</code> or <code>CONTINUE</code>.
		 *  Can be a simple literal (e.g. <code>&#39;CREATE&#39;</code>) or a CEL expression (e.g. <code>condition ? &#39;CREATE&#39; : &#39;CONTINUE&#39;</code>).
		 *  If omitted, defaults to <code>CONTINUE</code>.</p>
		 * @type {string}
		 * @memberof OtelInputMetric
		 */
		action?: string;
		/**
		 * @description <p>Defines conditional mapping at the resource -&gt; scope -&gt; metric -&gt; datapoint level.
		 *  If omitted, <code>condition</code> defaults to <code>true</code> and <code>action</code> defaults to <code>CONTINUE</code>.</p>
		 * @type {Api.OtelInputDatapoint}
		 * @memberof OtelInputMetric
		 */
		datapoint?: Api.OtelInputDatapoint;
	}

	/**
	 * <p>Defines the conditional mapping at the resource level.
	 * If omitted, <code>condition</code> defaults to <code>true</code> and <code>action</code> defaults to <code>CONTINUE</code>.</p>
	 */
	export interface OtelInputResource {
		/**
		 * @description <p>A Cel expression that must return a boolean</p>
		 * @type {string}
		 * @memberof OtelInputResource
		 */
		condition?: string;
		/**
		 * @description <p>A CEL expression that must evaluate to one of the valid OtelInputConditionAction values: <code>CREATE</code> or <code>CONTINUE</code>.
		 *  Can be a simple literal (e.g. <code>&#39;CREATE&#39;</code>) or a CEL expression (e.g. <code>condition ? &#39;CREATE&#39; : &#39;CONTINUE&#39;</code>).
		 *  If omitted, defaults to <code>CONTINUE</code>.</p>
		 * @type {string}
		 * @memberof OtelInputResource
		 */
		action?: string;
		/**
		 * @description <p>Defines conditional mapping at the resource -&gt; scope level.
		 *  If omitted, <code>condition</code> defaults to <code>true</code> and <code>action</code> defaults to <code>CONTINUE</code>.</p>
		 * @type {Api.OtelInputScope}
		 * @memberof OtelInputResource
		 */
		scope?: Api.OtelInputScope;
	}

	/**
	 * <p>Defines conditional mapping at the resource -&gt; scope level.
	 * If omitted, <code>condition</code> defaults to <code>true</code> and <code>action</code> defaults to <code>CONTINUE</code>.</p>
	 */
	export interface OtelInputScope {
		/**
		 * @description <p>A Cel expression that must return a boolean</p>
		 * @type {string}
		 * @memberof OtelInputScope
		 */
		condition?: string;
		/**
		 * @description <p>A CEL expression that must evaluate to one of the valid OtelInputConditionAction values: <code>CREATE</code> or <code>CONTINUE</code>.
		 *  Can be a simple literal (e.g. <code>&#39;CREATE&#39;</code>) or a CEL expression (e.g. <code>condition ? &#39;CREATE&#39; : &#39;CONTINUE&#39;</code>).
		 *  If omitted, defaults to <code>CONTINUE</code>.</p>
		 * @type {string}
		 * @memberof OtelInputScope
		 */
		action?: string;
		/**
		 * @description <p>Defines conditional mapping at the resource -&gt; scope -&gt; metric level.
		 *  If omitted, <code>condition</code> defaults to <code>true</code> and <code>action</code> defaults to <code>CONTINUE</code>.</p>
		 * @type {Api.OtelInputMetric}
		 * @memberof OtelInputScope
		 */
		metric?: Api.OtelInputMetric;
		/**
		 * @description <p>Defines conditional mapping at the resource -&gt; scope -&gt; span level.
		 *  If omitted, <code>condition</code> defaults to <code>true</code> and <code>action</code> defaults to <code>CONTINUE</code>.</p>
		 * @type {Api.OtelInputSpan}
		 * @memberof OtelInputScope
		 */
		span?: Api.OtelInputSpan;
		/**
		 * @description <p>Defines conditional mapping at the resource -&gt; scope -&gt; log level.
		 *  If omitted, <code>condition</code> defaults to <code>true</code> and <code>action</code> defaults to <code>CONTINUE</code>.</p>
		 * @type {Api.OtelInputLog}
		 * @memberof OtelInputScope
		 */
		log?: Api.OtelInputLog;
	}

	/**
	 * <p>Signals exported by OpenTelemetry, which determine which data models and
	 * attribute maps are available for expression evaluation in an OTel topology
	 * mapping.</p>
	 * <p>Each signal enables access to a specific set of fields and attribute maps
	 * coming from the corresponding OTel data pipeline level.</p>
	 * <p>Fields/attributes available per signal:</p>
	 * <p>  • <strong>TRACES</strong>
	 *   Provides access to:
	 *     - <code>resource.attributes</code>
	 *     - <code>scope.name</code>, <code>scope.version</code>, <code>scope.attributes</code>
	 *     - <code>span.name</code>, <code>span.kind</code>, <code>span.statusMessage</code>, <code>span.statusCode</code>, <code>span.attributes</code></p>
	 * <p>  • <strong>METRICS</strong>
	 *   Provides access to:
	 *     - <code>resource.attributes</code>
	 *     - <code>scope.name</code>, <code>scope.version</code>, <code>scope.attributes</code>
	 *     - <code>metric.name</code>, <code>metric.description</code>, <code>metric.unit</code>
	 *     - <code>datapoint.attributes</code></p>
	 * <p>  • <strong>LOGS</strong>
	 *   Provides access to:
	 *     - <code>resource.attributes</code>
	 *     - <code>scope.name</code>, <code>scope.version</code>, <code>scope.attributes</code>
	 *     - <code>log.eventName</code>, <code>log.attributes</code>, <code>log.body</code></p>
	 * <p>For example, if the signal is <code>METRICS</code>, expressions may reference:
	 * <code>resource.attributes[&quot;service.name&quot;]</code>, <code>scope.attributes[&quot;env&quot;]</code>,
	 * <code>metric.name</code>, or <code>datapoint.attributes[&quot;status&quot;]</code>.</p>
	 */
	export enum OtelInputSignal {
		TRACES = 'TRACES',
		METRICS = 'METRICS',
		LOGS = 'LOGS'
	}

	/**
	 * <p>Defines conditional mapping at the resource -&gt; scope -&gt; span level.
	 * If omitted, <code>condition</code> defaults to <code>true</code> and <code>action</code> defaults to <code>CONTINUE</code>.</p>
	 */
	export interface OtelInputSpan {
		/**
		 * @description <p>A Cel expression that must return a boolean</p>
		 * @type {string}
		 * @memberof OtelInputSpan
		 */
		condition?: string;
		/**
		 * @description <p>A CEL expression that must evaluate to one of the valid OtelInputConditionAction values: <code>CREATE</code> or <code>CONTINUE</code>.
		 *  Can be a simple literal (e.g. <code>&#39;CREATE&#39;</code>) or a CEL expression (e.g. <code>condition ? &#39;CREATE&#39; : &#39;CONTINUE&#39;</code>).
		 *  If omitted, defaults to <code>CONTINUE</code>.</p>
		 * @type {string}
		 * @memberof OtelInputSpan
		 */
		action?: string;
	}

	export interface OtelMappingApiError {
		message: string;
	}

	export interface OtelMappingError {
		level: Api.MessageLevel;
		message: string;
		issueId?: string;
	}

	export interface OtelMappingItem {
		name: string;
		identifier?: string;
	}

	export interface OtelMappingMetrics {
		/**
		 * @type {number}
		 * @memberof OtelMappingMetrics
		 */
		bucketSizeSeconds: number;
		latencySeconds?: Api.MetricBucketValue3[];
	}

	export interface OtelMappingStatus {
		item: Api.OtelMappingStatusItem;
		errorDetails: Api.OtelMappingError[];
		metrics?: Api.OtelMappingMetrics;
	}

	export interface OtelMappingStatusItem {
		name: string;
		identifier?: string;
		/**
		 * @type {number}
		 * @memberof OtelMappingStatusItem
		 */
		relationCount: number;
		/**
		 * @type {number}
		 * @memberof OtelMappingStatusItem
		 */
		componentCount: number;
	}

	export interface OtelRelationMapping {
		_type: Api.OtelRelationMapping.TypeEnum;
		identifier: string;
		name: string;
		description?: string;
		/**
		 * @description <p>Combines input signals and conditional resource/scope/metric/span mappings.</p>
		 * @type {Api.OtelInput}
		 * @memberof OtelRelationMapping
		 */
		input: Api.OtelInput;
		output: Api.OtelRelationMappingOutput;
		vars?: Api.OtelVariableMapping[];
		/**
		 * @type {number}
		 * @memberof OtelRelationMapping
		 */
		expireAfter: number;
	}
	
	/**
	 * @export
	 * @namespace OtelRelationMapping
	 */
	export namespace OtelRelationMapping {
		export enum TypeEnum {
			OtelRelationMapping = 'OtelRelationMapping'
		}
	
	}

	export interface OtelRelationMappingOutput {
		/**
		 * @description <p>An expression that must produce a string. It must be one of these formats:</p>
		 *  <ul>
		 *  <li>A plain string, for example <code>&quot;this is a plain string&quot;</code></li>
		 *  <li>A cel expression that must return a string, for example: <code>resource.attributes[&#39;service.namespace&#39;]</code></li>
		 *  </ul>
		 * @type {string}
		 * @memberof OtelRelationMappingOutput
		 */
		sourceId: string;
		/**
		 * @description <p>An expression that must produce a string. It must be one of these formats:</p>
		 *  <ul>
		 *  <li>A plain string, for example <code>&quot;this is a plain string&quot;</code></li>
		 *  <li>A cel expression that must return a string, for example: <code>resource.attributes[&#39;service.namespace&#39;]</code></li>
		 *  </ul>
		 * @type {string}
		 * @memberof OtelRelationMappingOutput
		 */
		targetId: string;
		/**
		 * @description <p>An expression that must produce a string. It must be one of these formats:</p>
		 *  <ul>
		 *  <li>A plain string, for example <code>&quot;this is a plain string&quot;</code></li>
		 *  <li>A cel expression that must return a string, for example: <code>resource.attributes[&#39;service.namespace&#39;]</code></li>
		 *  </ul>
		 * @type {string}
		 * @memberof OtelRelationMappingOutput
		 */
		typeName: string;
		/**
		 * @description <p>An expression that must produce a string. It must be one of these formats:</p>
		 *  <ul>
		 *  <li>A plain string, for example <code>&quot;this is a plain string&quot;</code></li>
		 *  <li>A cel expression that must return a string, for example: <code>resource.attributes[&#39;service.namespace&#39;]</code></li>
		 *  </ul>
		 * @type {string}
		 * @memberof OtelRelationMappingOutput
		 */
		dependencyType: string;
	}

	export interface OtelRelationmappingUpsertRequest {
		identifier: string;
		name: string;
		description?: string;
		/**
		 * @description <p>Combines input signals and conditional resource/scope/metric/span mappings.</p>
		 * @type {Api.OtelInput}
		 * @memberof OtelRelationmappingUpsertRequest
		 */
		input: Api.OtelInput;
		output: Api.OtelRelationMappingOutput;
		vars?: Api.OtelVariableMapping[];
		/**
		 * @type {number}
		 * @memberof OtelRelationmappingUpsertRequest
		 */
		expireAfter: number;
	}

	/**
	 * <p>Defines how a tag should be mapped from an input source to an output target, optionally using a regex pattern.</p>
	 */
	export interface OtelTagMapping {
		/**
		 * @description <p>When a <code>pattern</code> is specified the expression must return a Map, when no <code>pattern</code> is specified the expression must return a string.</p>
		 * @type {string}
		 * @memberof OtelTagMapping
		 */
		source: string;
		/**
		 * @description <p>Name of the target tag key to which the value should be mapped.</p>
		 * @type {string}
		 * @memberof OtelTagMapping
		 */
		target: string;
		/**
		 * @description <p>Optional regex pattern applied to the source value. Capturing groups can be referenced in the target (e.g., ${1}).</p>
		 * @type {string}
		 * @memberof OtelTagMapping
		 */
		pattern?: string;
	}

	export interface OtelVariableMapping {
		name: string;
		/**
		 * @description <p>An expression that can produce any type. 
		 *  Variables use it to store any type of value. For example, to store a boolean in a variable named  <code>inTestNamespace</code> assign
		 *  it the expression <code>resource.attributes[&#39;service.namespace&#39;] == &#39;test&#39;</code>. The variable can now be used directly in the conditions like this: <code>vars.inTestNamespace</code>.</p>
		 * @type {string}
		 * @memberof OtelVariableMapping
		 */
		value: string;
	}

	/**
	 * <p>Definition of a column in the overview presentation. The <code>columnId</code> field is used to identify the column and merge columns from different presentations. If only the <code>columnId</code> is provided, the column will be rendered from the next more specific presentation definition.</p>
	 */
	export interface OverviewColumnDefinition {
		columnId: string;
		title?: string;
		/**
		 * @description <p>Display type and value for the field.</p>
		 * @type {Api.ComponentOverviewProjection}
		 * @memberof OverviewColumnDefinition
		 */
		projection?: Api.ComponentOverviewProjection;
	}

	export interface OverviewColumnFilter {
		columnId: string;
		search: string;
	}

	export interface OverviewColumnMeta {
		columnId: string;
		title: string;
		display: Api.OverviewColumnMetaDisplay;
		sortable: boolean;
		searchable: boolean;
		/**
		 * @type {number}
		 * @memberof OverviewColumnMeta
		 */
		order: number;
	}

	export type OverviewColumnMetaDisplay = Api.MetricMetaDisplay | Api.ComponentLinkMetaDisplay | Api.HealthMetaDisplay | Api.TextMetaDisplay | Api.NumericMetaDisplay | Api.DurationMetaDisplay | Api.ReadyStatusMetaDisplay | Api.LinkMetaDisplay;

	export interface OverviewDataUnavailable {
		/**
		 * Value for discriminator in Api.OverviewPageResponse
		 */
		_type: 'OverviewDataUnavailable';
	
		/**
		 * @description <p>Time when data became unavailable (epoch ms).</p>
		 * @type {number}
		 * @memberof OverviewDataUnavailable
		 */
		unavailableAtEpochMs: number;
		/**
		 * @description <p>Time when data became available again (epoch ms).</p>
		 * @type {number}
		 * @memberof OverviewDataUnavailable
		 */
		availableSinceEpochMs: number;
	}
	
	/**
	 * @export
	 * @namespace OverviewDataUnavailable
	 */
	export namespace OverviewDataUnavailable {
		export enum TypeEnum {
			OverviewDataUnavailable = 'OverviewDataUnavailable'
		}
	
	}

	export interface OverviewErrorResponse {
		_type: Api.OverviewErrorResponse.TypeEnum;
		/**
		 * @description <p>Error message describing why the overview request failed.</p>
		 * @type {string}
		 * @memberof OverviewErrorResponse
		 */
		errorMessage: string;
	}
	
	/**
	 * @export
	 * @namespace OverviewErrorResponse
	 */
	export namespace OverviewErrorResponse {
		export enum TypeEnum {
			OverviewErrorResponse = 'OverviewErrorResponse'
		}
	
	}

	export interface OverviewFetchTimeout {
		/**
		 * Value for discriminator in Api.OverviewPageResponse
		 */
		_type: 'OverviewFetchTimeout';
	
		/**
		 * @description <p>Timeout used for the overview request (seconds).</p>
		 * @type {number}
		 * @memberof OverviewFetchTimeout
		 */
		usedTimeoutSeconds: number;
	}
	
	/**
	 * @export
	 * @namespace OverviewFetchTimeout
	 */
	export namespace OverviewFetchTimeout {
		export enum TypeEnum {
			OverviewFetchTimeout = 'OverviewFetchTimeout'
		}
	
	}

	export interface OverviewFilters {
		/**
		 * @description <p>Tags are grouped by their key.  For each key at least one of the values matches.</p>
		 * @type {string[]}
		 * @memberof OverviewFilters
		 */
		tagFilters?: string[];
		/**
		 * @description <p>Map of columnId to filter</p>
		 * @type {{ [name: string]: Api.OverviewColumnFilter }}
		 * @memberof OverviewFilters
		 */
		columnFilters?: { [name: string]: Api.OverviewColumnFilter };
	}

	export interface OverviewMetadata {
		columns: Api.OverviewColumnMeta[];
		/**
		 * @description <p>The effective sorting applied to the overview results.</p>
		 * @type {Api.OverviewSorting[]}
		 * @memberof OverviewMetadata
		 */
		sorting: Api.OverviewSorting[];
		/**
		 * @type {number}
		 * @memberof OverviewMetadata
		 */
		fixedColumns: number;
	}

	export type OverviewPageResponse = Api.OverviewPageResult | Api.OverviewFetchTimeout | Api.OverviewTooManyActiveQueries | Api.OverviewTopologySizeOverflow | Api.OverviewDataUnavailable;

	export interface OverviewPageResult {
		/**
		 * Value for discriminator in Api.OverviewPageResponse
		 */
		_type: 'OverviewPageResult';
	
		metadata: Api.OverviewMetadata;
		data: Api.OverviewRow[];
		pagination: Api.PaginationResponse;
	}
	
	/**
	 * @export
	 * @namespace OverviewPageResult
	 */
	export namespace OverviewPageResult {
		export enum TypeEnum {
			OverviewPageResult = 'OverviewPageResult'
		}
	
	}

	export interface OverviewPaginationCursor {
		/**
		 * @description <p>Opaque cursor returned from previous request</p>
		 * @type {string | null}
		 * @memberof OverviewPaginationCursor
		 */
		cursor: string | null;
		direction: Api.OverviewPaginationDirection;
	}

	export enum OverviewPaginationDirection {
		Back = 'Back',
		Forward = 'Forward'
	}

	export interface OverviewPaginationRequest {
		cursor?: Api.OverviewPaginationCursor;
		/**
		 * @type {number}
		 * @memberof OverviewPaginationRequest
		 * minimum: 1
		 * maximum: 500
		 */
		limit?: number;
	}

	export interface OverviewPerspective {
	  // OpenAPI `type: object` without properties
	  [name: string]: unknown
	}

	export interface OverviewRequest {
		/**
		 * @description <p>STQL query string to retrieve and project using the presentationOrViewUrn (helpful for related resources)</p>
		 * @type {string}
		 * @memberof OverviewRequest
		 */
		query?: string;
		/**
		 * @description <p>A timestamp at which resources will be queried. If not given the resources are queried at current time.</p>
		 * @type {number}
		 * @memberof OverviewRequest
		 */
		topologyTime?: number;
		filters?: Api.OverviewFilters;
		pagination?: Api.OverviewPaginationRequest;
		sorting?: Api.OverviewSorting[];
	}

	export interface OverviewRow {
		componentIdentifier: string;
		cells: { [name: string]: Api.CellValue };
	}

	export interface OverviewSorting {
		columnId: string;
		direction: Api.OverviewSortingDirection;
	}

	export enum OverviewSortingDirection {
		Ascending = 'Ascending',
		Descending = 'Descending'
	}

	export interface OverviewTooManyActiveQueries {
		/**
		 * Value for discriminator in Api.OverviewPageResponse
		 */
		_type: 'OverviewTooManyActiveQueries';
	
	  // OpenAPI `type: object` without properties
	  [name: string]: unknown
	}
	
	/**
	 * @export
	 * @namespace OverviewTooManyActiveQueries
	 */
	export namespace OverviewTooManyActiveQueries {
		export enum TypeEnum {
			OverviewTooManyActiveQueries = 'OverviewTooManyActiveQueries'
		}
	
	}

	export interface OverviewTopologySizeOverflow {
		/**
		 * Value for discriminator in Api.OverviewPageResponse
		 */
		_type: 'OverviewTopologySizeOverflow';
	
		/**
		 * @description <p>Maximum allowed topology size.</p>
		 * @type {number}
		 * @memberof OverviewTopologySizeOverflow
		 */
		maxSize: number;
	}
	
	/**
	 * @export
	 * @namespace OverviewTopologySizeOverflow
	 */
	export namespace OverviewTopologySizeOverflow {
		export enum TypeEnum {
			OverviewTopologySizeOverflow = 'OverviewTopologySizeOverflow'
		}
	
	}

	export interface PaginationResponse {
		/**
		 * @description <p>Total number of items matching the ComponentPresentation
		 *  before applying column filters or search.</p>
		 * @type {number}
		 * @memberof PaginationResponse
		 */
		total: number;
		/**
		 * @description <p>Total number of items after filters/search are applied,
		 *  but before pagination.</p>
		 * @type {number | null}
		 * @memberof PaginationResponse
		 */
		filtered?: number | null;
		elementName: string;
		elementNamePlural: string;
		startCursor?: string | null;
		endCursor?: string | null;
	}

	export interface PermissionDescription {
		subjectHandle: string;
		fromSources?: Api.SubjectSource[];
		permissions: { [name: string]: string[] };
	}

	export interface Permissions {
		permissions: string[];
	}

	export interface PersesDashboard {
		kind?: string;
		metadata?: Api.PersesProjectMetadata;
		spec?: Api.PersesDashboardSpec;
	}

	export interface PersesDashboardDisplaySpec {
		description?: string;
		name?: string;
	}

	export interface PersesDashboardSpec {
		/**
		 * @description <p>Datasources is an optional list of datasource definition.</p>
		 * @type {{ [name: string]: Api.PersesDatasourceSpec }}
		 * @memberof PersesDashboardSpec
		 */
		datasources?: { [name: string]: Api.PersesDatasourceSpec };
		display?: Api.PersesDashboardDisplaySpec;
		/**
		 * @description <p>A Duration represents the elapsed time between two instants.
		 *  It must be provided as a string like &quot;1h&quot;, &quot;30m&quot;, &quot;15s&quot;.</p>
		 * @type {string}
		 * @memberof PersesDashboardSpec
		 */
		duration?: string;
		layouts?: Api.PersesLayout[];
		panels?: { [name: string]: Api.PersesPanel };
		/**
		 * @description <p>A Duration represents the elapsed time between two instants.
		 *  It must be provided as a string like &quot;1h&quot;, &quot;30m&quot;, &quot;15s&quot;.</p>
		 * @type {string}
		 * @memberof PersesDashboardSpec
		 */
		refreshInterval?: string;
		variables?: Api.PersesVariableTypes[];
	}

	export interface PersesDatasourceSpec {
		default?: boolean;
		display?: Api.PersesDashboardDisplaySpec;
		plugin?: Api.PersesPlugin;
	}

	export interface PersesGridItem {
		/**
		 * @description <p>The x-coordinate of the item in the grid.</p>
		 * @type {number}
		 * @memberof PersesGridItem
		 */
		x: number;
		/**
		 * @description <p>The y-coordinate of the item in the grid.</p>
		 * @type {number}
		 * @memberof PersesGridItem
		 */
		y: number;
		/**
		 * @description <p>The width of the item in the grid.</p>
		 * @type {number}
		 * @memberof PersesGridItem
		 */
		width: number;
		/**
		 * @description <p>The height of the item in the grid.</p>
		 * @type {number}
		 * @memberof PersesGridItem
		 */
		height: number;
		content: Api.PersesJSONRef;
	}

	export interface PersesGridLayoutCollapse {
		/**
		 * @description <p>Indicates whether the grid layout is collapsed.</p>
		 * @type {boolean}
		 * @memberof PersesGridLayoutCollapse
		 */
		open: boolean;
	}

	export interface PersesGridLayoutDisplay {
		/**
		 * @description <p>The title of the grid layout.</p>
		 * @type {string}
		 * @memberof PersesGridLayoutDisplay
		 */
		title: string;
		collapse?: Api.PersesGridLayoutCollapse;
	}

	export interface PersesJSONRef {
		/**
		 * @description <p>The JSON reference pointing to the actual object. The property name &#39;$ref&#39; contains a reserved char, which gets stripped away when generated (it&#39;s possible to handle this but makes the generation code more complex). For now, consumers of this spec will need to omit the &#39;$&#39; in the property name.</p>
		 * @type {string}
		 * @memberof PersesJSONRef
		 */
		$ref: string;
	}

	export interface PersesLayout {
		/**
		 * @description <p>Defines the layout type. Currently, only &#39;Grid&#39; is supported.</p>
		 * @type {Api.PersesLayoutKind}
		 * @memberof PersesLayout
		 */
		kind: Api.PersesLayoutKind;
		spec: Api.PersesLayoutSpec;
	}

	/**
	 * <p>Defines the layout type. Currently, only &#39;Grid&#39; is supported.</p>
	 */
	export enum PersesLayoutKind {
		Grid = 'Grid'
	}

	export interface PersesLayoutSpec {
		display?: Api.PersesGridLayoutDisplay;
		items: Api.PersesGridItem[];
	}

	export interface PersesLink {
		name?: string;
		renderVariables?: boolean;
		targetBlank?: boolean;
		tooltip?: string;
		url?: string;
	}

	export interface PersesListVariable {
		/**
		 * Value for discriminator in Api.PersesVariableTypes
		 */
		kind: 'ListVariable';
	
		spec?: Api.PersesListVariableSpec;
	}
	
	/**
	 * @export
	 * @namespace PersesListVariable
	 */
	export namespace PersesListVariable {
		export enum KindEnum {
			ListVariable = 'ListVariable'
		}
	
	}

	export interface PersesListVariableDefaultSingleValue {
		/**
		 * Value for discriminator in Api.PersesListVariableDefaultValue
		 */
		kind: 'singleValue';
	
		singleValue: string;
	}
	
	/**
	 * @export
	 * @namespace PersesListVariableDefaultSingleValue
	 */
	export namespace PersesListVariableDefaultSingleValue {
		export enum KindEnum {
			SingleValue = 'singleValue'
		}
	
	}

	export interface PersesListVariableDefaultSliceValues {
		/**
		 * Value for discriminator in Api.PersesListVariableDefaultValue
		 */
		kind: 'sliceValues';
	
		sliceValues: string[];
	}
	
	/**
	 * @export
	 * @namespace PersesListVariableDefaultSliceValues
	 */
	export namespace PersesListVariableDefaultSliceValues {
		export enum KindEnum {
			SliceValues = 'sliceValues'
		}
	
	}

	export type PersesListVariableDefaultValue = Api.PersesListVariableDefaultSingleValue | Api.PersesListVariableDefaultSliceValues;

	export interface PersesListVariableSpec {
		name: string;
		display?: Api.PersesVariableDisplaySpec;
		defaultValue?: Api.PersesListVariableDefaultValue;
		allowAllValue: boolean;
		allowMultiple: boolean;
		customAllValue?: string;
		capturingRegexp?: string;
		sort?: Api.PersesVariableSort;
		plugin: Api.PersesPlugin;
	}

	export interface PersesPanel {
		kind?: string;
		spec?: Api.PersesPanelSpec;
	}

	export interface PersesPanelDisplay {
		description?: string;
		name?: string;
	}

	export interface PersesPanelSpec {
		display?: Api.PersesPanelDisplay;
		links?: Api.PersesLink[];
		plugin?: Api.PersesPlugin;
		queries?: Api.PersesQuery[];
	}

	export interface PersesPlugin {
		kind?: string;
		spec?: Api.PersesPlugin.Spec;
	}
	
	/**
	 * @export
	 * @namespace PersesPlugin
	 */
	export namespace PersesPlugin {
		export interface Spec {
		  // OpenAPI `type: object` without properties
		  [name: string]: unknown
		}
	
	}

	export interface PersesProjectMetadata {
		createdAt?: string;
		name?: string;
		project?: string;
		updatedAt?: string;
		/**
		 * @type {number}
		 * @memberof PersesProjectMetadata
		 */
		version?: number;
	}

	export interface PersesQuery {
		kind?: string;
		spec?: Api.PersesQuerySpec;
	}

	export interface PersesQuerySpec {
		plugin?: Api.PersesPlugin;
	}

	export interface PersesTextVariable {
		/**
		 * Value for discriminator in Api.PersesVariableTypes
		 */
		kind: 'TextVariable';
	
		spec?: Api.PersesTextVariableSpec;
	}
	
	/**
	 * @export
	 * @namespace PersesTextVariable
	 */
	export namespace PersesTextVariable {
		export enum KindEnum {
			TextVariable = 'TextVariable'
		}
	
	}

	export interface PersesTextVariableSpec {
		name: string;
		display?: Api.PersesVariableDisplaySpec;
		value: string;
		constant?: boolean;
	}

	export interface PersesVariableDisplaySpec {
		name?: string;
		description?: string;
		hidden?: boolean;
	}

	export enum PersesVariableSort {
		None = 'none',
		AlphabeticalAsc = 'alphabetical-asc',
		AlphabeticalDesc = 'alphabetical-desc',
		NumericalAsc = 'numerical-asc',
		NumericalDesc = 'numerical-desc',
		AlphabeticalCiAsc = 'alphabetical-ci-asc',
		AlphabeticalCiDesc = 'alphabetical-ci-desc'
	}

	export type PersesVariableTypes = Api.PersesTextVariable | Api.PersesListVariable;

	/**
	 * <p>The set of perspectives the frontend needs to render a view page in one response.
	 * Each optional field carries the per-perspective config; absence means
	 * the perspective is not available for this view.</p>
	 */
	export interface Perspectives {
		/**
		 * @description <p>The resolved URN (ComponentPresentation identifier or legacy QueryView/ViewType URN).</p>
		 * @type {string}
		 * @memberof Perspectives
		 */
		identifier: string;
		/**
		 * @description <p>STQL query for this view. Used by the shared timeline, the events perspective, and the topology perspective.</p>
		 * @type {string}
		 * @memberof Perspectives
		 */
		topologyQuery: string;
		/**
		 * @description <p>When true, the view is system-managed (e.g. a ComponentPresentation or ViewType) and the
		 *  frontend must not offer save, save-as, edit, or delete operations. When false, the view is
		 *  a user-managed QueryView and mutation operations are permitted subject to normal permission checks.</p>
		 * @type {boolean}
		 * @memberof Perspectives
		 */
		readOnly: boolean;
		overview?: Api.OverviewPerspective;
		/**
		 * @description <p>Topology perspective config. Reuses QueryMetadata from the snapshot API
		 *  as the rendering spec.</p>
		 * @type {Api.TopologyPerspective}
		 * @memberof Perspectives
		 */
		topology?: Api.TopologyPerspective;
		events?: Api.EventsPerspective;
	}

	export interface PerspectivesApiError {
		message: string;
	}

	/**
	 * <p>Component presentation definition.
	 * If multiple ComponentPresentations match, <code>filters</code> are merged by filter identity with the most specific presentation winning.
	 * Scalar fields like <code>icon</code> and <code>topology</code> follow most-specific-wins semantics across matching presentations.
	 * Absence of <code>topology</code> means the Topology perspective is not available for this presentation.
	 * Absence of the field keeps legacy behavior (for example, ViewType-based filters) unchanged.</p>
	 */
	export interface PresentationDefinition {
		icon?: string;
		/**
		 * @description <p>Overview presentation definition. The <code>columns</code> field defines the columns to show in the overview table. The <code>flags</code> field can be used to enable/disable functionalities.
		 *  If multiple ComponentPresentations match, columns are merged by <code>columnId</code> according to binding rank. Absence of the field means no overview is shown.</p>
		 * @type {Api.PresentationOverview}
		 * @memberof PresentationDefinition
		 */
		overview?: Api.PresentationOverview;
		/**
		 * @description <p>Highlight presentation definition. The <code>fields</code> define the fields to show in the highlight page.
		 *  If multiple ComponentPresentations match, fields are merged by <code>fieldId</code> according to binding rank.
		 *  Related resources follow the same merge semantics using <code>resourceId</code> as the identity key.
		 *  Links follow the same merge semantics using <code>linkId</code> as the identity key.</p>
		 * @type {Api.PresentationHighlight}
		 * @memberof PresentationDefinition
		 */
		highlight?: Api.PresentationHighlight;
		summary?: Api.PresentationSummary;
		filters?: Api.ComponentPresentationFilter[];
		metricPerspective?: Api.PresentationMetricPerspective;
		/**
		 * @description <p>Makes the Traces perspective available on components matched by this presentation.
		 *  Absence of the field means the Traces perspective is not shown.
		 *  Most-specific-wins merge semantics across matching ComponentPresentations: the whole
		 *  section is taken from the most specific presentation that defines it, it is not merged
		 *  field by field.</p>
		 * @type {Api.PresentationTracesPerspective}
		 * @memberof PresentationDefinition
		 */
		tracesPerspective?: Api.PresentationTracesPerspective;
		/**
		 * @description <p>Rendering settings for the topology perspective.
		 *  Near-copy of QueryMetadata used for topology rendering today; differences:</p>
		 *  <ul>
		 *  <li><code>queryTime</code> is intentionally absent (request-time state, not a presentation setting).
		 *  Most-specific-wins merge semantics across matching ComponentPresentations.</li>
		 *  </ul>
		 * @type {Api.TopologySettings}
		 * @memberof PresentationDefinition
		 */
		topology?: Api.TopologySettings;
	}

	export type PresentationFilter = Api.PresentationTagFilter;

	export interface PresentationFilterName {
		singular: string;
		plural: string;
	}

	export interface PresentationFiltersResponse {
		/**
		 * @description <p>Whether topology filters are enabled for this presentation.</p>
		 * @type {boolean}
		 * @memberof PresentationFiltersResponse
		 */
		topologyFilters: boolean;
		/**
		 * @description <p>Presentation filters in display order. Earlier items are primary (filter bar),
		 *  later items are secondary (&quot;More&quot; section).</p>
		 * @type {Api.PresentationFilter[]}
		 * @memberof PresentationFiltersResponse
		 */
		filters: Api.PresentationFilter[];
		/**
		 * @description <p>Label for the section within &quot;More&quot; tab when secondary filters are present.</p>
		 * @type {string}
		 * @memberof PresentationFiltersResponse
		 */
		menuSection: string;
	}

	/**
	 * <p>Highlight presentation definition. The <code>fields</code> define the fields to show in the highlight page.
	 * If multiple ComponentPresentations match, fields are merged by <code>fieldId</code> according to binding rank.
	 * Related resources follow the same merge semantics using <code>resourceId</code> as the identity key.
	 * Links follow the same merge semantics using <code>linkId</code> as the identity key.</p>
	 */
	export interface PresentationHighlight {
		fields?: Api.PresentationHighlightField[];
		/**
		 * @description <p>Provisioning section of a component in the highlight presentation. The <code>topologySourceSelector</code> field is used to identify the external component with provisioning details for this component.</p>
		 * @type {Api.PresentationHighlightProvisioning}
		 * @memberof PresentationHighlight
		 */
		provisioning?: Api.PresentationHighlightProvisioning;
		relatedResources?: Api.PresentationRelatedResource[];
		links?: Api.PresentationLink[];
		events?: Api.PresentationHighlightEvents;
		metrics?: Api.PresentationHighlightMetricsSection[];
	}

	export interface PresentationHighlightEvents {
		showEvents: boolean;
		relatedResourcesQuery?: string;
		excludedRelatedResourcesQuery?: string;
	}

	/**
	 * <p>Definition of a field in the highlight presentation. The <code>fieldId</code> field is used to identify the field and merge fields from different presentations.</p>
	 */
	export interface PresentationHighlightField {
		fieldId: string;
		title: string;
		description?: string;
		/**
		 * @type {number}
		 * @memberof PresentationHighlightField
		 */
		order: number;
		/**
		 * @description <p>Display type and value for the field.</p>
		 * @type {Api.ComponentHighlightProjection}
		 * @memberof PresentationHighlightField
		 */
		projection?: Api.ComponentHighlightProjection;
	}

	export interface PresentationHighlightMetricsSection {
		sectionId: string;
		title: string;
		description?: string;
		defaultExpanded?: boolean;
		/**
		 * @type {number}
		 * @memberof PresentationHighlightMetricsSection
		 */
		order: number;
		metrics?: Api.OrderedComponentPresentationMetric[];
	}

	/**
	 * <p>Provisioning section of a component in the highlight presentation. The <code>topologySourceSelector</code> field is used to identify the external component with provisioning details for this component.</p>
	 */
	export interface PresentationHighlightProvisioning {
		/**
		 * @description <p>Cel expression that selects the external component with provisioning details</p>
		 * @type {string}
		 * @memberof PresentationHighlightProvisioning
		 */
		topologySourceSelector?: string;
		showConfiguration?: boolean;
		showStatus?: boolean;
	}

	/**
	 * <p>Link definition for the highlight page. Each entry defines a navigation link shown for a component.
	 * Merge semantics follow related resource rules:</p>
	 * <ul>
	 * <li>All presentations whose binding matches the component contribute links.</li>
	 * <li>Same linkId with higher specificity wins (override).</li>
	 * <li>Different linkId entries are appended.</li>
	 * <li>Display order is determined by the order field.
	 * CEL expressions are evaluated against the component presentation context. The filter is evaluated first;
	 * if it evaluates to false the link is omitted. If the filter includes the link but required data cannot be
	 * evaluated, the resolved highlight response reports an error link.</li>
	 * </ul>
	 */
	export interface PresentationLink {
		/**
		 * @description <p>Stable identity key for merging across presentations, analogous to fieldId and resourceId.</p>
		 * @type {string}
		 * @memberof PresentationLink
		 */
		linkId: string;
		/**
		 * @description <p>CEL expression that returns the displayed link title.</p>
		 * @type {string}
		 * @memberof PresentationLink
		 */
		title?: string;
		/**
		 * @description <p>CEL expression that returns a relative or fully-qualified link target.</p>
		 * @type {string}
		 * @memberof PresentationLink
		 */
		target?: string;
		/**
		 * @description <p>Whether the link opens in a new tab. Defaults to false.</p>
		 * @type {boolean}
		 * @memberof PresentationLink
		 */
		openInNewTab?: boolean;
		/**
		 * @description <p>Optional CEL expression that returns tooltip text.</p>
		 * @type {string}
		 * @memberof PresentationLink
		 */
		tooltip?: string;
		/**
		 * @description <p>Optional CEL boolean expression deciding whether the link is shown. Missing filters default to true.</p>
		 * @type {string}
		 * @memberof PresentationLink
		 */
		filter?: string;
		/**
		 * @description <p>Display order. Higher value means it shows first in UI.</p>
		 * @type {number}
		 * @memberof PresentationLink
		 */
		order?: number;
	}

	export interface PresentationMainMenu {
		group: string;
		icon?: string;
		/**
		 * @type {number}
		 * @memberof PresentationMainMenu
		 */
		order: number;
	}

	export interface PresentationMetricPerspective {
		tabs: Api.PresentationMetricPerspectiveTab[];
	}

	export interface PresentationMetricPerspectiveSection {
		sectionId: string;
		title: string;
		/**
		 * @type {number}
		 * @memberof PresentationMetricPerspectiveSection
		 */
		order: number;
		metrics?: Api.OrderedComponentPresentationMetric[];
	}

	export interface PresentationMetricPerspectiveTab {
		tabId: string;
		title: string;
		/**
		 * @type {number}
		 * @memberof PresentationMetricPerspectiveTab
		 */
		order: number;
		sections?: Api.PresentationMetricPerspectiveSection[];
	}

	export interface PresentationMetricQuery {
		expression: string;
		alias: string;
		componentIdentifierTemplate?: string;
	}

	export interface PresentationName {
		singular: string;
		plural: string;
		title: string;
	}

	/**
	 * <p>Overview presentation definition. The <code>columns</code> field defines the columns to show in the overview table. The <code>flags</code> field can be used to enable/disable functionalities.
	 * If multiple ComponentPresentations match, columns are merged by <code>columnId</code> according to binding rank. Absence of the field means no overview is shown.</p>
	 */
	export interface PresentationOverview {
		name: Api.PresentationName;
		mainMenu?: Api.PresentationMainMenu;
		columns: Api.OverviewColumnDefinition[];
		/**
		 * @type {number}
		 * @memberof PresentationOverview
		 */
		fixedColumns?: number;
		sort?: Api.PresentationOverviewSorting[];
	}

	export interface PresentationOverviewSorting {
		columnId: string;
		direction?: Api.PresentationOverviewSortingDirection;
	}

	export enum PresentationOverviewSortingDirection {
		Ascending = 'Ascending',
		Descending = 'Descending'
	}

	/**
	 * <p>Related resource definition for the highlight page. Each entry defines a section showing components
	 * related to the one being viewed, rendered using the referenced presentation&#39;s overview spec.
	 * Merge semantics follow highlight field rules:</p>
	 * <ul>
	 * <li>All presentations whose binding matches the component contribute related resources.</li>
	 * <li>Same resourceId with higher specificity wins (override).</li>
	 * <li>Different resourceId entries are appended.</li>
	 * <li>Display order is determined by the order field.</li>
	 * </ul>
	 */
	export interface PresentationRelatedResource {
		/**
		 * @description <p>Stable identity key for merging across presentations, analogous to fieldId and filterId.</p>
		 * @type {string}
		 * @memberof PresentationRelatedResource
		 */
		resourceId: string;
		/**
		 * @description <p>Section heading displayed in the UI for this related resource.</p>
		 * @type {string}
		 * @memberof PresentationRelatedResource
		 */
		title: string;
		/**
		 * @description <p>Display order. Higher value means it shows first in UI.</p>
		 * @type {number}
		 * @memberof PresentationRelatedResource
		 */
		order: number;
		/**
		 * @description <p>STQL query scoping the related components. Supports template interpolation with ${*} placeholders
		 *  (e.g. ${identifiers[0]}, ${tags[&#39;namespace&#39;]}).
		 *  The backend intersects this query with the referenced presentation&#39;s binding query.</p>
		 * @type {string}
		 * @memberof PresentationRelatedResource
		 */
		topologyQuery?: string;
		/**
		 * @description <p>References a ComponentPresentation by identifier to reuse its overview spec (columns, name, filters)
		 *  for rendering this related resource section. Must be within the same stackpack.</p>
		 * @type {string}
		 * @memberof PresentationRelatedResource
		 */
		presentationIdentifier?: string;
	}

	/**
	 * <p>Selects the spans shown in the Traces perspective for a component.
	 * String-valued fields are string templates: text is taken literally and any <code>${...}</code>
	 * placeholder is evaluated as a CEL expression against the component, using the same context
	 * as metric perspective queries. For example <code>orderService</code> is a literal, while
	 * <code>${tags.singleValue(&#39;service.namespace&#39;)}</code> resolves the tag of that name. Note that <code>tags</code>
	 * maps each key to a list of values, so use <code>singleValue</code> inside a placeholder when a single
	 * string is required.
	 * Enum- and duration-valued fields are literals and are not evaluated.
	 * Resolution is best effort: a field whose expression fails to parse or evaluate is dropped
	 * from the filter and logged, the remaining fields still apply.</p>
	 */
	export interface PresentationSpanFilter {
		/**
		 * @description <p>Filter spans by service name</p>
		 * @type {string[]}
		 * @memberof PresentationSpanFilter
		 */
		serviceName?: string[];
		/**
		 * @description <p>Filter spans by name</p>
		 * @type {string[]}
		 * @memberof PresentationSpanFilter
		 */
		spanName?: string[];
		/**
		 * @description <p>Filter spans by 1 or more attributes</p>
		 * @type {{ [name: string]: string[] }}
		 * @memberof PresentationSpanFilter
		 */
		attributes?: { [name: string]: string[] };
		/**
		 * @description <p>Filter spans by kind</p>
		 * @type {Api.SpanKind[]}
		 * @memberof PresentationSpanFilter
		 */
		spanKind?: Api.SpanKind[];
		/**
		 * @description <p>Filter spans by parent type</p>
		 * @type {Api.SpanParentType[]}
		 * @memberof PresentationSpanFilter
		 */
		spanParentType?: Api.SpanParentType[];
		/**
		 * @description <p>Filter spans by status code</p>
		 * @type {Api.SpanStatusCode[]}
		 * @memberof PresentationSpanFilter
		 */
		statusCode?: Api.SpanStatusCode[];
		/**
		 * @description <p>Filter spans by duration &gt;= value, in nanoseconds</p>
		 * @type {number}
		 * @memberof PresentationSpanFilter
		 */
		durationFromNanos?: number;
		/**
		 * @description <p>Filter spans by duration &lt; value, in nanoseconds</p>
		 * @type {number}
		 * @memberof PresentationSpanFilter
		 */
		durationToNanos?: number;
		/**
		 * @description <p>Filter spans by instrumentation scope name</p>
		 * @type {string[]}
		 * @memberof PresentationSpanFilter
		 */
		scopeName?: string[];
		/**
		 * @description <p>Filter spans by instrumentation scope version</p>
		 * @type {string[]}
		 * @memberof PresentationSpanFilter
		 */
		scopeVersion?: string[];
	}

	export interface PresentationSummary {
		metrics?: Api.PresentationSummaryMetric[];
	}

	export interface PresentationSummaryMetric {
		summaryMetricId: string;
		name?: string;
		/**
		 * @type {number}
		 * @memberof PresentationSummaryMetric
		 */
		order?: number;
		query?: string;
		unit?: string;
		/**
		 * @type {number}
		 * @memberof PresentationSummaryMetric
		 */
		decimalPlaces?: number;
		metricId?: string;
	}

	export interface PresentationTagFilter {
		/**
		 * Value for discriminator in Api.PresentationFilter
		 */
		_type: 'PresentationTagFilter';
	
		filterId: string;
		displayName: Api.PresentationFilterName;
		/**
		 * @description <p>Tag key to use for filtering.</p>
		 * @type {string}
		 * @memberof PresentationTagFilter
		 */
		tagKey: string;
	}
	
	/**
	 * @export
	 * @namespace PresentationTagFilter
	 */
	export namespace PresentationTagFilter {
		export enum TypeEnum {
			PresentationTagFilter = 'PresentationTagFilter'
		}
	
	}

	/**
	 * <p>Makes the Traces perspective available on components matched by this presentation.
	 * Absence of the field means the Traces perspective is not shown.
	 * Most-specific-wins merge semantics across matching ComponentPresentations: the whole
	 * section is taken from the most specific presentation that defines it, it is not merged
	 * field by field.</p>
	 */
	export interface PresentationTracesPerspective {
		/**
		 * @description <p>Set to false on a more specific presentation to suppress a Traces perspective enabled by a less specific one.</p>
		 * @type {boolean}
		 * @memberof PresentationTracesPerspective
		 */
		showTraces: boolean;
		/**
		 * @description <p>Selects the spans shown in the Traces perspective for a component.
		 *  String-valued fields are string templates: text is taken literally and any <code>${...}</code>
		 *  placeholder is evaluated as a CEL expression against the component, using the same context
		 *  as metric perspective queries. For example <code>orderService</code> is a literal, while
		 *  <code>${tags.singleValue(&#39;service.namespace&#39;)}</code> resolves the tag of that name. Note that <code>tags</code>
		 *  maps each key to a list of values, so use <code>singleValue</code> inside a placeholder when a single
		 *  string is required.
		 *  Enum- and duration-valued fields are literals and are not evaluated.
		 *  Resolution is best effort: a field whose expression fails to parse or evaluate is dropped
		 *  from the filter and logged, the remaining fields still apply.</p>
		 * @type {Api.PresentationSpanFilter}
		 * @memberof PresentationTracesPerspective
		 */
		spanFilter: Api.PresentationSpanFilter;
	}

	export interface ProblemNotFound {
		/**
		 * Value for discriminator in Api.GetCausingEventsNotFound
		 */
		_type: 'ProblemNotFound';
	
		message: string;
		/**
		 * @type {number}
		 * @memberof ProblemNotFound
		 */
		problemId: number;
		/**
		 * @type {number}
		 * @memberof ProblemNotFound
		 */
		requestTimeMs: number;
	}
	
	/**
	 * @export
	 * @namespace ProblemNotFound
	 */
	export namespace ProblemNotFound {
		export enum TypeEnum {
			ProblemNotFound = 'ProblemNotFound'
		}
	
	}

	export interface PromBatchEnvelope {
		results: Api.PromBatchResult[];
	}

	export interface PromBatchError {
		/**
		 * Value for discriminator in Api.PromBatchResult
		 */
		resultType: 'error';
	
		id: string;
		error: string;
	}
	
	/**
	 * @export
	 * @namespace PromBatchError
	 */
	export namespace PromBatchError {
		export enum ResultTypeEnum {
			Error = 'error'
		}
	
	}

	export interface PromBatchInstantQuery {
		/**
		 * Value for discriminator in Api.PromBatchQueryItem
		 */
		_type: 'instant';
	
		id: string;
		query: string;
		time?: string;
		step?: string;
		timeout?: string;
		post_filter?: string[];
	}
	
	/**
	 * @export
	 * @namespace PromBatchInstantQuery
	 */
	export namespace PromBatchInstantQuery {
		export enum TypeEnum {
			Instant = 'instant'
		}
	
	}

	export type PromBatchQueryItem = Api.PromBatchInstantQuery | Api.PromBatchRangeQuery;

	/**
	 * <p>Executes multiple query items in one request. If both request-level timeout and item-level timeout are set, item-level timeout takes precedence.</p>
	 */
	export interface PromBatchQueryRequest {
		/**
		 * @description <p>List of queries to execute.</p>
		 * @type {Api.PromBatchQueryItem[]}
		 * @memberof PromBatchQueryRequest
		 */
		queries: Api.PromBatchQueryItem[];
		timeout?: string;
	}

	export interface PromBatchRangeQuery {
		/**
		 * Value for discriminator in Api.PromBatchQueryItem
		 */
		_type: 'range';
	
		id: string;
		query: string;
		start: string;
		end: string;
		step: string;
		timeout?: string;
		aligned?: boolean;
		/**
		 * @type {number}
		 * @memberof PromBatchRangeQuery
		 */
		maxNumberOfDataPoints?: number;
		post_filter?: string[];
	}
	
	/**
	 * @export
	 * @namespace PromBatchRangeQuery
	 */
	export namespace PromBatchRangeQuery {
		export enum TypeEnum {
			Range = 'range'
		}
	
	}

	export type PromBatchResult = Api.PromBatchSuccess | Api.PromBatchError;

	export interface PromBatchSuccess {
		/**
		 * Value for discriminator in Api.PromBatchResult
		 */
		resultType: 'success';
	
		id: string;
		data: Api.PromEnvelope;
	}
	
	/**
	 * @export
	 * @namespace PromBatchSuccess
	 */
	export namespace PromBatchSuccess {
		export enum ResultTypeEnum {
			Success = 'success'
		}
	
	}

	export type PromData = Api.PromMatrix | Api.PromVector | Api.PromScalar | Api.PromDataString;

	export interface PromDataResult {
		metric: { [name: string]: string };
		values: ((number | string)[])[];
	}

	export interface PromDataString {
		/**
		 * Value for discriminator in Api.PromData
		 */
		resultType: 'string';
	
		/**
		 * @description <p>This is always a tuple represented as an array with in first position the unix timestamp as 
		 *  a float with precision 3 in seconds) and in second position the sample value as a string.</p>
		 * @type {(number | string)[]}
		 * @memberof PromDataString
		 */
		result: (number | string)[];
	}
	
	/**
	 * @export
	 * @namespace PromDataString
	 */
	export namespace PromDataString {
		export enum ResultTypeEnum {
			String = 'string'
		}
	
	}

	export interface PromEnvelope {
		status: string;
		data?: Api.PromData;
		errorType?: string;
		error?: string;
		warnings?: string[];
	}

	export interface PromExemplar {
		labels: { [name: string]: string };
		value: string;
		/**
		 * @type {number}
		 * @memberof PromExemplar
		 */
		timestamp: number;
	}

	export interface PromExemplarData {
		seriesLabels: { [name: string]: string };
		exemplars: Api.PromExemplar[];
	}

	export interface PromExemplarEnvelope {
		status: string;
		data?: Api.PromExemplarData[];
		errorType?: string;
		error?: string;
		warnings?: string[];
	}

	export interface PromLabelsEnvelope {
		status: string;
		data?: string[];
		errorType?: string;
		error?: string;
		warnings?: string[];
	}

	export interface PromLabelsRequest {
		start?: string;
		end?: string;
		'match[]'?: string[];
	}

	export interface PromLabelValuesRequest {
		start?: string;
		end?: string;
		'match[]'?: string[];
	}

	export interface PromMatrix {
		/**
		 * Value for discriminator in Api.PromData
		 */
		resultType: 'matrix';
	
		result: Api.PromDataResult[];
	}
	
	/**
	 * @export
	 * @namespace PromMatrix
	 */
	export namespace PromMatrix {
		export enum ResultTypeEnum {
			Matrix = 'matrix'
		}
	
	}

	export interface PromMetadataEnvelope {
		status: string;
		data?: { [name: string]: ({ [name: string]: string })[] };
		errorType?: string;
		error?: string;
		warnings?: string[];
	}

	export interface PromMetadataRequest {
		/**
		 * @type {number}
		 * @memberof PromMetadataRequest
		 */
		limit?: number;
		metric?: string;
	}

	export interface PromQLMetric {
		/**
		 * Discriminator property
		 */
		_type: Api.PromQLMetric.TypeEnum;
		
		/**
		 * @type {number}
		 * @memberof PromQLMetric
		 */
		id?: number;
		query: string;
		unit: string;
		aliasTemplate: string;
	}
	
	/**
	 * @export
	 * @namespace PromQLMetric
	 */
	export namespace PromQLMetric {
		export enum TypeEnum {
			PromQLMetric = 'PromQLMetric'
		}
	
	}

	export interface PromQueryExemplarRequest {
		query: string;
		start?: string;
		end?: string;
	}

	export interface PromQueryRangeRequest {
		query: string;
		start: string;
		end: string;
		step: string;
		timeout?: string;
		aligned?: boolean;
		/**
		 * @type {number}
		 * @memberof PromQueryRangeRequest
		 */
		maxNumberOfDataPoints?: number;
		post_filter?: string[];
	}

	export interface PromQueryRequest {
		query: string;
		time?: string;
		timeout?: string;
		step?: string;
		post_filter?: string[];
	}

	export interface PromScalar {
		/**
		 * Value for discriminator in Api.PromData
		 */
		resultType: 'scalar';
	
		/**
		 * @description <p>This is always a tuple represented as an array with in first position the unix timestamp as 
		 *  a float with precision 3 in seconds) and in second position the sample value as a string.</p>
		 * @type {(number | string)[]}
		 * @memberof PromScalar
		 */
		result: (number | string)[];
	}
	
	/**
	 * @export
	 * @namespace PromScalar
	 */
	export namespace PromScalar {
		export enum ResultTypeEnum {
			Scalar = 'scalar'
		}
	
	}

	export interface PromSeriesEnvelope {
		status: string;
		data?: ({ [name: string]: string })[];
		errorType?: string;
		error?: string;
		warnings?: string[];
	}

	export interface PromSeriesRequest {
		'match[]': string[];
		start?: string;
		end?: string;
	}

	export interface PromVector {
		/**
		 * Value for discriminator in Api.PromData
		 */
		resultType: 'vector';
	
		result: Api.PromVectorResult[];
	}
	
	/**
	 * @export
	 * @namespace PromVector
	 */
	export namespace PromVector {
		export enum ResultTypeEnum {
			Vector = 'vector'
		}
	
	}

	export interface PromVectorResult {
		metric: { [name: string]: string };
		/**
		 * @description <p>This is always a tuple represented as an array with in first position the unix timestamp as 
		 *  a float with precision 3 in seconds) and in second position the sample value as a string.</p>
		 * @type {(number | string)[]}
		 * @memberof PromVectorResult
		 */
		value: (number | string)[];
	}

	export interface ProvisionResponse {
		/**
		 * @type {number}
		 * @memberof ProvisionResponse
		 */
		id?: number;
		status?: string;
		name?: string;
		stackPackVersion?: string;
		/**
		 * @type {number}
		 * @memberof ProvisionResponse
		 */
		lastUpdateTimestamp?: number;
	}

	/**
	 * <p>Query execution settings</p>
	 */
	export interface QueryMetadata {
		groupingEnabled: boolean;
		showIndirectRelations: boolean;
		/**
		 * @type {number}
		 * @memberof QueryMetadata
		 */
		minGroupSize: number;
		groupedByLayer: boolean;
		groupedByDomain: boolean;
		groupedByRelation: boolean;
		/**
		 * @description <p>Unix timestamp in milliseconds</p>
		 * @type {number | null}
		 * @memberof QueryMetadata
		 */
		queryTime?: number | null;
		autoGrouping: boolean;
		connectedComponents: boolean;
		neighboringComponents: boolean;
		showFullComponent: boolean;
	}

	/**
	 * <p>Query parsing failed. The reason field contains the error message.</p>
	 */
	export interface QueryParsingFailure {
		/**
		 * @description <p>Discriminator field</p>
		 * @type {Api.QueryParsingFailure.TypeEnum}
		 * @memberof QueryParsingFailure
		 */
		_type: Api.QueryParsingFailure.TypeEnum;
		/**
		 * @description <p>Error message describing why the query failed to parse</p>
		 * @type {string}
		 * @memberof QueryParsingFailure
		 */
		reason: string;
	}
	
	/**
	 * @export
	 * @namespace QueryParsingFailure
	 */
	export namespace QueryParsingFailure {
		/**
		 * <p>Discriminator field</p>
		 */
		export enum TypeEnum {
			QueryParsingFailure = 'QueryParsingFailure'
		}
	
	}

	/**
	 * <p>Query succeeded (or encountered a runtime error that&#39;s part of the result).
	 * The SnapshotResponse uses existing DTO types for nested structures.</p>
	 */
	export interface QuerySnapshotResult {
		/**
		 * @description <p>Discriminator field</p>
		 * @type {Api.QuerySnapshotResult.TypeEnum}
		 * @memberof QuerySnapshotResult
		 */
		_type: Api.QuerySnapshotResult.TypeEnum;
		/**
		 * @description <p>The query result or error response. This is opaque at the API level but contains one of the following DTO types:</p>
		 *  <ul>
		 *  <li>ViewSnapshot (success)</li>
		 *  <li>ViewSnapshotFetchTimeout (error)</li>
		 *  <li>ViewSnapshotTooManyActiveQueries (error)</li>
		 *  <li>ViewSnapshotTopologySizeOverflow (error)</li>
		 *  <li>ViewSnapshotDataUnavailable (error)
		 *  Use the _type field to discriminate between types.</li>
		 *  </ul>
		 * @type {Api.QuerySnapshotResult.ViewSnapshotResponse}
		 * @memberof QuerySnapshotResult
		 */
		viewSnapshotResponse: Api.QuerySnapshotResult.ViewSnapshotResponse;
		/**
		 * @description <p>View identifier that was provided in the ViewSnapshotRequest. Preserved for compatibility when this API got moved to OpenAPI. Not used for any processing.</p>
		 * @type {number}
		 * @memberof QuerySnapshotResult
		 */
		viewId?: number;
	}
	
	/**
	 * @export
	 * @namespace QuerySnapshotResult
	 */
	export namespace QuerySnapshotResult {
		/**
		 * <p>Discriminator field</p>
		 */
		export enum TypeEnum {
			QuerySnapshotResult = 'QuerySnapshotResult'
		}
	
		/**
		 * <p>The query result or error response. This is opaque at the API level but contains one of the following DTO types:</p>
		 * <ul>
		 * <li>ViewSnapshot (success)</li>
		 * <li>ViewSnapshotFetchTimeout (error)</li>
		 * <li>ViewSnapshotTooManyActiveQueries (error)</li>
		 * <li>ViewSnapshotTopologySizeOverflow (error)</li>
		 * <li>ViewSnapshotDataUnavailable (error)
		 * Use the _type field to discriminate between types.</li>
		 * </ul>
		 */
		export interface ViewSnapshotResponse {
		  // OpenAPI `type: object` without properties
		  [name: string]: unknown
		}
	
	}

	export interface QueryViewArguments {
		/**
		 * Value for discriminator in Api.TimelineSummaryRequest.Arguments
		 */
		_type: 'QueryViewArguments';
	
		query: string;
		/**
		 * @description <p>Date/time representation in milliseconds since epoch (1970-01-01 00:00:00)</p>
		 * @type {number}
		 * @memberof QueryViewArguments
		 */
		queryTime?: number;
	}
	
	/**
	 * @export
	 * @namespace QueryViewArguments
	 */
	export namespace QueryViewArguments {
		export enum TypeEnum {
			QueryViewArguments = 'QueryViewArguments'
		}
	
	}

	export enum QueryViewFlag {
		NotUnlockable = 'NotUnlockable',
		HideFromViewsOverview = 'HideFromViewsOverview'
	}

	export interface RatioField extends Api.BaseComponentField {
		/**
		 * Value for discriminator in Api.ComponentField
		 */
		_type: 'RatioField';
	
		/**
		 * @type {number}
		 * @memberof RatioField
		 */
		numerator: number;
		/**
		 * @type {number}
		 * @memberof RatioField
		 */
		denominator: number;
		status?: Api.HealthStateValue;
	}
	
	/**
	 * @export
	 * @namespace RatioField
	 */
	export namespace RatioField {
		export enum TypeEnum {
			RatioField = 'RatioField'
		}
	
	}

	/**
	 * <p>Helps rendering columns that summarize success rates</p>
	 */
	export interface RatioProjection {
		/**
		 * Value for discriminator in Api.ComponentOverviewProjection
		 */
		_type: 'RatioProjection';
	
		/**
		 * @description <p>Cel expression that returns a number</p>
		 * @type {string}
		 * @memberof RatioProjection
		 */
		numerator: string;
		/**
		 * @description <p>Cel expression that returns a number</p>
		 * @type {string}
		 * @memberof RatioProjection
		 */
		denominator: string;
		/**
		 * @description <p>Cel expression that returns a string that represents a valid HealthState</p>
		 * @type {string}
		 * @memberof RatioProjection
		 */
		status?: string;
	}
	
	/**
	 * @export
	 * @namespace RatioProjection
	 */
	export namespace RatioProjection {
		export enum TypeEnum {
			RatioProjection = 'RatioProjection'
		}
	
	}

	export interface ReadyStatusCell {
		/**
		 * Value for discriminator in Api.CellValue
		 */
		_type: 'ReadyStatusCell';
	
		/**
		 * @type {number}
		 * @memberof ReadyStatusCell
		 */
		ready?: number;
		/**
		 * @type {number}
		 * @memberof ReadyStatusCell
		 */
		total?: number;
		status?: Api.HealthStateValue;
	}
	
	/**
	 * @export
	 * @namespace ReadyStatusCell
	 */
	export namespace ReadyStatusCell {
		export enum TypeEnum {
			ReadyStatusCell = 'ReadyStatusCell'
		}
	
	}

	export interface ReadyStatusMetaDisplay {
		/**
		 * Value for discriminator in Api.OverviewColumnMetaDisplay
		 */
		_type: 'ReadyStatusMetaDisplay';
	
	  // OpenAPI `type: object` without properties
	  [name: string]: unknown
	}
	
	/**
	 * @export
	 * @namespace ReadyStatusMetaDisplay
	 */
	export namespace ReadyStatusMetaDisplay {
		export enum TypeEnum {
			ReadyStatusMetaDisplay = 'ReadyStatusMetaDisplay'
		}
	
	}

	/**
	 * <p>A resolved related resource definition returned in the FullComponent response.
	 * The backend merges related resources from all matching presentations, resolves template variables
	 * in the stql field, and derives the name from the referenced presentation&#39;s PresentationName.
	 * Array order in the response determines display order.</p>
	 */
	export interface RelatedResource {
		/**
		 * @description <p>Identity key for this related resource.</p>
		 * @type {string}
		 * @memberof RelatedResource
		 */
		resourceId: string;
		/**
		 * @description <p>Section heading displayed in the UI.</p>
		 * @type {string}
		 * @memberof RelatedResource
		 */
		title: string;
		/**
		 * @description <p>Resolved STQL query with template variables substituted.</p>
		 * @type {string}
		 * @memberof RelatedResource
		 */
		stql: string;
		/**
		 * @description <p>ComponentPresentation identifier whose overview spec is used for rendering.</p>
		 * @type {string}
		 * @memberof RelatedResource
		 */
		presentationIdentifier: string;
	}

	export interface RelationData {
		tags: string[];
		health?: Api.HealthStateValue;
		identifiers: string[];
		description?: string;
		/**
		 * @type {number}
		 * @memberof RelationData
		 */
		id?: number;
		/**
		 * @type {number}
		 * @memberof RelationData
		 */
		lastUpdateTimestamp?: number;
		name?: string;
		dependencyDirection: Api.DependencyDirection;
	}

	export enum ReleaseStatus {
		AVAILABLE = 'AVAILABLE',
		ENABLED = 'ENABLED',
		COMINGSOON = 'COMING_SOON',
		HIDDEN = 'HIDDEN',
		BROKEN = 'BROKEN'
	}

	export type RequestError = Api.TopologyOverflowError | Api.RequestValidationError;

	export interface RequestValidationError {
		/**
		 * Value for discriminator in Api.RequestError
		 */
		_type: 'RequestValidationError';
	
		message: string;
	}
	
	/**
	 * @export
	 * @namespace RequestValidationError
	 */
	export namespace RequestValidationError {
		export enum TypeEnum {
			RequestValidationError = 'RequestValidationError'
		}
	
	}

	export interface ResolvedComponentPresentationLink {
		/**
		 * Value for discriminator in Api.ComponentPresentationLink
		 */
		_type: 'ResolvedComponentPresentationLink';
	
		/**
		 * @description <p>Identity key for this link.</p>
		 * @type {string}
		 * @memberof ResolvedComponentPresentationLink
		 */
		linkId: string;
		/**
		 * @description <p>Displayed link title.</p>
		 * @type {string}
		 * @memberof ResolvedComponentPresentationLink
		 */
		title: string;
		/**
		 * @description <p>Relative or fully-qualified link target.</p>
		 * @type {string}
		 * @memberof ResolvedComponentPresentationLink
		 */
		target: string;
		/**
		 * @description <p>Whether the link opens in a new tab.</p>
		 * @type {boolean}
		 * @memberof ResolvedComponentPresentationLink
		 */
		openInNewTab: boolean;
		/**
		 * @description <p>Optional tooltip text.</p>
		 * @type {string}
		 * @memberof ResolvedComponentPresentationLink
		 */
		tooltip?: string;
	}
	
	/**
	 * @export
	 * @namespace ResolvedComponentPresentationLink
	 */
	export namespace ResolvedComponentPresentationLink {
		export enum TypeEnum {
			ResolvedComponentPresentationLink = 'ResolvedComponentPresentationLink'
		}
	
	}

	export interface Role {
		role?: string;
	}

	export interface RoleNotAvailableError {
		_type: Api.RoleNotAvailableError.TypeEnum;
		role: string;
	}
	
	/**
	 * @export
	 * @namespace RoleNotAvailableError
	 */
	export namespace RoleNotAvailableError {
		export enum TypeEnum {
			RoleNotAvailableError = 'RoleNotAvailableError'
		}
	
	}

	export interface Roles {
		roles: string[];
	}

	export interface ScriptLocation {
		/**
		 * @type {number}
		 * @memberof ScriptLocation
		 */
		line: number;
		/**
		 * @type {number}
		 * @memberof ScriptLocation
		 */
		column: number;
	}

	export interface ServerInfo {
		version: Api.ServerVersion;
		deploymentMode: Api.ServerInfo.DeploymentModeEnum;
		/**
		 * @description <p>The version value is a semantic version, based on the official Semantic Versioning spec (<a href="https://semver.org/">https://semver.org/</a>).</p>
		 * @type {string}
		 * @memberof ServerInfo
		 */
		platformVersion?: string;
		applicationDomains: Api.ApplicationDomain[];
	}
	
	/**
	 * @export
	 * @namespace ServerInfo
	 */
	export namespace ServerInfo {
		export enum DeploymentModeEnum {
			Saas = 'Saas',
			SelfHosted = 'SelfHosted'
		}
	
	}

	export interface ServerVersion {
		/**
		 * @type {number}
		 * @memberof ServerVersion
		 */
		major: number;
		/**
		 * @type {number}
		 * @memberof ServerVersion
		 */
		minor: number;
		/**
		 * @type {number}
		 * @memberof ServerVersion
		 */
		patch: number;
		diff: string;
		commit: string;
		isDev: boolean;
	}

	export interface ServiceToken {
		/**
		 * @type {number}
		 * @memberof ServiceToken
		 */
		readonly id?: number;
		/**
		 * @type {number}
		 * @memberof ServiceToken
		 */
		readonly lastUpdateTimestamp?: number;
		name: string;
		description?: string;
		/**
		 * @type {number}
		 * @memberof ServiceToken
		 */
		expiration?: number;
		roles: string[];
		dedicatedSubject?: string;
	}

	export interface ServiceTokenCreatedResponse {
		readonly name: string;
		readonly token: string;
		/**
		 * @type {number}
		 * @memberof ServiceTokenCreatedResponse
		 */
		readonly expiration?: number;
	}

	export type ServiceTokenCreateError = Api.ServiceTokenInvalidExpiryError;

	export interface ServiceTokenInvalidExpiryError {
		/**
		 * Value for discriminator in Api.ServiceTokenCreateError
		 */
		_type: 'ServiceTokenInvalidExpiryError';
	
		message: string;
	}
	
	/**
	 * @export
	 * @namespace ServiceTokenInvalidExpiryError
	 */
	export namespace ServiceTokenInvalidExpiryError {
		export enum TypeEnum {
			ServiceTokenInvalidExpiryError = 'ServiceTokenInvalidExpiryError'
		}
	
	}

	/**
	 * <p>A silencing rule as returned by the API</p>
	 */
	export interface SilencingRule {
		/**
		 * @description <p>Unique URN for this silencing rule.</p>
		 * @type {string}
		 * @memberof SilencingRule
		 */
		identifier: string;
		note: string;
		/**
		 * @type {number}
		 * @memberof SilencingRule
		 */
		expiryEpochSeconds?: number;
		/**
		 * @description <p>Selects what to silence. Discriminated by <code>type</code> to allow future selector variants.</p>
		 * @type {Api.SilencingRuleSelector}
		 * @memberof SilencingRule
		 */
		selector: Api.SilencingRuleSelector;
	}

	export interface SilencingRuleApiError {
		message: string;
	}

	export interface SilencingRuleConflictError {
		message: string;
		/**
		 * @description <p>The identifier of the already-active silencing rule.</p>
		 * @type {string}
		 * @memberof SilencingRuleConflictError
		 */
		existingIdentifier: string;
	}

	export interface SilencingRuleList {
		silencingRules: Api.SilencingRule[];
	}

	export interface SilencingRuleNotFoundError {
		identifier: string;
		_type: Api.SilencingRuleNotFoundError.TypeEnum;
	}
	
	/**
	 * @export
	 * @namespace SilencingRuleNotFoundError
	 */
	export namespace SilencingRuleNotFoundError {
		export enum TypeEnum {
			SilencingRuleNotFoundError = 'SilencingRuleNotFoundError'
		}
	
	}

	export type SilencingRuleSelector = Api.MonitorCheckStateSelector;

	export interface SlackChannel {
		name: string;
		id: string;
	}

	export interface SlackChannelId {
		id: string;
	}

	export interface SlackChannelRefId {
		/**
		 * Value for discriminator in Api.ChannelReferenceId
		 */
		_type: 'SlackChannelRefId';
	
		/**
		 * @type {number}
		 * @memberof SlackChannelRefId
		 */
		id: number;
	}
	
	/**
	 * @export
	 * @namespace SlackChannelRefId
	 */
	export namespace SlackChannelRefId {
		export enum TypeEnum {
			SlackChannelRefId = 'SlackChannelRefId'
		}
	
	}

	export interface SlackChannelsChunk {
		channels: Api.SlackChannel[];
		next_cursor?: string;
	}

	export interface SlackNotificationChannel extends Api.BaseNotificationChannel {
		/**
		 * Value for discriminator in Api.NotificationChannel
		 */
		_type: 'SlackNotificationChannel';
	
		slackWorkspace: string;
		slackChannel?: string;
		slackChannelId?: string;
	}
	
	/**
	 * @export
	 * @namespace SlackNotificationChannel
	 */
	export namespace SlackNotificationChannel {
		export enum TypeEnum {
			SlackNotificationChannel = 'SlackNotificationChannel'
		}
	
	}

	export interface SourceLink {
		title: string;
		url: string;
	}

	export interface Span {
		/**
		 * @description <p>Start time of the span</p>
		 * @type {Api.InstantNanoPrecision}
		 * @memberof Span
		 */
		startTime: Api.InstantNanoPrecision;
		/**
		 * @description <p>End time of the span</p>
		 * @type {Api.InstantNanoPrecision}
		 * @memberof Span
		 */
		endTime: Api.InstantNanoPrecision;
		/**
		 * @description <p>Duration of the span in nanoseconds</p>
		 * @type {number}
		 * @memberof Span
		 */
		durationNanos: number;
		/**
		 * @description <p>The unique identifier for the trace, all spans of the same trace share the same trace_id</p>
		 * @type {string}
		 * @memberof Span
		 */
		traceId: string;
		/**
		 * @description <p>The unique identifier of the span within the trace</p>
		 * @type {string}
		 * @memberof Span
		 */
		spanId: string;
		/**
		 * @description <p>The id of the parent span of this span. Empty if this is the root span</p>
		 * @type {string}
		 * @memberof Span
		 */
		parentSpanId?: string;
		/**
		 * @description <p>Can contain vendor specific trace identification information <a href="https://www.w3.org/TR/trace-context/#tracestate-header">https://www.w3.org/TR/trace-context/#tracestate-header</a></p>
		 * @type {string}
		 * @memberof Span
		 */
		traceState?: string;
		/**
		 * @description <p>A description of the span&#39;s operation. For example, the name can be a qualified method name or a file name and a line number where the operation is called</p>
		 * @type {string}
		 * @memberof Span
		 */
		spanName: string;
		/**
		 * @description <p>Logical name of the service for the span</p>
		 * @type {string}
		 * @memberof Span
		 */
		serviceName: string;
		/**
		 * @description <p>The type of span. Distinguishes between spans generated in a particular context.</p>
		 * @type {Api.SpanKind}
		 * @memberof Span
		 */
		spanKind: Api.SpanKind;
		/**
		 * @description <p>The type of relation of the parent with respect to the span.</p>
		 * @type {Api.SpanParentType}
		 * @memberof Span
		 */
		spanParentType: Api.SpanParentType;
		/**
		 * @description <p>Attributes (key/value pairs) describing the span.</p>
		 * @type {{ [name: string]: string }}
		 * @memberof Span
		 */
		spanAttributes: { [name: string]: string };
		/**
		 * @description <p>Reference to shared resource attributes, used to deduplicate repeated resource data.</p>
		 * @type {string}
		 * @memberof Span
		 */
		resourceId: string;
		/**
		 * @description <p>The status of the operation for the span</p>
		 * @type {Api.SpanStatusCode}
		 * @memberof Span
		 */
		statusCode: Api.SpanStatusCode;
		/**
		 * @description <p>Human readable message for the status</p>
		 * @type {string}
		 * @memberof Span
		 */
		statusMessage?: string;
		/**
		 * @description <p>The name of the instrumentation scope for the span <a href="https://opentelemetry.io/docs/specs/otel/glossary/#instrumentation-scope">https://opentelemetry.io/docs/specs/otel/glossary/#instrumentation-scope</a></p>
		 * @type {string}
		 * @memberof Span
		 */
		scopeName?: string;
		/**
		 * @description <p>The version for the instrumentation scope for the span <a href="https://opentelemetry.io/docs/specs/otel/glossary/#instrumentation-scope">https://opentelemetry.io/docs/specs/otel/glossary/#instrumentation-scope</a></p>
		 * @type {string}
		 * @memberof Span
		 */
		scopeVersion?: string;
		/**
		 * @description <p>Time-stamped annotations on the span providing extra application context</p>
		 * @type {Api.SpanEvent[]}
		 * @memberof Span
		 */
		events: Api.SpanEvent[];
		/**
		 * @description <p>Links to related spans in the same or in other traces</p>
		 * @type {Api.SpanLink[]}
		 * @memberof Span
		 */
		links: Api.SpanLink[];
	}

	export interface SpanComponent {
		/**
		 * @type {number}
		 * @memberof SpanComponent
		 */
		id: number;
		identifier: string;
		name: string;
		type: string;
		healthState: Api.HealthStateValue;
	}

	export interface SpanComponents {
		components: Api.SpanComponent[];
	}

	/**
	 * <p>Event is a time-stamped annotation of the span, consisting of user-supplied text description and key-value pairs.</p>
	 */
	export interface SpanEvent {
		/**
		 * @description <p>A custom representation for a date/time that needs better than milliseconds precision. Simply using nanoseconds since epoch results in integers that are too big to be represented correctly in Javascript (which is limited to 2^53-1). Instead this uses the standard representation of milliseconds since epoch with a nanosecond offset. Calculate nanoseconds since epoch like this <code>nanosSinceEpoch = timestamp * 1000000 + offsetNanos</code>.</p>
		 * @type {Api.InstantNanoPrecision}
		 * @memberof SpanEvent
		 */
		timestamp: Api.InstantNanoPrecision;
		name: string;
		/**
		 * @description <p>Set of key/value pairs providing extra contextual information. Keys are unique.</p>
		 * @type {{ [name: string]: string }}
		 * @memberof SpanEvent
		 */
		attributes: { [name: string]: string };
	}

	export interface SpanFilter {
		/**
		 * @description <p>Filter spans by service name</p>
		 * @type {string[]}
		 * @memberof SpanFilter
		 */
		serviceName?: string[];
		/**
		 * @description <p>Filter spans by name</p>
		 * @type {string[]}
		 * @memberof SpanFilter
		 */
		spanName?: string[];
		/**
		 * @description <p>Filter spans by 1 or more attributes</p>
		 * @type {{ [name: string]: string[] }}
		 * @memberof SpanFilter
		 */
		attributes?: { [name: string]: string[] };
		/**
		 * @description <p>Filter span by kind</p>
		 * @type {Api.SpanKind[]}
		 * @memberof SpanFilter
		 */
		spanKind?: Api.SpanKind[];
		/**
		 * @description <p>Filter span by parent type</p>
		 * @type {Api.SpanParentType[]}
		 * @memberof SpanFilter
		 */
		spanParentType?: Api.SpanParentType[];
		/**
		 * @description <p>Filter spans by duration &gt;= value, in nanoseconds</p>
		 * @type {number}
		 * @memberof SpanFilter
		 */
		durationFromNanos?: number;
		/**
		 * @description <p>Filter spans by duration &lt; value, in nanoseconds</p>
		 * @type {number}
		 * @memberof SpanFilter
		 */
		durationToNanos?: number;
		/**
		 * @description <p>Filter spans by the StatusCode</p>
		 * @type {Api.SpanStatusCode[]}
		 * @memberof SpanFilter
		 */
		statusCode?: Api.SpanStatusCode[];
		/**
		 * @description <p>Filter spans by trace id, use only this filter to get a complete trace</p>
		 * @type {string[]}
		 * @memberof SpanFilter
		 */
		traceId?: string[];
		/**
		 * @description <p>Filter spans by span id, use only this filter to get a single span</p>
		 * @type {string[]}
		 * @memberof SpanFilter
		 */
		spanId?: string[];
		/**
		 * @description <p>Filter spans by scope</p>
		 * @type {string[]}
		 * @memberof SpanFilter
		 */
		scopeName?: string[];
		/**
		 * @description <p>Filter spans by scope version</p>
		 * @type {string[]}
		 * @memberof SpanFilter
		 */
		scopeVersion?: string[];
	}

	export enum SpanKind {
		Client = 'Client',
		Consumer = 'Consumer',
		Internal = 'Internal',
		Producer = 'Producer',
		Server = 'Server',
		Unspecified = 'Unspecified'
	}

	/**
	 * <p>A pointer from the current span to another span in the same trace or in a different trace. 
	 * For example, this can be used in batching operations, where a single batch handler processes 
	 * multiple requests from different traces or when the handler receives a request from a different project.</p>
	 */
	export interface SpanLink {
		traceId: string;
		spanId: string;
		traceState?: string;
		/**
		 * @description <p>Set of key/value pairs providing extra contextual information. Keys are unique.</p>
		 * @type {{ [name: string]: string }}
		 * @memberof SpanLink
		 */
		attributes: { [name: string]: string };
	}

	export enum SpanParentType {
		External = 'External',
		Internal = 'Internal',
		Root = 'Root'
	}

	/**
	 * <p>The result of looking up a span. As an optimization to reduce duplication, resource attributes are inlined at the
	 * root-level of the schema.</p>
	 */
	export interface SpanResponse {
		span: Api.Span;
		/**
		 * @description <p>Set of key/value pairs providing extra contextual information. Keys are unique.</p>
		 * @type {{ [name: string]: string }}
		 * @memberof SpanResponse
		 */
		resourceAttributes: { [name: string]: string };
	}

	export enum SpanSortDirection {
		Ascending = 'Ascending',
		Descending = 'Descending'
	}

	export enum SpanSortField {
		StartTime = 'StartTime',
		ServiceName = 'ServiceName',
		SpanName = 'SpanName',
		SpanKind = 'SpanKind',
		SpanParentType = 'SpanParentType',
		DurationNanos = 'DurationNanos',
		SpanStatusCode = 'SpanStatusCode',
		TraceId = 'TraceId',
		SpanId = 'SpanId',
		ScopeName = 'ScopeName',
		ScopeVersion = 'ScopeVersion'
	}

	export interface SpanSortOption {
		field: Api.SpanSortField;
		direction: Api.SpanSortDirection;
	}

	export enum SpanStatusCode {
		Error = 'Error',
		Ok = 'Ok',
		Unset = 'Unset'
	}

	export enum SpanSuggestionField {
		ServiceName = 'ServiceName',
		SpanName = 'SpanName',
		ScopeName = 'ScopeName',
		ScopeVersion = 'ScopeVersion'
	}

	export interface StackElementNotFound {
		/**
		 * Discriminator property
		 */
		_type: Api.StackElementNotFound.TypeEnum;
		
		objectType: string;
		objectId: string;
		message: string;
		/**
		 * @type {number}
		 * @memberof StackElementNotFound
		 */
		existedEarlierMs?: number;
		/**
		 * @type {number}
		 * @memberof StackElementNotFound
		 */
		existsLaterMs?: number;
	}
	
	/**
	 * @export
	 * @namespace StackElementNotFound
	 */
	export namespace StackElementNotFound {
		export enum TypeEnum {
			StackElementNotFound = 'StackElementNotFound'
		}
	
	}

	export interface StackPack {
		name: string;
		displayName: string;
		version: string;
		logo?: string;
		categories: string[];
		isNew: boolean;
		overviewUrl?: string;
		detailedOverviewUrl?: string;
		resourcesUrl?: string;
		faqs: Api.FAQ[];
		configurationUrls: (string[])[];
		releaseStatus: Api.ReleaseStatus;
		isCompatible: boolean;
	}

	export interface StackPackConfiguration {
		/**
		 * @type {number}
		 * @memberof StackPackConfiguration
		 */
		id?: number;
		/**
		 * @type {number}
		 * @memberof StackPackConfiguration
		 */
		lastUpdateTimestamp?: number;
		status: string;
		error?: Api.StackPackError;
		stackPackVersion: string;
		config: Api.StackPackConfiguration.Config;
	}
	
	/**
	 * @export
	 * @namespace StackPackConfiguration
	 */
	export namespace StackPackConfiguration {
		export interface Config {
		  // OpenAPI `type: object` without properties
		  [name: string]: unknown
		}
	
	}

	export interface StackPackError {
		retryable: boolean;
		action?: string;
		error: Api.StackPackError.Error;
	}
	
	/**
	 * @export
	 * @namespace StackPackError
	 */
	export namespace StackPackError {
		export interface Error {
		  // OpenAPI `type: object` without properties
		  [name: string]: unknown
		}
	
	}

	export interface StackPackIntegration {
		name: string;
		displayName: string;
		logo?: string;
		brandIcon?: string;
		categories: string[];
		isNew: boolean;
		overviewUrl?: string;
		resourceUrl?: string;
		faqs: Api.FAQ[];
	}

	export interface StackPackStep {
		display?: string;
		name?: string;
		value?: Api.StackPackStep.Value;
	}
	
	/**
	 * @export
	 * @namespace StackPackStep
	 */
	export namespace StackPackStep {
		export interface Value {
			_type?: string;
		}
	
	}

	export interface StackPackUpload {
		stackPack?: string | Blob;
	}
	
	/**
	 * @export
	 * @namespace StackPackUpload
	 */
	export namespace StackPackUpload {
		export interface MultipartFormData {
			stackPack?: Api.StackPackUpload.MultipartFormData.StackPackPart;
		}
		
		/**
		 * @export
		 * @namespace MultipartFormData
		 */
		export namespace MultipartFormData {
			export interface StackPackPart {
				value: string | Blob;
				filename?: string;
			}
		
		}
	
		export interface MultipartFormData2 {
			stackPack?: Api.StackPackUpload.MultipartFormData2.StackPackPart;
		}
		
		/**
		 * @export
		 * @namespace MultipartFormData2
		 */
		export namespace MultipartFormData2 {
			export interface StackPackPart {
				value: string | Blob;
				filename?: string;
			}
		
		}
	
	}

	export interface StackPackVersionInfo {
		version: string;
		isDev: boolean;
		isInUse: boolean;
	}

	export interface StatChart {
		/**
		 * Value for discriminator in Api.Chart
		 */
		_type: 'StatChart';
	
		unit?: string;
		/**
		 * @type {number}
		 * @memberof StatChart
		 */
		decimals?: number;
		sparkline?: boolean;
		calculation?: Api.ChartCalculation;
		thresholds?: Api.ChartStatThresholds;
	}
	
	/**
	 * @export
	 * @namespace StatChart
	 */
	export namespace StatChart {
		export enum TypeEnum {
			StatChart = 'StatChart'
		}
	
	}

	export interface StreamList {
		items: Api.StreamListItem[];
	}

	export interface StreamListItem {
		urn: string;
		consistencyModel: string;
		/**
		 * @type {number}
		 * @memberof StreamListItem
		 */
		subStreams: number;
	}

	export interface StringItemsWithTotal {
		items: string[];
		/**
		 * @type {number}
		 * @memberof StringItemsWithTotal
		 */
		total: number;
	}

	export interface SubjectConfig {
		handle: string;
		source: Api.SubjectSource;
	}

	export enum SubjectSource {
		Static = 'Static',
		Observability = 'Observability',
		Kubernetes = 'Kubernetes'
	}

	export interface Subscription {
		tenant: string;
		/**
		 * @type {number}
		 * @memberof Subscription
		 */
		expiryTimestampMs?: number;
		plan: string;
	}

	export type SubscriptionState = Api.ExpiredSubscription | Api.UnlicensedSubscription | Api.LicensedSubscription;

	export interface SubStreamList {
		subStreams: Api.SubStreamListItem[];
	}

	export interface SubStreamListItem {
		subStreamId: string;
		subStreamState: Api.HealthSubStreamConsistencyState;
		/**
		 * @type {number}
		 * @memberof SubStreamListItem
		 */
		checkStateCount: number;
	}

	export interface Suggestions {
		suggestions: string[];
	}

	export interface SystemNotification {
		notificationId: string;
		title: string;
		severity: Api.SystemNotificationSeverity;
		/**
		 * @type {number}
		 * @memberof SystemNotification
		 */
		notificationTimeEpochMs: number;
		content: string;
		toast: boolean;
	}

	export interface SystemNotifications {
		notifications: Api.SystemNotification[];
	}

	export enum SystemNotificationSeverity {
		Info = 'info',
		Ok = 'ok',
		Warning = 'warning',
		Problem = 'problem'
	}

	export interface TagField extends Api.BaseComponentField {
		/**
		 * Value for discriminator in Api.ComponentField
		 */
		_type: 'TagField';
	
		values: string[];
	}
	
	/**
	 * @export
	 * @namespace TagField
	 */
	export namespace TagField {
		export enum TypeEnum {
			TagField = 'TagField'
		}
	
	}

	/**
	 * <p>Tag-based filter. Uses indexed tags via <code>tagKey</code>.</p>
	 */
	export interface TagFilter {
		/**
		 * Value for discriminator in Api.ComponentPresentationFilterDefinition
		 */
		_type: 'TagFilter';
	
		/**
		 * @description <p>Tag key used for filtering and value lookup.</p>
		 * @type {string}
		 * @memberof TagFilter
		 */
		tagKey: string;
	}
	
	/**
	 * @export
	 * @namespace TagFilter
	 */
	export namespace TagFilter {
		export enum TypeEnum {
			TagFilter = 'TagFilter'
		}
	
	}

	export interface TagProjection {
		/**
		 * Value for discriminator in Api.ComponentHighlightProjection
		 */
		_type: 'TagProjection';
	
	  // OpenAPI `type: object` without properties
	  [name: string]: unknown
	}
	
	/**
	 * @export
	 * @namespace TagProjection
	 */
	export namespace TagProjection {
		export enum TypeEnum {
			TagProjection = 'TagProjection'
		}
	
	}

	export interface TeamsChannelRefId {
		/**
		 * Value for discriminator in Api.ChannelReferenceId
		 */
		_type: 'TeamsChannelRefId';
	
		/**
		 * @type {number}
		 * @memberof TeamsChannelRefId
		 */
		id: number;
	}
	
	/**
	 * @export
	 * @namespace TeamsChannelRefId
	 */
	export namespace TeamsChannelRefId {
		export enum TypeEnum {
			TeamsChannelRefId = 'TeamsChannelRefId'
		}
	
	}

	export interface TeamsChannelWriteSchema {
		url: string;
	}

	export interface TeamsNotificationChannel extends Api.BaseNotificationChannel, Api.TeamsChannelWriteSchema {
		/**
		 * Value for discriminator in Api.NotificationChannel
		 */
		_type: 'TeamsNotificationChannel';
	
	  // OpenAPI `type: object` without properties
	  [name: string]: unknown
	}
	
	/**
	 * @export
	 * @namespace TeamsNotificationChannel
	 */
	export namespace TeamsNotificationChannel {
		export enum TypeEnum {
			TeamsNotificationChannel = 'TeamsNotificationChannel'
		}
	
	}

	export interface TextCell {
		/**
		 * Value for discriminator in Api.CellValue
		 */
		_type: 'TextCell';
	
		value: string;
	}
	
	/**
	 * @export
	 * @namespace TextCell
	 */
	export namespace TextCell {
		export enum TypeEnum {
			TextCell = 'TextCell'
		}
	
	}

	export interface TextField extends Api.BaseComponentField {
		/**
		 * Value for discriminator in Api.ComponentField
		 */
		_type: 'TextField';
	
		value: string;
		asTag: boolean;
	}
	
	/**
	 * @export
	 * @namespace TextField
	 */
	export namespace TextField {
		export enum TypeEnum {
			TextField = 'TextField'
		}
	
	}

	export interface TextMetaDisplay {
		/**
		 * Value for discriminator in Api.OverviewColumnMetaDisplay
		 */
		_type: 'TextMetaDisplay';
	
	  // OpenAPI `type: object` without properties
	  [name: string]: unknown
	}
	
	/**
	 * @export
	 * @namespace TextMetaDisplay
	 */
	export namespace TextMetaDisplay {
		export enum TypeEnum {
			TextMetaDisplay = 'TextMetaDisplay'
		}
	
	}

	export interface TextProjection {
		/**
		 * Value for discriminator in Api.ComponentOverviewProjection
		 */
		_type: 'TextProjection';
	
		/**
		 * @description <p>Cel expression that returns a string</p>
		 * @type {string}
		 * @memberof TextProjection
		 */
		value: string;
		/**
		 * @description <p>Should the value be rendered as a tag or as plain text</p>
		 * @type {boolean}
		 * @memberof TextProjection
		 */
		asTag?: boolean;
	}
	
	/**
	 * @export
	 * @namespace TextProjection
	 */
	export namespace TextProjection {
		export enum TypeEnum {
			TextProjection = 'TextProjection'
		}
	
	}

	export interface TimelineSummary {
		buckets: Api.TimelineSummaryEventBucket[];
		healthHistory: Api.TimelineSummaryHealthChange[];
		/**
		 * @type {number}
		 * @memberof TimelineSummary
		 */
		fromTime: number;
	}

	export interface TimelineSummaryError {
		message: string;
	}

	export interface TimelineSummaryEventBucket {
		/**
		 * Discriminator property
		 */
		_type: Api.TimelineSummaryEventBucket.TypeEnum;
		
		/**
		 * @type {number}
		 * @memberof TimelineSummaryEventBucket
		 */
		count: number;
		/**
		 * @type {number}
		 * @memberof TimelineSummaryEventBucket
		 */
		startTimeEpochMillis: number;
		/**
		 * @type {number}
		 * @memberof TimelineSummaryEventBucket
		 */
		endTimeEpochMillis?: number;
	}
	
	/**
	 * @export
	 * @namespace TimelineSummaryEventBucket
	 */
	export namespace TimelineSummaryEventBucket {
		export enum TypeEnum {
			TimelineSummaryEventBucket = 'TimelineSummaryEventBucket'
		}
	
	}

	export interface TimelineSummaryHealthChange {
		/**
		 * Discriminator property
		 */
		_type: Api.TimelineSummaryHealthChange.TypeEnum;
		
		/**
		 * @type {number}
		 * @memberof TimelineSummaryHealthChange
		 */
		timestamp: number;
		newHealth: Api.HealthStateValue;
	}
	
	/**
	 * @export
	 * @namespace TimelineSummaryHealthChange
	 */
	export namespace TimelineSummaryHealthChange {
		export enum TypeEnum {
			TimelineSummaryHealthChange = 'TimelineSummaryHealthChange'
		}
	
	}

	export interface TimelineSummaryOverflow {
		message: string;
	}

	export interface TimelineSummaryRequest {
		arguments: Api.ComponentViewArguments | Api.QueryViewArguments;
		/**
		 * @description <p>Date/time representation in milliseconds since epoch (1970-01-01 00:00:00)</p>
		 * @type {number}
		 * @memberof TimelineSummaryRequest
		 */
		startTime: number;
		/**
		 * @description <p>Date/time representation in milliseconds since epoch (1970-01-01 00:00:00)</p>
		 * @type {number}
		 * @memberof TimelineSummaryRequest
		 */
		endTime?: number;
		/**
		 * @type {number}
		 * @memberof TimelineSummaryRequest
		 */
		histogramBucketCount: number;
		eventFilters?: Api.EventFilters;
	}

	export interface TimeSeriesChart {
		/**
		 * Value for discriminator in Api.Chart
		 */
		_type: 'TimeSeriesChart';
	
		unit?: string;
		/**
		 * @type {number}
		 * @memberof TimeSeriesChart
		 */
		decimals?: number;
		/**
		 * @type {number}
		 * @memberof TimeSeriesChart
		 */
		min?: number;
		/**
		 * @type {number}
		 * @memberof TimeSeriesChart
		 */
		max?: number;
		connectNulls?: boolean;
		thresholds?: Api.ChartThresholds;
	}
	
	/**
	 * @export
	 * @namespace TimeSeriesChart
	 */
	export namespace TimeSeriesChart {
		export enum TypeEnum {
			TimeSeriesChart = 'TimeSeriesChart'
		}
	
	}

	export interface TooManyActiveQueries {
		/**
		 * Value for discriminator in Api.GetCausingEventsServiceUnaivailable
		 */
		_type: 'TooManyActiveQueries';
	
		message: string;
	}
	
	/**
	 * @export
	 * @namespace TooManyActiveQueries
	 */
	export namespace TooManyActiveQueries {
		export enum TypeEnum {
			TooManyActiveQueries = 'TooManyActiveQueries'
		}
	
	}

	export interface TooManyTopologyResults {
		/**
		 * Value for discriminator in Api.GetCausingEventsResult
		 */
		_type: 'TooManyTopologyResults';
	
	  // OpenAPI `type: object` without properties
	  [name: string]: unknown
	}
	
	/**
	 * @export
	 * @namespace TooManyTopologyResults
	 */
	export namespace TooManyTopologyResults {
		export enum TypeEnum {
			TooManyTopologyResults = 'TooManyTopologyResults'
		}
	
	}

	export interface Topic {
		name: string;
	}

	export interface TopologyEvent {
		identifier: string;
		sourceIdentifier?: string;
		elementIdentifiers: string[];
		elements: Api.EventElement[];
		source: string;
		category: Api.EventCategory;
		description?: string;
		name: string;
		sourceLinks: Api.SourceLink[];
		data: Api.TopologyEvent.Data;
		eventType: string;
		/**
		 * @type {number}
		 * @memberof TopologyEvent
		 */
		eventTime: number;
		/**
		 * @type {number}
		 * @memberof TopologyEvent
		 */
		processedTime: number;
		tags: Api.EventTag[];
	}
	
	/**
	 * @export
	 * @namespace TopologyEvent
	 */
	export namespace TopologyEvent {
		export interface Data {
		  // OpenAPI `type: object` without properties
		  [name: string]: unknown
		}
	
	}

	export interface TopologyMatchResult {
		/**
		 * @type {number}
		 * @memberof TopologyMatchResult
		 */
		matchedCheckStates: number;
		unmatchedCheckStates: Api.UnmatchedCheckState[];
		multipleMatchesCheckStates: Api.MultipleMatchesCheckState[];
	}

	export interface TopologyOverflowError {
		/**
		 * Value for discriminator in Api.RequestError
		 */
		_type: 'TopologyOverflowError';
	
		/**
		 * @type {number}
		 * @memberof TopologyOverflowError
		 */
		maxSize: number;
	}
	
	/**
	 * @export
	 * @namespace TopologyOverflowError
	 */
	export namespace TopologyOverflowError {
		export enum TypeEnum {
			TopologyOverflowError = 'TopologyOverflowError'
		}
	
	}

	/**
	 * <p>Topology perspective config. Reuses QueryMetadata from the snapshot API
	 * as the rendering spec.</p>
	 */
	export interface TopologyPerspective {
		/**
		 * @description <p>Query execution settings</p>
		 * @type {Api.QueryMetadata}
		 * @memberof TopologyPerspective
		 */
		queryMetadata: Api.QueryMetadata;
	}

	export interface TopologyPromQLMetric {
		/**
		 * Discriminator property
		 */
		_type: Api.TopologyPromQLMetric.TypeEnum;
		
		/**
		 * @type {number}
		 * @memberof TopologyPromQLMetric
		 */
		id?: number;
		promQLQuery: string;
		unit: string;
		aliasTemplate: string;
		topologyQuery: string;
	}
	
	/**
	 * @export
	 * @namespace TopologyPromQLMetric
	 */
	export namespace TopologyPromQLMetric {
		export enum TypeEnum {
			TopologyPromQLMetric = 'TopologyPromQLMetric'
		}
	
	}

	/**
	 * <p>Rendering settings for the topology perspective.
	 * Near-copy of QueryMetadata used for topology rendering today; differences:</p>
	 * <ul>
	 * <li><code>queryTime</code> is intentionally absent (request-time state, not a presentation setting).
	 * Most-specific-wins merge semantics across matching ComponentPresentations.</li>
	 * </ul>
	 */
	export interface TopologySettings {
		groupingEnabled?: boolean;
		showIndirectRelations?: boolean;
		/**
		 * @type {number}
		 * @memberof TopologySettings
		 */
		minimumGroupSize?: number;
		groupedByLayers?: boolean;
		groupedByDomains?: boolean;
		groupedByRelations?: boolean;
		autoGrouping?: boolean;
		connectedComponents?: boolean;
		neighboringComponents?: boolean;
	}

	export interface TopologyStreamError {
		level: Api.MessageLevel;
		message: string;
		externalId?: string;
	}

	export interface TopologyStreamList {
		streams: Api.TopologyStreamListItem[];
	}

	export interface TopologyStreamListItem {
		syncIdentifier?: string | null;
		/**
		 * @type {number}
		 * @memberof TopologyStreamListItem
		 */
		nodeId: number;
		name: string;
		/**
		 * @type {number}
		 * @memberof TopologyStreamListItem
		 */
		createdRelations: number;
		/**
		 * @type {number}
		 * @memberof TopologyStreamListItem
		 */
		deletedRelations: number;
		/**
		 * @type {number}
		 * @memberof TopologyStreamListItem
		 */
		createdComponents: number;
		/**
		 * @type {number}
		 * @memberof TopologyStreamListItem
		 */
		deletedComponents: number;
		/**
		 * @type {number}
		 * @memberof TopologyStreamListItem
		 */
		errors: number;
		status: Api.TopologySyncStatus;
	}

	export interface TopologyStreamListItemWithErrorDetails {
		item: Api.TopologyStreamListItem;
		errorDetails: Api.TopologyStreamError[];
		metrics?: Api.TopologyStreamMetrics;
	}

	export interface TopologyStreamMetrics {
		/**
		 * @type {number}
		 * @memberof TopologyStreamMetrics
		 */
		bucketSizeSeconds: number;
		latencySeconds?: Api.MetricBucketValue2[];
	}

	export interface TopologySyncError {
		message: string;
	}

	export enum TopologySyncStatus {
		Running = 'Running',
		Resetting = 'Resetting',
		Deleting = 'Deleting',
		DeleteFailed = 'DeleteFailed'
	}

	export interface TopologyTimeOutOfRange {
		/**
		 * Value for discriminator in Api.GetCausingEventsBadRequest
		 */
		_type: 'TopologyTimeOutOfRange';
	
		message: string;
		/**
		 * @type {number}
		 * @memberof TopologyTimeOutOfRange
		 */
		topologyTimeMs: number;
		/**
		 * @type {number}
		 * @memberof TopologyTimeOutOfRange
		 */
		lowerBoundMs: number;
		upperBound: string;
	}
	
	/**
	 * @export
	 * @namespace TopologyTimeOutOfRange
	 */
	export namespace TopologyTimeOutOfRange {
		export enum TypeEnum {
			TopologyTimeOutOfRange = 'TopologyTimeOutOfRange'
		}
	
	}

	export interface Trace {
		/**
		 * @description <p>The id of the trace</p>
		 * @type {string}
		 * @memberof Trace
		 */
		traceId: string;
		/**
		 * @description <p>All spans for the trace</p>
		 * @type {Api.Span[]}
		 * @memberof Trace
		 */
		spans: Api.Span[];
		/**
		 * @description <p>Map of resource identifiers to their corresponding resource attributes (key/value pairs). Keys are UUIDs used in the spans’ <code>resourceId</code> fields.</p>
		 * @type {{ [name: string]: { [name: string]: string } }}
		 * @memberof Trace
		 */
		resources: { [name: string]: { [name: string]: string } };
	}

	export interface TraceApiError {
		message: string;
	}

	export interface TraceApiInvalidDurationFilter {
		/**
		 * Value for discriminator in Api.TraceApiSpansBadRequest
		 */
		_type: 'TraceApiInvalidDurationFilter';
	
		message: string;
		/**
		 * @type {number}
		 * @memberof TraceApiInvalidDurationFilter
		 */
		from: number;
		/**
		 * @type {number}
		 * @memberof TraceApiInvalidDurationFilter
		 */
		to: number;
	}
	
	/**
	 * @export
	 * @namespace TraceApiInvalidDurationFilter
	 */
	export namespace TraceApiInvalidDurationFilter {
		export enum TypeEnum {
			TraceApiInvalidDurationFilter = 'TraceApiInvalidDurationFilter'
		}
	
	}

	export interface TraceApiInvalidPagination {
		/**
		 * Value for discriminator in Api.TraceApiSpansBadRequest
		 */
		_type: 'TraceApiInvalidPagination';
	
		message: string;
		/**
		 * @type {number}
		 * @memberof TraceApiInvalidPagination
		 */
		pageSize: number;
	}
	
	/**
	 * @export
	 * @namespace TraceApiInvalidPagination
	 */
	export namespace TraceApiInvalidPagination {
		export enum TypeEnum {
			TraceApiInvalidPagination = 'TraceApiInvalidPagination'
		}
	
	}

	export interface TraceApiInvalidTimeRange {
		/**
		 * Value for discriminator in Api.TraceApiSpansBadRequest
		 */
		_type: 'TraceApiInvalidTimeRange';
	
		message: string;
		/**
		 * @description <p>Date/time representation in milliseconds since epoch (1970-01-01 00:00:00)</p>
		 * @type {number}
		 * @memberof TraceApiInvalidTimeRange
		 */
		from: number;
		/**
		 * @description <p>Date/time representation in milliseconds since epoch (1970-01-01 00:00:00)</p>
		 * @type {number}
		 * @memberof TraceApiInvalidTimeRange
		 */
		to: number;
	}
	
	/**
	 * @export
	 * @namespace TraceApiInvalidTimeRange
	 */
	export namespace TraceApiInvalidTimeRange {
		export enum TypeEnum {
			TraceApiInvalidTimeRange = 'TraceApiInvalidTimeRange'
		}
	
	}

	export interface TraceApiSpanNotFound {
		traceId: string;
		spanId: string;
	}

	export type TraceApiSpansBadRequest = Api.TraceApiInvalidTimeRange | Api.TraceApiInvalidPagination | Api.TraceApiInvalidDurationFilter;

	export interface TraceApiTraceNotFound {
		traceId: string;
	}

	/**
	 * <p>Filter traces that have a span that matches the primary filter and a span that matches the secondary filter. These could be the same, or two different spans of the same trace.</p>
	 */
	export interface TraceFilter {
		primarySpanFilter: Api.SpanFilter;
		secondarySpanFilter?: Api.SpanFilter;
	}

	/**
	 * <p>Find traces that have a span that matches the primary filter and a span that matches the secondary filter. These could be the same, or two different spans of the same trace.</p>
	 */
	export interface TraceQuery {
		primarySpanFilter: Api.SpanFilter;
		secondarySpanFilter?: Api.SpanFilter;
		sortBy?: Api.SpanSortOption[];
	}

	/**
	 * <p>A trace that matched the query filters. It structurally matches the Trace schema, with extra fields representing 
	 * the result of the trace query.</p>
	 */
	export interface TraceQueryMatch extends Api.Trace {
		/**
		 * @description <p>Spans matching the primary filter</p>
		 * @type {string[]}
		 * @memberof TraceQueryMatch
		 */
		primaryFilterMatches: string[];
		/**
		 * @description <p>Spans matching the secondary filter</p>
		 * @type {string[]}
		 * @memberof TraceQueryMatch
		 */
		secondaryFilterMatches: string[];
	}

	export interface TraceQueryResponse {
		/**
		 * @description <p>List of traces matching the query</p>
		 * @type {Api.TraceQueryMatch[]}
		 * @memberof TraceQueryResponse
		 */
		traces: Api.TraceQueryMatch[];
		/**
		 * @description <p>Maximum number of the traces in the result.</p>
		 * @type {number}
		 * @memberof TraceQueryResponse
		 */
		pageSize: number;
		/**
		 * @description <p>The requested page.</p>
		 * @type {number}
		 * @memberof TraceQueryResponse
		 */
		page: number;
		/**
		 * @description <p>The total number of matching traces.</p>
		 * @type {number}
		 * @memberof TraceQueryResponse
		 */
		matchesTotal: number;
	}

	export interface UnlicensedSubscription {
		/**
		 * Value for discriminator in Api.SubscriptionState
		 */
		_type: 'UnlicensedSubscription';
	
		reason: Api.UnlicensedSubscription.ReasonEnum;
	}
	
	/**
	 * @export
	 * @namespace UnlicensedSubscription
	 */
	export namespace UnlicensedSubscription {
		export enum TypeEnum {
			UnlicensedSubscription = 'UnlicensedSubscription'
		}
	
		export enum ReasonEnum {
			Missin = 'Missin',
			Invalid = 'Invalid'
		}
	
	}

	export interface UnmatchedCheckState {
		checkStateId: string;
		topologyElementIdentifier: string;
	}

	export interface UserNameMismatchError {
		/**
		 * Value for discriminator in Api.UserProfileSaveError
		 */
		_type: 'UserNameMismatchError';
	
		name: string;
	}
	
	/**
	 * @export
	 * @namespace UserNameMismatchError
	 */
	export namespace UserNameMismatchError {
		export enum TypeEnum {
			UserNameMismatchError = 'UserNameMismatchError'
		}
	
	}

	export interface UserNotFoundError {
		/**
		 * Value for discriminator in Api.UserProfileSaveError
		 */
		_type: 'UserNotFoundError';
	
		name: string;
	}
	
	/**
	 * @export
	 * @namespace UserNotFoundError
	 */
	export namespace UserNotFoundError {
		export enum TypeEnum {
			UserNotFoundError = 'UserNotFoundError'
		}
	
	}

	export interface UserNotLoggedInError {
		/**
		 * Value for discriminator in Api.UserProfileSaveError
		 */
		_type: 'UserNotLoggedInError';
	
	  // OpenAPI `type: object` without properties
	  [name: string]: unknown
	}
	
	/**
	 * @export
	 * @namespace UserNotLoggedInError
	 */
	export namespace UserNotLoggedInError {
		export enum TypeEnum {
			UserNotLoggedInError = 'UserNotLoggedInError'
		}
	
	}

	export interface UserProfile {
		/**
		 * @type {number}
		 * @memberof UserProfile
		 */
		readonly id?: number;
		/**
		 * @type {number}
		 * @memberof UserProfile
		 */
		readonly lastUpdateTimestamp?: number;
		name: string;
		displayName?: string;
		description?: string;
		identifier?: string;
		starredViews?: number[];
		starredDashboards?: number[];
		systemNotificationsRead: string[];
		hideUnavailableMonitors: boolean;
		hideUnavailableMetrics: boolean;
		hideUnavailableConnections: boolean;
		ownedBy?: string;
	}

	export type UserProfileSaveError = Api.UserNameMismatchError | Api.UserNotFoundError | Api.UserNotLoggedInError;

	export interface View {
		/**
		 * @type {number}
		 * @memberof View
		 */
		id: number;
		identifier?: string;
		name: string;
		viewType?: string;
		topologyQuery: string;
		groupingEnabled: boolean;
		groupedByLayers: boolean;
		groupedByDomains: boolean;
		groupedByRelations: boolean;
		/**
		 * @type {number}
		 * @memberof View
		 */
		minimumGroupSize: number;
		showIndirectRelations: boolean;
		autoGrouping: boolean;
		connectedComponents: boolean;
		neighboringComponents: boolean;
		flags: Api.QueryViewFlag[];
		ownedBy?: string;
	}

	export interface ViewCheckState {
		checkStateId: string;
		healthState: Api.HealthStateValue;
		componentName?: string;
		componentIdentifier: string;
		componentType?: string;
		/**
		 * @type {number}
		 * @memberof ViewCheckState
		 */
		lastUpdateTimestamp: number;
	}

	export interface ViewList {
		views: Api.View[];
	}

	export interface ViewNotFoundError {
		/**
		 * @description <p>A detailed error message describing why the operation failed.</p>
		 * @type {string}
		 * @memberof ViewNotFoundError
		 */
		message: string;
		viewIdOrIdentifier: string;
	}

	export interface ViewSnapshotRequest {
		/**
		 * @description <p>STQL query string</p>
		 * @type {string}
		 * @memberof ViewSnapshotRequest
		 */
		query: string;
		queryVersion: string;
		/**
		 * @description <p>Query execution settings</p>
		 * @type {Api.QueryMetadata}
		 * @memberof ViewSnapshotRequest
		 */
		metadata: Api.QueryMetadata;
		/**
		 * @description <p>View identifier that gets mapped back in the response. Preserved for compatibility when this API got moved to OpenAPI. Not used for any processing.</p>
		 * @type {number}
		 * @memberof ViewSnapshotRequest
		 */
		viewId?: number;
	}

	export interface WebhookChannelRefId {
		/**
		 * Value for discriminator in Api.ChannelReferenceId
		 */
		_type: 'WebhookChannelRefId';
	
		/**
		 * @type {number}
		 * @memberof WebhookChannelRefId
		 */
		id: number;
	}
	
	/**
	 * @export
	 * @namespace WebhookChannelRefId
	 */
	export namespace WebhookChannelRefId {
		export enum TypeEnum {
			WebhookChannelRefId = 'WebhookChannelRefId'
		}
	
	}

	export interface WebhookChannelWriteSchema {
		url: string;
		token: string;
		verifySsl: boolean;
		metadata: { [name: string]: string };
	}

	export interface WebhookNotificationChannel extends Api.BaseNotificationChannel, Api.WebhookChannelWriteSchema {
		/**
		 * Value for discriminator in Api.NotificationChannel
		 */
		_type: 'WebhookNotificationChannel';
	
	  // OpenAPI `type: object` without properties
	  [name: string]: unknown
	}
	
	/**
	 * @export
	 * @namespace WebhookNotificationChannel
	 */
	export namespace WebhookNotificationChannel {
		export enum TypeEnum {
			WebhookNotificationChannel = 'WebhookNotificationChannel'
		}
	
	}

}

export type AgentData = Api.AgentData

export import AgentLease = Api.AgentLease

export type AgentRegistration = Api.AgentRegistration

export type AgentRegistrations = Api.AgentRegistrations

export type ApiToken = Api.ApiToken

export import ApplicationDomain = Api.ApplicationDomain

export type Argument = Api.Argument

export type ArgumentBooleanVal = Api.ArgumentBooleanVal

export type ArgumentComparatorWithoutEqualityVal = Api.ArgumentComparatorWithoutEqualityVal

export type ArgumentComponentTypeRef = Api.ArgumentComponentTypeRef

export type ArgumentDoubleVal = Api.ArgumentDoubleVal

export type ArgumentDurationVal = Api.ArgumentDurationVal

export type ArgumentFailingHealthStateVal = Api.ArgumentFailingHealthStateVal

export type ArgumentLongVal = Api.ArgumentLongVal

export type ArgumentNodeIdVal = Api.ArgumentNodeIdVal

export type ArgumentPromQLMetricVal = Api.ArgumentPromQLMetricVal

export type ArgumentQueryViewRef = Api.ArgumentQueryViewRef

export type ArgumentRelationTypeRef = Api.ArgumentRelationTypeRef

export type ArgumentStateVal = Api.ArgumentStateVal

export type ArgumentStringVal = Api.ArgumentStringVal

export type ArgumentStructTypeVal = Api.ArgumentStructTypeVal

export type ArgumentTimeWindowVal = Api.ArgumentTimeWindowVal

export type ArgumentTopologyPromQLMetricVal = Api.ArgumentTopologyPromQLMetricVal

export type ArgumentTopologyQueryVal = Api.ArgumentTopologyQueryVal

export type BarChart = Api.BarChart

export type BaseComponentField = Api.BaseComponentField

export type BaseMonitorError = Api.BaseMonitorError

export type BaseNotificationChannel = Api.BaseNotificationChannel

export type BoundMetric = Api.BoundMetric

export type BoundMetricBindingId = Api.BoundMetricBindingId

export type BoundMetricId = Api.BoundMetricId

export type BoundMetricQuery = Api.BoundMetricQuery

export type BoundPresentationMetricId = Api.BoundPresentationMetricId

export type BoundSummaryMetric = Api.BoundSummaryMetric

export type BoundTraces = Api.BoundTraces

export type CausingEventsAreNotAvailableForTheTime = Api.CausingEventsAreNotAvailableForTheTime

export type CausingEventsResult = Api.CausingEventsResult

export type CellValue = Api.CellValue

export type ChannelReferenceId = Api.ChannelReferenceId

export type Chart = Api.Chart

export import ChartCalculation = Api.ChartCalculation

export type ChartStatThresholds = Api.ChartStatThresholds

export type ChartThresholds = Api.ChartThresholds

export type ChartThresholdStep = Api.ChartThresholdStep

export type CheckLeaseRequest = Api.CheckLeaseRequest

export import ComparatorWithoutEquality = Api.ComparatorWithoutEquality

export type ComponentAction = Api.ComponentAction

export type ComponentCheckState = Api.ComponentCheckState

export type ComponentCheckStates = Api.ComponentCheckStates

export type ComponentData = Api.ComponentData

export type ComponentEvents = Api.ComponentEvents

/**
 * <p>Display type and value for the field.</p>
 */
export type ComponentField = Api.ComponentField

export type ComponentHealthChange = Api.ComponentHealthChange

export type ComponentHealthHistory = Api.ComponentHealthHistory

/**
 * <p>Display type and value for the field.</p>
 */
export type ComponentHighlightProjection = Api.ComponentHighlightProjection

export type ComponentLink = Api.ComponentLink

export type ComponentLinkCell = Api.ComponentLinkCell

export type ComponentLinkField = Api.ComponentLinkField

export type ComponentLinkMetaDisplay = Api.ComponentLinkMetaDisplay

export type ComponentLinkProjection = Api.ComponentLinkProjection

export type ComponentMetricSection = Api.ComponentMetricSection

export type ComponentMetricTab = Api.ComponentMetricTab

/**
 * <p>Display type and value for the field.</p>
 */
export type ComponentOverviewProjection = Api.ComponentOverviewProjection

export type ComponentPresentation = Api.ComponentPresentation

export type ComponentPresentationApiError = Api.ComponentPresentationApiError

/**
 * <p>Filter definition for ComponentPresentation.
 * When only <code>filterId</code> is provided, the filter references a definition from a less specific presentation.
 * Merge semantics for matching ComponentPresentations:</p>
 * <ol>
 * <li>The most specific matching ComponentPresentation&#39;s filter list determines which <code>filterId</code>s are active.
 * Only filters whose <code>filterId</code> appears in that list are rendered.</li>
 * <li>For each active <code>filterId</code>, scalar fields (<code>displayName</code>, <code>menuSection</code>, <code>filter</code>, etc.) are resolved by
 * falling back through less specific presentations that define the same <code>filterId</code>, most specific value wins.</li>
 * <li>Array position determines display order: earlier items are primary (filter bar),
 * later items are secondary (&quot;More&quot; section).</li>
 * </ol>
 */
export type ComponentPresentationFilter = Api.ComponentPresentationFilter

export type ComponentPresentationFilterDefinition = Api.ComponentPresentationFilterDefinition

/**
 * <p>A resolved link definition returned in the FullComponent response.</p>
 */
export type ComponentPresentationLink = Api.ComponentPresentationLink

export type ComponentPresentationMetric = Api.ComponentPresentationMetric

export type ComponentPresentationQueryBinding = Api.ComponentPresentationQueryBinding

export type ComponentPresentationRank = Api.ComponentPresentationRank

export type ComponentProvisioning = Api.ComponentProvisioning

export type ComponentQuery = Api.ComponentQuery

export type ComponentSummary = Api.ComponentSummary

export type ComponentViewArguments = Api.ComponentViewArguments

/**
 * <p>Helps rendering links for docker images</p>
 */
export type ContainerImageProjection = Api.ContainerImageProjection

/**
 * <p>Request body for creating a silencing rule</p>
 */
export type CreateSilencingRule = Api.CreateSilencingRule

export type CreateSubject = Api.CreateSubject

export type DashboardAuthorizationError = Api.DashboardAuthorizationError

export type DashboardClientErrors = Api.DashboardClientErrors

/**
 * <p>The provided fields are used to override the corresponding fields of the new (cloned) dashboard.</p>
 */
export type DashboardCloneSchema = Api.DashboardCloneSchema

export type DashboardInvalidIdentifierError = Api.DashboardInvalidIdentifierError

export type DashboardList = Api.DashboardList

export type DashboardNotFoundError = Api.DashboardNotFoundError

/**
 * <p>The provided fields are used to patch the corresponding fields of a dashboard.</p>
 */
export type DashboardPatchSchema = Api.DashboardPatchSchema

export type DashboardReadBaseSchema = Api.DashboardReadBaseSchema

export type DashboardReadFullSchema = Api.DashboardReadFullSchema

export type DashboardReadMetadataSchema = Api.DashboardReadMetadataSchema

export type DashboardReadSchema = Api.DashboardReadSchema

/**
 * <p>Scope of the dashboard. &#39;publicDashboard&#39; for accessible by everyone, &#39;privateDashboard&#39; for owned and accessible by the current user.</p>
 */
export import DashboardScope = Api.DashboardScope

export type DashboardValidationError = Api.DashboardValidationError

export type DashboardWriteSchema = Api.DashboardWriteSchema

export type DataUnavailable = Api.DataUnavailable

export type DeleteVersionsResult = Api.DeleteVersionsResult

export import DependencyDirection = Api.DependencyDirection

export type DurationCell = Api.DurationCell

export type DurationField = Api.DurationField

export type DurationHistogram = Api.DurationHistogram

export type DurationHistogramBucket = Api.DurationHistogramBucket

export type DurationMetaDisplay = Api.DurationMetaDisplay

export type DurationProjection = Api.DurationProjection

export type DurationQuantiles = Api.DurationQuantiles

export type EmailChannelRefId = Api.EmailChannelRefId

export type EmailChannelWriteSchema = Api.EmailChannelWriteSchema

export type EmailNotificationChannel = Api.EmailNotificationChannel

export type EmailNotificationStatus = Api.EmailNotificationStatus

export type ErrorComponentPresentationLink = Api.ErrorComponentPresentationLink

export type ErrorField = Api.ErrorField

export type EventBucket = Api.EventBucket

export import EventCategory = Api.EventCategory

export type EventCategoryBucket = Api.EventCategoryBucket

export type EventComponent = Api.EventComponent

export type EventCursor = Api.EventCursor

export type EventElement = Api.EventElement

export type EventFilters = Api.EventFilters

export type EventItemsWithTotal = Api.EventItemsWithTotal

export type EventListRequest = Api.EventListRequest

export type EventNotFoundError = Api.EventNotFoundError

export type EventRelation = Api.EventRelation

export type EventsHistogram = Api.EventsHistogram

export type EventsHistogramRequest = Api.EventsHistogramRequest

export type EventsPerspective = Api.EventsPerspective

export type EventTag = Api.EventTag

export type ExecuteScriptArgumentsScriptError = Api.ExecuteScriptArgumentsScriptError

export type ExecuteScriptError = Api.ExecuteScriptError

export type ExecuteScriptExceptionError = Api.ExecuteScriptExceptionError

export type ExecuteScriptExecutionError = Api.ExecuteScriptExecutionError

export type ExecuteScriptGroovyRuntimeError = Api.ExecuteScriptGroovyRuntimeError

export type ExecuteScriptRequest = Api.ExecuteScriptRequest

export type ExecuteScriptResponse = Api.ExecuteScriptResponse

export type ExecuteScriptSecurityError = Api.ExecuteScriptSecurityError

export type ExecuteScriptSyntaxErrors = Api.ExecuteScriptSyntaxErrors

export type ExecuteScriptTimeoutError = Api.ExecuteScriptTimeoutError

export type ExecuteScriptWrongReturnTypeError = Api.ExecuteScriptWrongReturnTypeError

export type ExpiredSubscription = Api.ExpiredSubscription

export type Export = Api.Export

export type ExternalComponent = Api.ExternalComponent

export type ExternalMonitorDefId = Api.ExternalMonitorDefId

export type ExternalRelation = Api.ExternalRelation

export import FailingHealthStateValue = Api.FailingHealthStateValue

export type FAQ = Api.FAQ

export type FilterName = Api.FilterName

export type FullComponent = Api.FullComponent

export type FullRelation = Api.FullRelation

export type FullStackPack = Api.FullStackPack

export type GaugeChart = Api.GaugeChart

export type GenericApiError = Api.GenericApiError

export type GenericErrorsResponse = Api.GenericErrorsResponse

export type GetCausingEventsBadRequest = Api.GetCausingEventsBadRequest

export type GetCausingEventsNotFound = Api.GetCausingEventsNotFound

export type GetCausingEventsResult = Api.GetCausingEventsResult

export type GetCausingEventsServiceUnaivailable = Api.GetCausingEventsServiceUnaivailable

export type GetKubernetesLogsAutocompleteBadRequest = Api.GetKubernetesLogsAutocompleteBadRequest

export type GetKubernetesLogsAutocompleteInvalidTimeRange = Api.GetKubernetesLogsAutocompleteInvalidTimeRange

export type GetKubernetesLogsAutocompleteResult = Api.GetKubernetesLogsAutocompleteResult

export type GetKubernetesLogsBadRequest = Api.GetKubernetesLogsBadRequest

export type GetKubernetesLogsHistogramBadRequest = Api.GetKubernetesLogsHistogramBadRequest

export type GetKubernetesLogsHistogramInvalidQuery = Api.GetKubernetesLogsHistogramInvalidQuery

export type GetKubernetesLogsHistogramInvalidTimeRange = Api.GetKubernetesLogsHistogramInvalidTimeRange

export type GetKubernetesLogsHistogramResult = Api.GetKubernetesLogsHistogramResult

export type GetKubernetesLogsInvalidPagination = Api.GetKubernetesLogsInvalidPagination

export type GetKubernetesLogsInvalidQuery = Api.GetKubernetesLogsInvalidQuery

export type GetKubernetesLogsInvalidTimeRange = Api.GetKubernetesLogsInvalidTimeRange

export type GetKubernetesLogsResult = Api.GetKubernetesLogsResult

export type GetTopologyTimeout = Api.GetTopologyTimeout

export type GrantPermission = Api.GrantPermission

export type HealthCell = Api.HealthCell

export type HealthField = Api.HealthField

export type HealthMetaDisplay = Api.HealthMetaDisplay

export type HealthProjection = Api.HealthProjection

export import HealthStateValue = Api.HealthStateValue

export type HealthStreamError = Api.HealthStreamError

export type HealthStreamMetrics = Api.HealthStreamMetrics

export type HealthStreamNotFound = Api.HealthStreamNotFound

export type HealthStreamStatus = Api.HealthStreamStatus

export type HealthSubStreamConsistencyState = Api.HealthSubStreamConsistencyState

export type HealthSubStreamError = Api.HealthSubStreamError

export type HealthSubStreamExpiry = Api.HealthSubStreamExpiry

export type HealthSubStreamNotFound = Api.HealthSubStreamNotFound

export type HealthSubStreamSnapshot = Api.HealthSubStreamSnapshot

export type HealthSubStreamStatus = Api.HealthSubStreamStatus

export type HealthSubStreamTransactionalIncrements = Api.HealthSubStreamTransactionalIncrements

export import IdentifierType = Api.IdentifierType

export type ImportSettings200Response = Api.ImportSettings200Response

export import ImportSettingsLockedEnum = Api.ImportSettingsLockedEnum

export import ImportSettingsUnlockedEnum = Api.ImportSettingsUnlockedEnum

/**
 * <p>A custom representation for a date/time that needs better than milliseconds precision. Simply using nanoseconds since epoch results in integers that are too big to be represented correctly in Javascript (which is limited to 2^53-1). Instead this uses the standard representation of milliseconds since epoch with a nanosecond offset. Calculate nanoseconds since epoch like this <code>nanosSinceEpoch = timestamp * 1000000 + offsetNanos</code>.</p>
 */
export type InstantNanoPrecision = Api.InstantNanoPrecision

export type InvalidMonitorIdentifierError = Api.InvalidMonitorIdentifierError

export type InvalidNotificationConfigurationIdentifier = Api.InvalidNotificationConfigurationIdentifier

export type InvalidSyncIdentifier = Api.InvalidSyncIdentifier

export type InvalidUrn = Api.InvalidUrn

export type KubernetesLogHighlight = Api.KubernetesLogHighlight

export type KubernetesLogHistogramBucket = Api.KubernetesLogHistogramBucket

export type KubernetesLogRecord = Api.KubernetesLogRecord

export type KubernetesLogSeverityHistogramBucket = Api.KubernetesLogSeverityHistogramBucket

export type LegacyComponentHighlights = Api.LegacyComponentHighlights

export type LicensedSubscription = Api.LicensedSubscription

export type LimitOutOfRange = Api.LimitOutOfRange

export type LinkCell = Api.LinkCell

export type LinkField = Api.LinkField

export type LinkMetaDisplay = Api.LinkMetaDisplay

export type LockedResponse = Api.LockedResponse

export import LogLevel = Api.LogLevel

export import LogsDirection = Api.LogsDirection

export import LogSeverity = Api.LogSeverity

export type MainMenuGroup = Api.MainMenuGroup

export type MainMenuViewItem = Api.MainMenuViewItem

export type MapField = Api.MapField

export type MapProjection = Api.MapProjection

export type Message = Api.Message

export import MessageLevel = Api.MessageLevel

export type Messages = Api.Messages

export type MetricBucketValue = Api.MetricBucketValue

export type MetricBucketValue2 = Api.MetricBucketValue2

export type MetricBucketValue3 = Api.MetricBucketValue3

export type MetricCell = Api.MetricCell

export type MetricField = Api.MetricField

export type MetricMetaDisplay = Api.MetricMetaDisplay

export type MetricPerspectiveData = Api.MetricPerspectiveData

export type MetricProjection = Api.MetricProjection

export type Monitor = Api.Monitor

export type MonitorApiError = Api.MonitorApiError

export type MonitorCheckStates = Api.MonitorCheckStates

/**
 * <p>Selects a single monitor check state identified by monitor + checkStateId.</p>
 */
export type MonitorCheckStateSelector = Api.MonitorCheckStateSelector

export type MonitorCheckStatus = Api.MonitorCheckStatus

export type MonitorCheckStatusApiError = Api.MonitorCheckStatusApiError

export type MonitorCheckStatusComponent = Api.MonitorCheckStatusComponent

export type MonitorCheckStatusHealthChange = Api.MonitorCheckStatusHealthChange

export type MonitorCheckStatusHealthHistory = Api.MonitorCheckStatusHealthHistory

export type MonitorCheckStatusMetric = Api.MonitorCheckStatusMetric

export type MonitorCheckStatusNotFoundError = Api.MonitorCheckStatusNotFoundError

export type MonitorCheckStatusQuery = Api.MonitorCheckStatusQuery

export type MonitorCheckStatusRelatedFailures = Api.MonitorCheckStatusRelatedFailures

export type MonitorCheckStatusRelatedFailuresCheckStatus = Api.MonitorCheckStatusRelatedFailuresCheckStatus

export type MonitorCheckStatusRelatedFailuresTopology = Api.MonitorCheckStatusRelatedFailuresTopology

/**
 * <p>Configured silencing rule on this check state id.</p>
 */
export type MonitorCheckStatusSilencingRule = Api.MonitorCheckStatusSilencingRule

export type MonitorDefId = Api.MonitorDefId

export type MonitorDisplayQuery = Api.MonitorDisplayQuery

export type MonitorDisplayTimeSeries = Api.MonitorDisplayTimeSeries

export type MonitorError = Api.MonitorError

export type MonitorFunction = Api.MonitorFunction

export type MonitorFunctionNotFoundError = Api.MonitorFunctionNotFoundError

export type MonitorFunctionTest = Api.MonitorFunctionTest

export type MonitorHealthState = Api.MonitorHealthState

export type MonitorIdentifierLookup = Api.MonitorIdentifierLookup

export type MonitorIdentifierSuggestion = Api.MonitorIdentifierSuggestion

export type MonitorIdentifierSuggestions = Api.MonitorIdentifierSuggestions

export type MonitorInvalidIntervalError = Api.MonitorInvalidIntervalError

export type MonitorList = Api.MonitorList

export type MonitorMetrics = Api.MonitorMetrics

export type MonitorNotFoundError = Api.MonitorNotFoundError

export type MonitorOverview = Api.MonitorOverview

export type MonitorOverviewList = Api.MonitorOverviewList

export type MonitorPatch = Api.MonitorPatch

export type MonitorPreview = Api.MonitorPreview

export type MonitorPreviewComponentCount = Api.MonitorPreviewComponentCount

export type MonitorPreviewResult = Api.MonitorPreviewResult

export type MonitorReferenceId = Api.MonitorReferenceId

export type MonitorRunResult = Api.MonitorRunResult

export type MonitorRuntimeMetrics = Api.MonitorRuntimeMetrics

export import MonitorRuntimeStatusValue = Api.MonitorRuntimeStatusValue

export type MonitorSnapshot = Api.MonitorSnapshot

export type MonitorStatus = Api.MonitorStatus

/**
 * <p>If a monitor status is set to DISABLED it won&#39;t produce any health states but it can still be run manually to inspect it&#39;s output</p>
 */
export import MonitorStatusValue = Api.MonitorStatusValue

export type MonitorValidationError = Api.MonitorValidationError

export type MultipleMatchesCheckState = Api.MultipleMatchesCheckState

export type NewLicense = Api.NewLicense

export type NewServiceTokenRequest = Api.NewServiceTokenRequest

export type Node = Api.Node

export type NodeLocked = Api.NodeLocked

export type NodeName = Api.NodeName

export type NodeTypes = Api.NodeTypes

export type NodeUnlocked = Api.NodeUnlocked

export type NotificationChannel = Api.NotificationChannel

export type NotificationChannelError = Api.NotificationChannelError

export type NotificationChannelNotFound = Api.NotificationChannelNotFound

export type NotificationChannelStatus = Api.NotificationChannelStatus

export type NotificationChannelStatusError = Api.NotificationChannelStatusError

export type NotificationConfigurationByIdErrors = Api.NotificationConfigurationByIdErrors

export type NotificationConfigurationError = Api.NotificationConfigurationError

export type NotificationConfigurationNotFound = Api.NotificationConfigurationNotFound

export type NotificationConfigurationReadSchema = Api.NotificationConfigurationReadSchema

export import NotificationConfigurationRuntimeStatusValue = Api.NotificationConfigurationRuntimeStatusValue

export import NotificationConfigurationStatusValue = Api.NotificationConfigurationStatusValue

export type NotificationConfigurationWriteSchema = Api.NotificationConfigurationWriteSchema

export import NotifyOnOptions = Api.NotifyOnOptions

export type NumericCell = Api.NumericCell

export type NumericField = Api.NumericField

export type NumericMetaDisplay = Api.NumericMetaDisplay

export type NumericProjection = Api.NumericProjection

export type OpsgenieChannelRefId = Api.OpsgenieChannelRefId

export type OpsgenieChannelWriteSchema = Api.OpsgenieChannelWriteSchema

export type OpsgenieNotificationChannel = Api.OpsgenieNotificationChannel

export import OpsgeniePriority = Api.OpsgeniePriority

export import OpsgenieRegion = Api.OpsgenieRegion

export type OpsgenieResponder = Api.OpsgenieResponder

export import OpsgenieResponderType = Api.OpsgenieResponderType

export type OrderedComponentPresentationMetric = Api.OrderedComponentPresentationMetric

export type OtelComponentMapping = Api.OtelComponentMapping

export type OtelComponentMappingFieldMapping = Api.OtelComponentMappingFieldMapping

export type OtelComponentMappingOutput = Api.OtelComponentMappingOutput

export type OtelComponentMappingRank = Api.OtelComponentMappingRank

export type OtelComponentMappingUpsertRequest = Api.OtelComponentMappingUpsertRequest

/**
 * <p>Combines input signals and conditional resource/scope/metric/span mappings.</p>
 */
export type OtelInput = Api.OtelInput

/**
 * <p>Defines conditional mapping at the resource -&gt; scope -&gt; metric -&gt; datapoint level.
 * If omitted, <code>condition</code> defaults to <code>true</code> and <code>action</code> defaults to <code>CONTINUE</code>.</p>
 */
export type OtelInputDatapoint = Api.OtelInputDatapoint

/**
 * <p>Defines conditional mapping at the resource -&gt; scope -&gt; log level.
 * If omitted, <code>condition</code> defaults to <code>true</code> and <code>action</code> defaults to <code>CONTINUE</code>.</p>
 */
export type OtelInputLog = Api.OtelInputLog

/**
 * <p>Defines conditional mapping at the resource -&gt; scope -&gt; metric level.
 * If omitted, <code>condition</code> defaults to <code>true</code> and <code>action</code> defaults to <code>CONTINUE</code>.</p>
 */
export type OtelInputMetric = Api.OtelInputMetric

/**
 * <p>Defines the conditional mapping at the resource level.
 * If omitted, <code>condition</code> defaults to <code>true</code> and <code>action</code> defaults to <code>CONTINUE</code>.</p>
 */
export type OtelInputResource = Api.OtelInputResource

/**
 * <p>Defines conditional mapping at the resource -&gt; scope level.
 * If omitted, <code>condition</code> defaults to <code>true</code> and <code>action</code> defaults to <code>CONTINUE</code>.</p>
 */
export type OtelInputScope = Api.OtelInputScope

/**
 * <p>Signals exported by OpenTelemetry, which determine which data models and
 * attribute maps are available for expression evaluation in an OTel topology
 * mapping.</p>
 * <p>Each signal enables access to a specific set of fields and attribute maps
 * coming from the corresponding OTel data pipeline level.</p>
 * <p>Fields/attributes available per signal:</p>
 * <p>  • <strong>TRACES</strong>
 *   Provides access to:
 *     - <code>resource.attributes</code>
 *     - <code>scope.name</code>, <code>scope.version</code>, <code>scope.attributes</code>
 *     - <code>span.name</code>, <code>span.kind</code>, <code>span.statusMessage</code>, <code>span.statusCode</code>, <code>span.attributes</code></p>
 * <p>  • <strong>METRICS</strong>
 *   Provides access to:
 *     - <code>resource.attributes</code>
 *     - <code>scope.name</code>, <code>scope.version</code>, <code>scope.attributes</code>
 *     - <code>metric.name</code>, <code>metric.description</code>, <code>metric.unit</code>
 *     - <code>datapoint.attributes</code></p>
 * <p>  • <strong>LOGS</strong>
 *   Provides access to:
 *     - <code>resource.attributes</code>
 *     - <code>scope.name</code>, <code>scope.version</code>, <code>scope.attributes</code>
 *     - <code>log.eventName</code>, <code>log.attributes</code>, <code>log.body</code></p>
 * <p>For example, if the signal is <code>METRICS</code>, expressions may reference:
 * <code>resource.attributes[&quot;service.name&quot;]</code>, <code>scope.attributes[&quot;env&quot;]</code>,
 * <code>metric.name</code>, or <code>datapoint.attributes[&quot;status&quot;]</code>.</p>
 */
export import OtelInputSignal = Api.OtelInputSignal

/**
 * <p>Defines conditional mapping at the resource -&gt; scope -&gt; span level.
 * If omitted, <code>condition</code> defaults to <code>true</code> and <code>action</code> defaults to <code>CONTINUE</code>.</p>
 */
export type OtelInputSpan = Api.OtelInputSpan

export type OtelMappingApiError = Api.OtelMappingApiError

export type OtelMappingError = Api.OtelMappingError

export type OtelMappingItem = Api.OtelMappingItem

export type OtelMappingMetrics = Api.OtelMappingMetrics

export type OtelMappingStatus = Api.OtelMappingStatus

export type OtelMappingStatusItem = Api.OtelMappingStatusItem

export type OtelRelationMapping = Api.OtelRelationMapping

export type OtelRelationMappingOutput = Api.OtelRelationMappingOutput

export type OtelRelationmappingUpsertRequest = Api.OtelRelationmappingUpsertRequest

/**
 * <p>Defines how a tag should be mapped from an input source to an output target, optionally using a regex pattern.</p>
 */
export type OtelTagMapping = Api.OtelTagMapping

export type OtelVariableMapping = Api.OtelVariableMapping

/**
 * <p>Definition of a column in the overview presentation. The <code>columnId</code> field is used to identify the column and merge columns from different presentations. If only the <code>columnId</code> is provided, the column will be rendered from the next more specific presentation definition.</p>
 */
export type OverviewColumnDefinition = Api.OverviewColumnDefinition

export type OverviewColumnFilter = Api.OverviewColumnFilter

export type OverviewColumnMeta = Api.OverviewColumnMeta

export type OverviewColumnMetaDisplay = Api.OverviewColumnMetaDisplay

export type OverviewDataUnavailable = Api.OverviewDataUnavailable

export type OverviewErrorResponse = Api.OverviewErrorResponse

export type OverviewFetchTimeout = Api.OverviewFetchTimeout

export type OverviewFilters = Api.OverviewFilters

export type OverviewMetadata = Api.OverviewMetadata

export type OverviewPageResponse = Api.OverviewPageResponse

export type OverviewPageResult = Api.OverviewPageResult

export type OverviewPaginationCursor = Api.OverviewPaginationCursor

export import OverviewPaginationDirection = Api.OverviewPaginationDirection

export type OverviewPaginationRequest = Api.OverviewPaginationRequest

export type OverviewPerspective = Api.OverviewPerspective

export type OverviewRequest = Api.OverviewRequest

export type OverviewRow = Api.OverviewRow

export type OverviewSorting = Api.OverviewSorting

export import OverviewSortingDirection = Api.OverviewSortingDirection

export type OverviewTooManyActiveQueries = Api.OverviewTooManyActiveQueries

export type OverviewTopologySizeOverflow = Api.OverviewTopologySizeOverflow

export type PaginationResponse = Api.PaginationResponse

export type PermissionDescription = Api.PermissionDescription

export type Permissions = Api.Permissions

export type PersesDashboard = Api.PersesDashboard

export type PersesDashboardDisplaySpec = Api.PersesDashboardDisplaySpec

export type PersesDashboardSpec = Api.PersesDashboardSpec

export type PersesDatasourceSpec = Api.PersesDatasourceSpec

export type PersesGridItem = Api.PersesGridItem

export type PersesGridLayoutCollapse = Api.PersesGridLayoutCollapse

export type PersesGridLayoutDisplay = Api.PersesGridLayoutDisplay

export type PersesJSONRef = Api.PersesJSONRef

export type PersesLayout = Api.PersesLayout

/**
 * <p>Defines the layout type. Currently, only &#39;Grid&#39; is supported.</p>
 */
export import PersesLayoutKind = Api.PersesLayoutKind

export type PersesLayoutSpec = Api.PersesLayoutSpec

export type PersesLink = Api.PersesLink

export type PersesListVariable = Api.PersesListVariable

export type PersesListVariableDefaultSingleValue = Api.PersesListVariableDefaultSingleValue

export type PersesListVariableDefaultSliceValues = Api.PersesListVariableDefaultSliceValues

export type PersesListVariableDefaultValue = Api.PersesListVariableDefaultValue

export type PersesListVariableSpec = Api.PersesListVariableSpec

export type PersesPanel = Api.PersesPanel

export type PersesPanelDisplay = Api.PersesPanelDisplay

export type PersesPanelSpec = Api.PersesPanelSpec

export type PersesPlugin = Api.PersesPlugin

export type PersesProjectMetadata = Api.PersesProjectMetadata

export type PersesQuery = Api.PersesQuery

export type PersesQuerySpec = Api.PersesQuerySpec

export type PersesTextVariable = Api.PersesTextVariable

export type PersesTextVariableSpec = Api.PersesTextVariableSpec

export type PersesVariableDisplaySpec = Api.PersesVariableDisplaySpec

export import PersesVariableSort = Api.PersesVariableSort

export type PersesVariableTypes = Api.PersesVariableTypes

/**
 * <p>The set of perspectives the frontend needs to render a view page in one response.
 * Each optional field carries the per-perspective config; absence means
 * the perspective is not available for this view.</p>
 */
export type Perspectives = Api.Perspectives

export type PerspectivesApiError = Api.PerspectivesApiError

/**
 * <p>Component presentation definition.
 * If multiple ComponentPresentations match, <code>filters</code> are merged by filter identity with the most specific presentation winning.
 * Scalar fields like <code>icon</code> and <code>topology</code> follow most-specific-wins semantics across matching presentations.
 * Absence of <code>topology</code> means the Topology perspective is not available for this presentation.
 * Absence of the field keeps legacy behavior (for example, ViewType-based filters) unchanged.</p>
 */
export type PresentationDefinition = Api.PresentationDefinition

export type PresentationFilter = Api.PresentationFilter

export type PresentationFilterName = Api.PresentationFilterName

export type PresentationFiltersResponse = Api.PresentationFiltersResponse

/**
 * <p>Highlight presentation definition. The <code>fields</code> define the fields to show in the highlight page.
 * If multiple ComponentPresentations match, fields are merged by <code>fieldId</code> according to binding rank.
 * Related resources follow the same merge semantics using <code>resourceId</code> as the identity key.
 * Links follow the same merge semantics using <code>linkId</code> as the identity key.</p>
 */
export type PresentationHighlight = Api.PresentationHighlight

export type PresentationHighlightEvents = Api.PresentationHighlightEvents

/**
 * <p>Definition of a field in the highlight presentation. The <code>fieldId</code> field is used to identify the field and merge fields from different presentations.</p>
 */
export type PresentationHighlightField = Api.PresentationHighlightField

export type PresentationHighlightMetricsSection = Api.PresentationHighlightMetricsSection

/**
 * <p>Provisioning section of a component in the highlight presentation. The <code>topologySourceSelector</code> field is used to identify the external component with provisioning details for this component.</p>
 */
export type PresentationHighlightProvisioning = Api.PresentationHighlightProvisioning

/**
 * <p>Link definition for the highlight page. Each entry defines a navigation link shown for a component.
 * Merge semantics follow related resource rules:</p>
 * <ul>
 * <li>All presentations whose binding matches the component contribute links.</li>
 * <li>Same linkId with higher specificity wins (override).</li>
 * <li>Different linkId entries are appended.</li>
 * <li>Display order is determined by the order field.
 * CEL expressions are evaluated against the component presentation context. The filter is evaluated first;
 * if it evaluates to false the link is omitted. If the filter includes the link but required data cannot be
 * evaluated, the resolved highlight response reports an error link.</li>
 * </ul>
 */
export type PresentationLink = Api.PresentationLink

export type PresentationMainMenu = Api.PresentationMainMenu

export type PresentationMetricPerspective = Api.PresentationMetricPerspective

export type PresentationMetricPerspectiveSection = Api.PresentationMetricPerspectiveSection

export type PresentationMetricPerspectiveTab = Api.PresentationMetricPerspectiveTab

export type PresentationMetricQuery = Api.PresentationMetricQuery

export type PresentationName = Api.PresentationName

/**
 * <p>Overview presentation definition. The <code>columns</code> field defines the columns to show in the overview table. The <code>flags</code> field can be used to enable/disable functionalities.
 * If multiple ComponentPresentations match, columns are merged by <code>columnId</code> according to binding rank. Absence of the field means no overview is shown.</p>
 */
export type PresentationOverview = Api.PresentationOverview

export type PresentationOverviewSorting = Api.PresentationOverviewSorting

export import PresentationOverviewSortingDirection = Api.PresentationOverviewSortingDirection

/**
 * <p>Related resource definition for the highlight page. Each entry defines a section showing components
 * related to the one being viewed, rendered using the referenced presentation&#39;s overview spec.
 * Merge semantics follow highlight field rules:</p>
 * <ul>
 * <li>All presentations whose binding matches the component contribute related resources.</li>
 * <li>Same resourceId with higher specificity wins (override).</li>
 * <li>Different resourceId entries are appended.</li>
 * <li>Display order is determined by the order field.</li>
 * </ul>
 */
export type PresentationRelatedResource = Api.PresentationRelatedResource

/**
 * <p>Selects the spans shown in the Traces perspective for a component.
 * String-valued fields are string templates: text is taken literally and any <code>${...}</code>
 * placeholder is evaluated as a CEL expression against the component, using the same context
 * as metric perspective queries. For example <code>orderService</code> is a literal, while
 * <code>${tags.singleValue(&#39;service.namespace&#39;)}</code> resolves the tag of that name. Note that <code>tags</code>
 * maps each key to a list of values, so use <code>singleValue</code> inside a placeholder when a single
 * string is required.
 * Enum- and duration-valued fields are literals and are not evaluated.
 * Resolution is best effort: a field whose expression fails to parse or evaluate is dropped
 * from the filter and logged, the remaining fields still apply.</p>
 */
export type PresentationSpanFilter = Api.PresentationSpanFilter

export type PresentationSummary = Api.PresentationSummary

export type PresentationSummaryMetric = Api.PresentationSummaryMetric

export type PresentationTagFilter = Api.PresentationTagFilter

/**
 * <p>Makes the Traces perspective available on components matched by this presentation.
 * Absence of the field means the Traces perspective is not shown.
 * Most-specific-wins merge semantics across matching ComponentPresentations: the whole
 * section is taken from the most specific presentation that defines it, it is not merged
 * field by field.</p>
 */
export type PresentationTracesPerspective = Api.PresentationTracesPerspective

export type ProblemNotFound = Api.ProblemNotFound

export type PromBatchEnvelope = Api.PromBatchEnvelope

export type PromBatchError = Api.PromBatchError

export type PromBatchInstantQuery = Api.PromBatchInstantQuery

export type PromBatchQueryItem = Api.PromBatchQueryItem

/**
 * <p>Executes multiple query items in one request. If both request-level timeout and item-level timeout are set, item-level timeout takes precedence.</p>
 */
export type PromBatchQueryRequest = Api.PromBatchQueryRequest

export type PromBatchRangeQuery = Api.PromBatchRangeQuery

export type PromBatchResult = Api.PromBatchResult

export type PromBatchSuccess = Api.PromBatchSuccess

export type PromData = Api.PromData

export type PromDataResult = Api.PromDataResult

export type PromDataString = Api.PromDataString

export type PromEnvelope = Api.PromEnvelope

export type PromExemplar = Api.PromExemplar

export type PromExemplarData = Api.PromExemplarData

export type PromExemplarEnvelope = Api.PromExemplarEnvelope

export type PromLabelsEnvelope = Api.PromLabelsEnvelope

export type PromLabelsRequest = Api.PromLabelsRequest

export type PromLabelValuesRequest = Api.PromLabelValuesRequest

export type PromMatrix = Api.PromMatrix

export type PromMetadataEnvelope = Api.PromMetadataEnvelope

export type PromMetadataRequest = Api.PromMetadataRequest

export type PromQLMetric = Api.PromQLMetric

export type PromQueryExemplarRequest = Api.PromQueryExemplarRequest

export type PromQueryRangeRequest = Api.PromQueryRangeRequest

export type PromQueryRequest = Api.PromQueryRequest

export type PromScalar = Api.PromScalar

export type PromSeriesEnvelope = Api.PromSeriesEnvelope

export type PromSeriesRequest = Api.PromSeriesRequest

export type PromVector = Api.PromVector

export type PromVectorResult = Api.PromVectorResult

export type ProvisionResponse = Api.ProvisionResponse

/**
 * <p>Query execution settings</p>
 */
export type QueryMetadata = Api.QueryMetadata

/**
 * <p>Query parsing failed. The reason field contains the error message.</p>
 */
export type QueryParsingFailure = Api.QueryParsingFailure

/**
 * <p>Query succeeded (or encountered a runtime error that&#39;s part of the result).
 * The SnapshotResponse uses existing DTO types for nested structures.</p>
 */
export type QuerySnapshotResult = Api.QuerySnapshotResult

export type QueryViewArguments = Api.QueryViewArguments

export import QueryViewFlag = Api.QueryViewFlag

export type RatioField = Api.RatioField

/**
 * <p>Helps rendering columns that summarize success rates</p>
 */
export type RatioProjection = Api.RatioProjection

export type ReadyStatusCell = Api.ReadyStatusCell

export type ReadyStatusMetaDisplay = Api.ReadyStatusMetaDisplay

/**
 * <p>A resolved related resource definition returned in the FullComponent response.
 * The backend merges related resources from all matching presentations, resolves template variables
 * in the stql field, and derives the name from the referenced presentation&#39;s PresentationName.
 * Array order in the response determines display order.</p>
 */
export type RelatedResource = Api.RelatedResource

export type RelationData = Api.RelationData

export import ReleaseStatus = Api.ReleaseStatus

export type RequestError = Api.RequestError

export type RequestValidationError = Api.RequestValidationError

export type ResolvedComponentPresentationLink = Api.ResolvedComponentPresentationLink

export type Role = Api.Role

export type RoleNotAvailableError = Api.RoleNotAvailableError

export type Roles = Api.Roles

export type ScriptLocation = Api.ScriptLocation

export type ServerInfo = Api.ServerInfo

export type ServerVersion = Api.ServerVersion

export type ServiceToken = Api.ServiceToken

export type ServiceTokenCreatedResponse = Api.ServiceTokenCreatedResponse

export type ServiceTokenCreateError = Api.ServiceTokenCreateError

export type ServiceTokenInvalidExpiryError = Api.ServiceTokenInvalidExpiryError

/**
 * <p>A silencing rule as returned by the API</p>
 */
export type SilencingRule = Api.SilencingRule

export type SilencingRuleApiError = Api.SilencingRuleApiError

export type SilencingRuleConflictError = Api.SilencingRuleConflictError

export type SilencingRuleList = Api.SilencingRuleList

export type SilencingRuleNotFoundError = Api.SilencingRuleNotFoundError

/**
 * <p>Selects what to silence. Discriminated by <code>type</code> to allow future selector variants.</p>
 */
export type SilencingRuleSelector = Api.SilencingRuleSelector

export type SlackChannel = Api.SlackChannel

export type SlackChannelId = Api.SlackChannelId

export type SlackChannelRefId = Api.SlackChannelRefId

export type SlackChannelsChunk = Api.SlackChannelsChunk

export type SlackNotificationChannel = Api.SlackNotificationChannel

export type SourceLink = Api.SourceLink

export type Span = Api.Span

export type SpanComponent = Api.SpanComponent

export type SpanComponents = Api.SpanComponents

/**
 * <p>Event is a time-stamped annotation of the span, consisting of user-supplied text description and key-value pairs.</p>
 */
export type SpanEvent = Api.SpanEvent

export type SpanFilter = Api.SpanFilter

export import SpanKind = Api.SpanKind

/**
 * <p>A pointer from the current span to another span in the same trace or in a different trace. 
 * For example, this can be used in batching operations, where a single batch handler processes 
 * multiple requests from different traces or when the handler receives a request from a different project.</p>
 */
export type SpanLink = Api.SpanLink

export import SpanParentType = Api.SpanParentType

/**
 * <p>The result of looking up a span. As an optimization to reduce duplication, resource attributes are inlined at the
 * root-level of the schema.</p>
 */
export type SpanResponse = Api.SpanResponse

export import SpanSortDirection = Api.SpanSortDirection

export import SpanSortField = Api.SpanSortField

export type SpanSortOption = Api.SpanSortOption

export import SpanStatusCode = Api.SpanStatusCode

export import SpanSuggestionField = Api.SpanSuggestionField

export type StackElementNotFound = Api.StackElementNotFound

export type StackPack = Api.StackPack

export type StackPackConfiguration = Api.StackPackConfiguration

export type StackPackError = Api.StackPackError

export type StackPackIntegration = Api.StackPackIntegration

export type StackPackStep = Api.StackPackStep

export type StackPackUpload = Api.StackPackUpload

export type StackPackVersionInfo = Api.StackPackVersionInfo

export type StatChart = Api.StatChart

export type StreamList = Api.StreamList

export type StreamListItem = Api.StreamListItem

export type StringItemsWithTotal = Api.StringItemsWithTotal

export type SubjectConfig = Api.SubjectConfig

export import SubjectSource = Api.SubjectSource

export type Subscription = Api.Subscription

export type SubscriptionState = Api.SubscriptionState

export type SubStreamList = Api.SubStreamList

export type SubStreamListItem = Api.SubStreamListItem

export type Suggestions = Api.Suggestions

export type SystemNotification = Api.SystemNotification

export type SystemNotifications = Api.SystemNotifications

export import SystemNotificationSeverity = Api.SystemNotificationSeverity

export type TagField = Api.TagField

/**
 * <p>Tag-based filter. Uses indexed tags via <code>tagKey</code>.</p>
 */
export type TagFilter = Api.TagFilter

export type TagProjection = Api.TagProjection

export type TeamsChannelRefId = Api.TeamsChannelRefId

export type TeamsChannelWriteSchema = Api.TeamsChannelWriteSchema

export type TeamsNotificationChannel = Api.TeamsNotificationChannel

export type TextCell = Api.TextCell

export type TextField = Api.TextField

export type TextMetaDisplay = Api.TextMetaDisplay

export type TextProjection = Api.TextProjection

export type TimelineSummary = Api.TimelineSummary

export type TimelineSummaryError = Api.TimelineSummaryError

export type TimelineSummaryEventBucket = Api.TimelineSummaryEventBucket

export type TimelineSummaryHealthChange = Api.TimelineSummaryHealthChange

export type TimelineSummaryOverflow = Api.TimelineSummaryOverflow

export type TimelineSummaryRequest = Api.TimelineSummaryRequest

export type TimeSeriesChart = Api.TimeSeriesChart

export type TooManyActiveQueries = Api.TooManyActiveQueries

export type TooManyTopologyResults = Api.TooManyTopologyResults

export type Topic = Api.Topic

export type TopologyEvent = Api.TopologyEvent

export type TopologyMatchResult = Api.TopologyMatchResult

export type TopologyOverflowError = Api.TopologyOverflowError

/**
 * <p>Topology perspective config. Reuses QueryMetadata from the snapshot API
 * as the rendering spec.</p>
 */
export type TopologyPerspective = Api.TopologyPerspective

export type TopologyPromQLMetric = Api.TopologyPromQLMetric

/**
 * <p>Rendering settings for the topology perspective.
 * Near-copy of QueryMetadata used for topology rendering today; differences:</p>
 * <ul>
 * <li><code>queryTime</code> is intentionally absent (request-time state, not a presentation setting).
 * Most-specific-wins merge semantics across matching ComponentPresentations.</li>
 * </ul>
 */
export type TopologySettings = Api.TopologySettings

export type TopologyStreamError = Api.TopologyStreamError

export type TopologyStreamList = Api.TopologyStreamList

export type TopologyStreamListItem = Api.TopologyStreamListItem

export type TopologyStreamListItemWithErrorDetails = Api.TopologyStreamListItemWithErrorDetails

export type TopologyStreamMetrics = Api.TopologyStreamMetrics

export type TopologySyncError = Api.TopologySyncError

export import TopologySyncStatus = Api.TopologySyncStatus

export type TopologyTimeOutOfRange = Api.TopologyTimeOutOfRange

export type Trace = Api.Trace

export type TraceApiError = Api.TraceApiError

export type TraceApiInvalidDurationFilter = Api.TraceApiInvalidDurationFilter

export type TraceApiInvalidPagination = Api.TraceApiInvalidPagination

export type TraceApiInvalidTimeRange = Api.TraceApiInvalidTimeRange

export type TraceApiSpanNotFound = Api.TraceApiSpanNotFound

export type TraceApiSpansBadRequest = Api.TraceApiSpansBadRequest

export type TraceApiTraceNotFound = Api.TraceApiTraceNotFound

/**
 * <p>Filter traces that have a span that matches the primary filter and a span that matches the secondary filter. These could be the same, or two different spans of the same trace.</p>
 */
export type TraceFilter = Api.TraceFilter

/**
 * <p>Find traces that have a span that matches the primary filter and a span that matches the secondary filter. These could be the same, or two different spans of the same trace.</p>
 */
export type TraceQuery = Api.TraceQuery

/**
 * <p>A trace that matched the query filters. It structurally matches the Trace schema, with extra fields representing 
 * the result of the trace query.</p>
 */
export type TraceQueryMatch = Api.TraceQueryMatch

export type TraceQueryResponse = Api.TraceQueryResponse

export type UnlicensedSubscription = Api.UnlicensedSubscription

export type UnmatchedCheckState = Api.UnmatchedCheckState

export type UserNameMismatchError = Api.UserNameMismatchError

export type UserNotFoundError = Api.UserNotFoundError

export type UserNotLoggedInError = Api.UserNotLoggedInError

export type UserProfile = Api.UserProfile

export type UserProfileSaveError = Api.UserProfileSaveError

export type View = Api.View

export type ViewCheckState = Api.ViewCheckState

export type ViewList = Api.ViewList

export type ViewNotFoundError = Api.ViewNotFoundError

export type ViewSnapshotRequest = Api.ViewSnapshotRequest

export type WebhookChannelRefId = Api.WebhookChannelRefId

export type WebhookChannelWriteSchema = Api.WebhookChannelWriteSchema

export type WebhookNotificationChannel = Api.WebhookNotificationChannel

